import { FormattedMessage as Ge, useIntl as Pt } from "react-intl";
import * as d from "react";
import ee, { useState as $t, useEffect as Sn, startTransition as yr, forwardRef as fs, createElement as ln, createContext as Zl, useContext as Ul, useLayoutEffect as Kl, useMemo as Yl } from "react";
import * as En from "react-dom";
import ps from "react-dom";
var Un, Sr;
function Xl() {
  if (Sr) return Un;
  Sr = 1;
  const e = Object.freeze({
    EN: "en-US",
    CS: "cs-CZ",
    DE: "de-DE",
    PL: "pl-PL",
    ES: "es-ES",
    RU: "ru-RU"
  }), t = Object.entries(e).reduce((o, [r, a]) => (o[r] = a.split("-")[0], o), {}), n = t.EN;
  return Un = {
    locales: e,
    languages: t,
    defaultLocale: n
  }, Un;
}
var Ct = Xl();
const ql = {}, Jl = {}, Ql = {}, ec = {}, tc = {}, nc = {};
Ct.languages.EN + "", Ct.languages.CS + "", Ct.languages.DE + "", Ct.languages.PL + "", Ct.languages.ES + "", Ct.languages.RU + "";
const oc = {
  sm: "--breakpoint-sm",
  md: "--breakpoint-md",
  lg: "--breakpoint-lg",
  xl: "--breakpoint-xl",
  "2xl": "--breakpoint-2xl",
  "3xl": "--breakpoint-3xl",
  "4xl": "--breakpoint-4xl"
};
function ms(e) {
  return parseInt(window.getComputedStyle(document.body).getPropertyValue(oc[e]));
}
function Kn(e) {
  return typeof window > "u" ? !1 : window.innerWidth < ms(e);
}
function hs(e, { resolveOnFirstRender: t = !1 } = {}) {
  const [n, o] = $t(() => t ? Kn(e) : !1);
  return Sn(() => {
    const r = window.matchMedia(`(max-width: ${ms(e) - 1}px)`), a = () => yr(() => o(Kn(e)));
    return r.addEventListener("change", a), yr(() => o(Kn(e))), () => r.removeEventListener("change", a);
  }, [e]), n;
}
const rc = () => {
  const [e, t] = $t(!1);
  return Sn(() => {
    const n = () => {
      t(window.scrollY > 0);
    };
    return window.addEventListener("scroll", n), () => {
      window.removeEventListener("scroll", n);
    };
  }, []), e;
};
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
var sc = {
  outline: {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  },
  filled: {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "none"
  }
};
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const de = (e, t, n, o) => {
  const r = fs(
    ({ color: a = "currentColor", size: i = 24, stroke: l = 2, title: c, className: u, children: f, ...m }, g) => ln(
      "svg",
      {
        ref: g,
        ...sc[e],
        width: i,
        height: i,
        className: ["tabler-icon", `tabler-icon-${t}`, u].join(" "),
        ...e === "filled" ? {
          fill: a
        } : {
          strokeWidth: l,
          stroke: a
        },
        ...m
      },
      [
        c && ln("title", { key: "svg-title" }, c),
        ...o.map(([x, b]) => ln(x, b)),
        ...Array.isArray(f) ? f : [f]
      ]
    )
  );
  return r.displayName = `${n}`, r;
};
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ac = [["path", { d: "M12 9v4", key: "svg-0" }], ["path", { d: "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0", key: "svg-1" }], ["path", { d: "M12 16h.01", key: "svg-2" }]], f4 = de("outline", "alert-triangle", "AlertTriangle", ac);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ic = [["path", { d: "M5 12l14 0", key: "svg-0" }], ["path", { d: "M13 18l6 -6", key: "svg-1" }], ["path", { d: "M13 6l6 6", key: "svg-2" }]], gs = de("outline", "arrow-right", "ArrowRight", ic);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lc = [["path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }], ["path", { d: "M5.7 5.7l12.6 12.6", key: "svg-1" }]], p4 = de("outline", "ban", "Ban", lc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cc = [["path", { d: "M5 12l5 5l10 -10", key: "svg-0" }]], dc = de("outline", "check", "Check", cc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uc = [["path", { d: "M6 9l6 6l6 -6", key: "svg-0" }]], tt = de("outline", "chevron-down", "ChevronDown", uc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fc = [["path", { d: "M6 15l6 -6l6 6", key: "svg-0" }]], pc = de("outline", "chevron-up", "ChevronUp", fc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mc = [["path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }], ["path", { d: "M9 12l2 2l4 -4", key: "svg-1" }]], m4 = de("outline", "circle-check", "CircleCheck", mc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hc = [["path", { d: "M7 9.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667l0 -8.666", key: "svg-0" }], ["path", { d: "M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1", key: "svg-1" }]], h4 = de("outline", "copy", "Copy", hc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gc = [["path", { d: "M16.7 8a3 3 0 0 0 -2.7 -2h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1 -2.7 -2", key: "svg-0" }], ["path", { d: "M12 3v3m0 12v3", key: "svg-1" }]], vc = de("outline", "currency-dollar", "CurrencyDollar", gc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xc = [["path", { d: "M17.2 7a6 7 0 1 0 0 10", key: "svg-0" }], ["path", { d: "M13 10h-8m0 4h8", key: "svg-1" }]], Cc = de("outline", "currency-euro", "CurrencyEuro", xc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bc = [["path", { d: "M10.585 10.587a2 2 0 0 0 2.829 2.828", key: "svg-0" }], ["path", { d: "M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87", key: "svg-1" }], ["path", { d: "M3 3l18 18", key: "svg-2" }]], g4 = de("outline", "eye-off", "EyeOff", bc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wc = [["path", { d: "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", key: "svg-0" }], ["path", { d: "M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6", key: "svg-1" }]], v4 = de("outline", "eye", "Eye", wc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yc = [["path", { d: "M14 3v4a1 1 0 0 0 1 1h4", key: "svg-0" }], ["path", { d: "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", key: "svg-1" }], ["path", { d: "M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6", key: "svg-2" }], ["path", { d: "M17 18h2", key: "svg-3" }], ["path", { d: "M20 15h-3v6", key: "svg-4" }], ["path", { d: "M11 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1", key: "svg-5" }]], x4 = de("outline", "file-type-pdf", "FileTypePdf", yc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sc = [["path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }], ["path", { d: "M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-1" }], ["path", { d: "M13.41 10.59l2.59 -2.59", key: "svg-2" }], ["path", { d: "M7 12a5 5 0 0 1 5 -5", key: "svg-3" }]], C4 = de("outline", "gauge", "Gauge", Sc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ec = [["path", { d: "M14 15.5a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0", key: "svg-0" }], ["path", { d: "M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5", key: "svg-1" }], ["path", { d: "M3 13h7", key: "svg-2" }], ["path", { d: "M21 12v7", key: "svg-3" }]], b4 = de("outline", "letter-case", "LetterCase", Ec);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rc = [["path", { d: "M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6", key: "svg-0" }], ["path", { d: "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", key: "svg-1" }], ["path", { d: "M8 11v-4a4 4 0 1 1 8 0v4", key: "svg-2" }]], w4 = de("outline", "lock", "Lock", Rc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mc = [["path", { d: "M4 6h16", key: "svg-0" }], ["path", { d: "M7 12h13", key: "svg-1" }], ["path", { d: "M10 18h10", key: "svg-2" }]], jc = de("outline", "menu-deep", "MenuDeep", Mc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pc = [["path", { d: "M12 10v4", key: "svg-0" }], ["path", { d: "M10 13l4 -2", key: "svg-1" }], ["path", { d: "M10 11l4 2", key: "svg-2" }], ["path", { d: "M5 10v4", key: "svg-3" }], ["path", { d: "M3 13l4 -2", key: "svg-4" }], ["path", { d: "M3 11l4 2", key: "svg-5" }], ["path", { d: "M19 10v4", key: "svg-6" }], ["path", { d: "M17 13l4 -2", key: "svg-7" }], ["path", { d: "M17 11l4 2", key: "svg-8" }]], y4 = de("outline", "password", "Password", Pc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nc = [["path", { d: "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4", key: "svg-0" }], ["path", { d: "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4", key: "svg-1" }]], S4 = de("outline", "refresh", "Refresh", Nc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _c = [["path", { d: "M12 21a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3c.539 1.832 .627 3.747 .283 5.588", key: "svg-0" }], ["path", { d: "M15 18a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }], ["path", { d: "M20.2 20.2l1.8 1.8", key: "svg-2" }]], E4 = de("outline", "shield-search", "ShieldSearch", _c);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kc = [["path", { d: "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", key: "svg-0" }], ["path", { d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2", key: "svg-1" }]], Ac = de("outline", "user", "User", kc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tc = [["path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", key: "svg-0" }], ["path", { d: "M3.6 9h16.8", key: "svg-1" }], ["path", { d: "M3.6 15h16.8", key: "svg-2" }], ["path", { d: "M11.5 3a17 17 0 0 0 0 18", key: "svg-3" }], ["path", { d: "M12.5 3a17 17 0 0 1 0 18", key: "svg-4" }]], vs = de("outline", "world", "World", Tc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ic = [["path", { d: "M18 6l-12 12", key: "svg-0" }], ["path", { d: "M6 6l12 12", key: "svg-1" }]], Oc = de("outline", "x", "X", Ic);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lc = [["path", { d: "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", key: "svg-0" }]], R4 = de("filled", "info-circle-filled", "InfoCircleFilled", Lc);
var Yt = { exports: {} }, It = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Er;
function Dc() {
  if (Er) return It;
  Er = 1;
  var e = ee, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(l, c, u) {
    var f, m = {}, g = null, x = null;
    u !== void 0 && (g = "" + u), c.key !== void 0 && (g = "" + c.key), c.ref !== void 0 && (x = c.ref);
    for (f in c) o.call(c, f) && !a.hasOwnProperty(f) && (m[f] = c[f]);
    if (l && l.defaultProps) for (f in c = l.defaultProps, c) m[f] === void 0 && (m[f] = c[f]);
    return { $$typeof: t, type: l, key: g, ref: x, props: m, _owner: r.current };
  }
  return It.Fragment = n, It.jsx = i, It.jsxs = i, It;
}
var Ot = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rr;
function Fc() {
  return Rr || (Rr = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = ee, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), x = Symbol.for("react.offscreen"), b = Symbol.iterator, p = "@@iterator";
    function v(h) {
      if (h === null || typeof h != "object")
        return null;
      var N = b && h[b] || h[p];
      return typeof N == "function" ? N : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(h) {
      {
        for (var N = arguments.length, k = new Array(N > 1 ? N - 1 : 0), H = 1; H < N; H++)
          k[H - 1] = arguments[H];
        y("error", h, k);
      }
    }
    function y(h, N, k) {
      {
        var H = w.ReactDebugCurrentFrame, oe = H.getStackAddendum();
        oe !== "" && (N += "%s", k = k.concat([oe]));
        var re = k.map(function(J) {
          return String(J);
        });
        re.unshift("Warning: " + N), Function.prototype.apply.call(console[h], console, re);
      }
    }
    var S = !1, E = !1, M = !1, j = !1, R = !1, _;
    _ = Symbol.for("react.module.reference");
    function L(h) {
      return !!(typeof h == "string" || typeof h == "function" || h === o || h === a || R || h === r || h === u || h === f || j || h === x || S || E || M || typeof h == "object" && h !== null && (h.$$typeof === g || h.$$typeof === m || h.$$typeof === i || h.$$typeof === l || h.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      h.$$typeof === _ || h.getModuleId !== void 0));
    }
    function B(h, N, k) {
      var H = h.displayName;
      if (H)
        return H;
      var oe = N.displayName || N.name || "";
      return oe !== "" ? k + "(" + oe + ")" : k;
    }
    function X(h) {
      return h.displayName || "Context";
    }
    function $(h) {
      if (h == null)
        return null;
      if (typeof h.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof h == "function")
        return h.displayName || h.name || null;
      if (typeof h == "string")
        return h;
      switch (h) {
        case o:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case r:
          return "StrictMode";
        case u:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case l:
            var N = h;
            return X(N) + ".Consumer";
          case i:
            var k = h;
            return X(k._context) + ".Provider";
          case c:
            return B(h, h.render, "ForwardRef");
          case m:
            var H = h.displayName || null;
            return H !== null ? H : $(h.type) || "Memo";
          case g: {
            var oe = h, re = oe._payload, J = oe._init;
            try {
              return $(J(re));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, G = 0, D, Z, P, te, fe, ge, Re;
    function le() {
    }
    le.__reactDisabledLog = !0;
    function ce() {
      {
        if (G === 0) {
          D = console.log, Z = console.info, P = console.warn, te = console.error, fe = console.group, ge = console.groupCollapsed, Re = console.groupEnd;
          var h = {
            configurable: !0,
            enumerable: !0,
            value: le,
            writable: !0
          };
          Object.defineProperties(console, {
            info: h,
            log: h,
            warn: h,
            error: h,
            group: h,
            groupCollapsed: h,
            groupEnd: h
          });
        }
        G++;
      }
    }
    function Se() {
      {
        if (G--, G === 0) {
          var h = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, h, {
              value: D
            }),
            info: z({}, h, {
              value: Z
            }),
            warn: z({}, h, {
              value: P
            }),
            error: z({}, h, {
              value: te
            }),
            group: z({}, h, {
              value: fe
            }),
            groupCollapsed: z({}, h, {
              value: ge
            }),
            groupEnd: z({}, h, {
              value: Re
            })
          });
        }
        G < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var be = w.ReactCurrentDispatcher, A;
    function Q(h, N, k) {
      {
        if (A === void 0)
          try {
            throw Error();
          } catch (oe) {
            var H = oe.stack.trim().match(/\n( *(at )?)/);
            A = H && H[1] || "";
          }
        return `
` + A + h;
      }
    }
    var ae = !1, U;
    {
      var q = typeof WeakMap == "function" ? WeakMap : Map;
      U = new q();
    }
    function K(h, N) {
      if (!h || ae)
        return "";
      {
        var k = U.get(h);
        if (k !== void 0)
          return k;
      }
      var H;
      ae = !0;
      var oe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var re;
      re = be.current, be.current = null, ce();
      try {
        if (N) {
          var J = function() {
            throw Error();
          };
          if (Object.defineProperty(J.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(J, []);
            } catch (we) {
              H = we;
            }
            Reflect.construct(h, [], J);
          } else {
            try {
              J.call();
            } catch (we) {
              H = we;
            }
            h.call(J.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (we) {
            H = we;
          }
          h();
        }
      } catch (we) {
        if (we && H && typeof we.stack == "string") {
          for (var Y = we.stack.split(`
`), xe = H.stack.split(`
`), ue = Y.length - 1, pe = xe.length - 1; ue >= 1 && pe >= 0 && Y[ue] !== xe[pe]; )
            pe--;
          for (; ue >= 1 && pe >= 0; ue--, pe--)
            if (Y[ue] !== xe[pe]) {
              if (ue !== 1 || pe !== 1)
                do
                  if (ue--, pe--, pe < 0 || Y[ue] !== xe[pe]) {
                    var je = `
` + Y[ue].replace(" at new ", " at ");
                    return h.displayName && je.includes("<anonymous>") && (je = je.replace("<anonymous>", h.displayName)), typeof h == "function" && U.set(h, je), je;
                  }
                while (ue >= 1 && pe >= 0);
              break;
            }
        }
      } finally {
        ae = !1, be.current = re, Se(), Error.prepareStackTrace = oe;
      }
      var xt = h ? h.displayName || h.name : "", it = xt ? Q(xt) : "";
      return typeof h == "function" && U.set(h, it), it;
    }
    function ve(h, N, k) {
      return K(h, !1);
    }
    function Me(h) {
      var N = h.prototype;
      return !!(N && N.isReactComponent);
    }
    function Ie(h, N, k) {
      if (h == null)
        return "";
      if (typeof h == "function")
        return K(h, Me(h));
      if (typeof h == "string")
        return Q(h);
      switch (h) {
        case u:
          return Q("Suspense");
        case f:
          return Q("SuspenseList");
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case c:
            return ve(h.render);
          case m:
            return Ie(h.type, N, k);
          case g: {
            var H = h, oe = H._payload, re = H._init;
            try {
              return Ie(re(oe), N, k);
            } catch {
            }
          }
        }
      return "";
    }
    var _e = Object.prototype.hasOwnProperty, Xe = {}, Kt = w.ReactDebugCurrentFrame;
    function ze(h) {
      if (h) {
        var N = h._owner, k = Ie(h.type, h._source, N ? N.type : null);
        Kt.setExtraStackFrame(k);
      } else
        Kt.setExtraStackFrame(null);
    }
    function El(h, N, k, H, oe) {
      {
        var re = Function.call.bind(_e);
        for (var J in h)
          if (re(h, J)) {
            var Y = void 0;
            try {
              if (typeof h[J] != "function") {
                var xe = Error((H || "React class") + ": " + k + " type `" + J + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof h[J] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw xe.name = "Invariant Violation", xe;
              }
              Y = h[J](N, J, H, k, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ue) {
              Y = ue;
            }
            Y && !(Y instanceof Error) && (ze(oe), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", H || "React class", k, J, typeof Y), ze(null)), Y instanceof Error && !(Y.message in Xe) && (Xe[Y.message] = !0, ze(oe), C("Failed %s type: %s", k, Y.message), ze(null));
          }
      }
    }
    var Rl = Array.isArray;
    function Bn(h) {
      return Rl(h);
    }
    function Ml(h) {
      {
        var N = typeof Symbol == "function" && Symbol.toStringTag, k = N && h[Symbol.toStringTag] || h.constructor.name || "Object";
        return k;
      }
    }
    function jl(h) {
      try {
        return dr(h), !1;
      } catch {
        return !0;
      }
    }
    function dr(h) {
      return "" + h;
    }
    function ur(h) {
      if (jl(h))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ml(h)), dr(h);
    }
    var fr = w.ReactCurrentOwner, Pl = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pr, mr;
    function Nl(h) {
      if (_e.call(h, "ref")) {
        var N = Object.getOwnPropertyDescriptor(h, "ref").get;
        if (N && N.isReactWarning)
          return !1;
      }
      return h.ref !== void 0;
    }
    function _l(h) {
      if (_e.call(h, "key")) {
        var N = Object.getOwnPropertyDescriptor(h, "key").get;
        if (N && N.isReactWarning)
          return !1;
      }
      return h.key !== void 0;
    }
    function kl(h, N) {
      typeof h.ref == "string" && fr.current;
    }
    function Al(h, N) {
      {
        var k = function() {
          pr || (pr = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", N));
        };
        k.isReactWarning = !0, Object.defineProperty(h, "key", {
          get: k,
          configurable: !0
        });
      }
    }
    function Tl(h, N) {
      {
        var k = function() {
          mr || (mr = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", N));
        };
        k.isReactWarning = !0, Object.defineProperty(h, "ref", {
          get: k,
          configurable: !0
        });
      }
    }
    var Il = function(h, N, k, H, oe, re, J) {
      var Y = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: h,
        key: N,
        ref: k,
        props: J,
        // Record the component responsible for creating this element.
        _owner: re
      };
      return Y._store = {}, Object.defineProperty(Y._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Y, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: H
      }), Object.defineProperty(Y, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: oe
      }), Object.freeze && (Object.freeze(Y.props), Object.freeze(Y)), Y;
    };
    function Ol(h, N, k, H, oe) {
      {
        var re, J = {}, Y = null, xe = null;
        k !== void 0 && (ur(k), Y = "" + k), _l(N) && (ur(N.key), Y = "" + N.key), Nl(N) && (xe = N.ref, kl(N, oe));
        for (re in N)
          _e.call(N, re) && !Pl.hasOwnProperty(re) && (J[re] = N[re]);
        if (h && h.defaultProps) {
          var ue = h.defaultProps;
          for (re in ue)
            J[re] === void 0 && (J[re] = ue[re]);
        }
        if (Y || xe) {
          var pe = typeof h == "function" ? h.displayName || h.name || "Unknown" : h;
          Y && Al(J, pe), xe && Tl(J, pe);
        }
        return Il(h, Y, xe, oe, H, fr.current, J);
      }
    }
    var zn = w.ReactCurrentOwner, hr = w.ReactDebugCurrentFrame;
    function vt(h) {
      if (h) {
        var N = h._owner, k = Ie(h.type, h._source, N ? N.type : null);
        hr.setExtraStackFrame(k);
      } else
        hr.setExtraStackFrame(null);
    }
    var Wn;
    Wn = !1;
    function Gn(h) {
      return typeof h == "object" && h !== null && h.$$typeof === t;
    }
    function gr() {
      {
        if (zn.current) {
          var h = $(zn.current.type);
          if (h)
            return `

Check the render method of \`` + h + "`.";
        }
        return "";
      }
    }
    function Ll(h) {
      return "";
    }
    var vr = {};
    function Dl(h) {
      {
        var N = gr();
        if (!N) {
          var k = typeof h == "string" ? h : h.displayName || h.name;
          k && (N = `

Check the top-level render call using <` + k + ">.");
        }
        return N;
      }
    }
    function xr(h, N) {
      {
        if (!h._store || h._store.validated || h.key != null)
          return;
        h._store.validated = !0;
        var k = Dl(N);
        if (vr[k])
          return;
        vr[k] = !0;
        var H = "";
        h && h._owner && h._owner !== zn.current && (H = " It was passed a child from " + $(h._owner.type) + "."), vt(h), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', k, H), vt(null);
      }
    }
    function Cr(h, N) {
      {
        if (typeof h != "object")
          return;
        if (Bn(h))
          for (var k = 0; k < h.length; k++) {
            var H = h[k];
            Gn(H) && xr(H, N);
          }
        else if (Gn(h))
          h._store && (h._store.validated = !0);
        else if (h) {
          var oe = v(h);
          if (typeof oe == "function" && oe !== h.entries)
            for (var re = oe.call(h), J; !(J = re.next()).done; )
              Gn(J.value) && xr(J.value, N);
        }
      }
    }
    function Fl(h) {
      {
        var N = h.type;
        if (N == null || typeof N == "string")
          return;
        var k;
        if (typeof N == "function")
          k = N.propTypes;
        else if (typeof N == "object" && (N.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        N.$$typeof === m))
          k = N.propTypes;
        else
          return;
        if (k) {
          var H = $(N);
          El(k, h.props, "prop", H, h);
        } else if (N.PropTypes !== void 0 && !Wn) {
          Wn = !0;
          var oe = $(N);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", oe || "Unknown");
        }
        typeof N.getDefaultProps == "function" && !N.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vl(h) {
      {
        for (var N = Object.keys(h.props), k = 0; k < N.length; k++) {
          var H = N[k];
          if (H !== "children" && H !== "key") {
            vt(h), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", H), vt(null);
            break;
          }
        }
        h.ref !== null && (vt(h), C("Invalid attribute `ref` supplied to `React.Fragment`."), vt(null));
      }
    }
    var br = {};
    function wr(h, N, k, H, oe, re) {
      {
        var J = L(h);
        if (!J) {
          var Y = "";
          (h === void 0 || typeof h == "object" && h !== null && Object.keys(h).length === 0) && (Y += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var xe = Ll();
          xe ? Y += xe : Y += gr();
          var ue;
          h === null ? ue = "null" : Bn(h) ? ue = "array" : h !== void 0 && h.$$typeof === t ? (ue = "<" + ($(h.type) || "Unknown") + " />", Y = " Did you accidentally export a JSX literal instead of a component?") : ue = typeof h, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ue, Y);
        }
        var pe = Ol(h, N, k, oe, re);
        if (pe == null)
          return pe;
        if (J) {
          var je = N.children;
          if (je !== void 0)
            if (H)
              if (Bn(je)) {
                for (var xt = 0; xt < je.length; xt++)
                  Cr(je[xt], h);
                Object.freeze && Object.freeze(je);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cr(je, h);
        }
        if (_e.call(N, "key")) {
          var it = $(h), we = Object.keys(N).filter(function(Gl) {
            return Gl !== "key";
          }), Zn = we.length > 0 ? "{key: someKey, " + we.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!br[it + Zn]) {
            var Wl = we.length > 0 ? "{" + we.join(": ..., ") + ": ...}" : "{}";
            C(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Zn, it, Wl, it), br[it + Zn] = !0;
          }
        }
        return h === o ? Vl(pe) : Fl(pe), pe;
      }
    }
    function Hl(h, N, k) {
      return wr(h, N, k, !0);
    }
    function $l(h, N, k) {
      return wr(h, N, k, !1);
    }
    var Bl = $l, zl = Hl;
    Ot.Fragment = o, Ot.jsx = Bl, Ot.jsxs = zl;
  })()), Ot;
}
var Mr;
function Vc() {
  return Mr || (Mr = 1, process.env.NODE_ENV === "production" ? Yt.exports = Dc() : Yt.exports = Fc()), Yt.exports;
}
var s = Vc();
const M4 = (e) => /* @__PURE__ */ s.jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 36 37", fill: "none", ...e, children: /* @__PURE__ */ s.jsx(
  "path",
  {
    d: "M27.4621 18.8818C27.512 24.2603 32.1804 26.0501 32.2321 26.0729C32.1926 26.1991 31.4862 28.6235 29.7726 31.1278C28.2912 33.2929 26.7538 35.45 24.3319 35.4946C21.9522 35.5385 21.1869 34.0835 18.4662 34.0835C15.7463 34.0835 14.8961 35.45 12.6434 35.5386C10.3056 35.6271 8.52539 33.1974 7.03182 31.0402C3.97974 26.6277 1.64732 18.5715 4.77917 13.1334C6.335 10.4329 9.1154 8.72278 12.1333 8.67893C14.4289 8.63514 16.5956 10.2233 17.999 10.2233C19.4015 10.2233 22.0345 8.31339 24.8026 8.59389C25.9614 8.64212 29.2143 9.06198 31.303 12.1193C31.1347 12.2237 27.4217 14.3852 27.4621 18.8818ZM22.9896 5.67464C24.2307 4.1723 25.066 2.08092 24.8382 0C23.0492 0.0719024 20.8859 1.19213 19.6027 2.69364C18.4527 4.0233 17.4455 6.15149 17.7173 8.19122C19.7113 8.3455 21.7484 7.17793 22.9896 5.67464Z",
    fill: "black"
  }
) }), j4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 46 46", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_11981_28639)", children: [
    /* @__PURE__ */ s.jsx("mask", { id: "mask0_11981_28639", maskUnits: "userSpaceOnUse", x: 0, y: 12, width: 46, height: 21, children: /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M45.3211 12.2374L0.00976562 12.2374L0.00976562 32.9461L45.3211 32.9461V12.2374Z",
        fill: "white"
      }
    ) }),
    /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_11981_28639)", children: [
      /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M36.3782 21.2233C36.2263 21.2233 36.0765 21.2288 35.9267 21.2336C35.9024 21.235 35.8786 21.2405 35.8562 21.2502C35.7757 21.2776 35.7144 21.3438 35.6933 21.4263L35.0512 23.6691C34.7744 24.6335 34.8772 25.5241 35.3426 26.1778C35.7693 26.7826 36.479 27.1374 37.3407 27.1788L40.8239 27.39C40.9274 27.3956 41.0172 27.4453 41.0718 27.5274C41.1296 27.6163 41.1427 27.7272 41.107 27.827C41.0497 27.9907 40.902 28.1057 40.7293 28.1211L37.1101 28.3323C35.1437 28.4235 33.0283 30.0278 32.2861 31.9843L32.0251 32.6746C32.0023 32.7326 32.0089 32.7981 32.0429 32.8504C32.0769 32.9028 32.134 32.9355 32.1963 32.9383L44.6613 32.9383C44.8102 32.9389 44.9413 32.8401 44.9816 32.6966C45.203 31.901 45.3144 31.0788 45.3131 30.2529C45.3131 25.2687 41.3162 21.2288 36.3838 21.2288",
          fill: "#FBAD41"
        }
      ),
      /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M30.9457 32.6562L31.1763 31.845C31.4538 30.8806 31.351 29.9901 30.8863 29.3363C30.4583 28.7316 29.7492 28.3768 28.8869 28.3354L12.5479 28.1241C12.4448 28.1223 12.3489 28.0712 12.2897 27.9867C12.2316 27.898 12.2183 27.7871 12.2538 27.6871C12.3116 27.5224 12.4609 27.4072 12.6349 27.3931L29.1264 27.1818C31.0845 27.0914 33.2 25.4864 33.9422 23.5299L34.8825 21.0447C34.9204 20.9394 34.9304 20.8257 34.9101 20.7155C33.8386 15.8679 29.5524 12.2374 24.4281 12.2374C19.7042 12.2374 15.6962 15.3177 14.2581 19.5998C13.2898 18.8636 12.0772 18.5244 10.8674 18.6513C8.60283 18.8792 6.7801 20.7237 6.55499 23.0129C6.49672 23.5846 6.53877 24.1621 6.67928 24.7194C2.9786 24.8299 0.00976562 27.8935 0.00976562 31.6586C0.00976562 31.999 0.0339306 32.3345 0.0829507 32.6617C0.103137 32.8205 0.238379 32.9394 0.398476 32.9392L30.5729 32.9392C30.7474 32.9363 30.8992 32.8189 30.9457 32.6506",
          fill: "#F6821F"
        }
      )
    ] })
  ] }),
  /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_11981_28639", children: /* @__PURE__ */ s.jsx("rect", { width: 45.3113, height: 45.3113, fill: "white" }) }) })
] }), P4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 47 47", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx("path", { d: "M43.7255 2.57275L2.57227 2.57275L2.57227 43.726H43.7255V2.57275Z", fill: "#0061FE" }),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M23.167 15.8254L16.2993 20.209L23.167 24.5926L16.2993 28.9762L9.43164 24.556L16.2993 20.1724L9.43164 15.8254L16.2993 11.4418L23.167 15.8254ZM16.2628 30.3644L23.1304 25.9807L29.9981 30.3644L23.1304 34.748L16.2628 30.3644ZM23.167 24.556L30.0346 20.1724L23.167 15.8254L29.9981 11.4418L36.8657 15.8254L29.9981 20.209L36.8657 24.5926L29.9981 28.9762L23.167 24.556Z",
      fill: "#F6F3F0"
    }
  )
] }), N4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 72 72", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M35.6074 35.8701C35.6074 30.0004 40.3658 25.2418 46.2357 25.2418C52.1054 25.2418 56.8639 30.0004 56.8639 35.8701C56.8639 41.7401 52.1054 46.4984 46.2357 46.4984C40.3658 46.4984 35.6074 41.7401 35.6074 35.8701Z",
      fill: "#1ABCFE"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M14.3477 57.127C14.3477 51.2573 19.1061 46.4987 24.9759 46.4987H35.604V57.127C35.604 62.9969 30.8457 67.7553 24.9759 67.7553C19.1061 67.7553 14.3477 62.9969 14.3477 57.127Z",
      fill: "#0ACF83"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M35.6074 3.9856V25.2421H46.2357C52.1055 25.2421 56.8639 20.4838 56.8639 14.6139C56.8639 8.74404 52.1055 3.9856 46.2357 3.9856H35.6074Z",
      fill: "#FF7262"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M14.3477 14.6139C14.3477 20.4838 19.1061 25.2421 24.9759 25.2421H35.604V3.9856L24.9759 3.9856C19.1061 3.9856 14.3477 8.74404 14.3477 14.6139Z",
      fill: "#F24E1E"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M14.3477 35.8701C14.3477 41.7401 19.1061 46.4984 24.9759 46.4984H35.604V25.2418H24.9759C19.1061 25.2418 14.3477 30.0004 14.3477 35.8701Z",
      fill: "#A259FF"
    }
  )
] }), _4 = (e) => /* @__PURE__ */ s.jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 38 38", fill: "none", ...e, children: /* @__PURE__ */ s.jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5006 2.4137C9.35354 2.4137 1.95898 9.86264 1.95898 19.078C1.95898 26.4444 6.69694 32.6798 13.2697 34.8867C14.0915 35.0527 14.3925 34.5282 14.3925 34.087C14.3925 33.7007 14.3654 32.3764 14.3654 30.9967C9.76388 31.9901 8.80567 29.0102 8.80567 29.0102C8.0662 27.0789 6.97048 26.5825 6.97048 26.5825C5.46443 25.5617 7.08019 25.5617 7.08019 25.5617C8.75083 25.672 9.62746 27.2722 9.62746 27.2722C11.1061 29.8103 13.4888 29.0931 14.4473 28.6516C14.5841 27.5756 15.0226 26.8307 15.4882 26.4169C11.8181 26.0306 7.95682 24.596 7.95682 18.195C7.95682 16.3741 8.61371 14.8843 9.65455 13.7256C9.49034 13.3118 8.91504 11.601 9.81909 9.31111C9.81909 9.31111 11.2158 8.86958 14.365 11.0217C15.7134 10.6569 17.1039 10.4713 18.5006 10.4697C19.8973 10.4697 21.3211 10.6631 22.6359 11.0217C25.7855 8.86958 27.1821 9.31111 27.1821 9.31111C28.0862 11.601 27.5106 13.3118 27.3464 13.7256C28.4147 14.8843 29.0444 16.3741 29.0444 18.195C29.0444 24.596 25.1831 26.0029 21.4857 26.4169C22.0884 26.9411 22.6084 27.9341 22.6084 29.5069C22.6084 31.7416 22.5814 33.5351 22.5814 34.0866C22.5814 34.5282 22.8827 35.0527 23.7041 34.8871C30.2769 32.6795 35.0148 26.4444 35.0148 19.078C35.0419 9.86264 27.6203 2.4137 18.5006 2.4137Z",
    fill: "#24292F"
  }
) }), k4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 66 66", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_11981_28666)", children: [
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M61.8146 33.536C61.8146 31.0667 61.6142 29.2648 61.1806 27.3962H32.9844V38.5411H49.5349C49.2014 41.3108 47.3995 45.4818 43.3952 48.2846L43.3391 48.6577L52.2542 55.5642L52.8719 55.6258C58.5444 50.3869 61.8146 42.6788 61.8146 33.536Z",
        fill: "#4285F4"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M32.9747 62.9002C41.0831 62.9002 47.8901 60.2307 52.8622 55.626L43.3855 48.2848C40.8496 50.0533 37.4459 51.2879 32.9747 51.2879C25.0331 51.2879 18.2927 46.0493 15.89 38.8083L15.5378 38.8383L6.26771 46.0125L6.14648 46.3495C11.0849 56.1597 21.2289 62.9002 32.9747 62.9002Z",
        fill: "#34A853"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M15.8999 38.8083C15.2659 36.9397 14.899 34.9374 14.899 32.8687C14.899 30.7997 15.2659 28.7977 15.8665 26.9291L15.8498 26.5311L6.46351 19.2417L6.15641 19.3878C4.12103 23.4588 2.95313 28.0303 2.95313 32.8687C2.95313 37.7071 4.12103 42.2784 6.15641 46.3494L15.8999 38.8083Z",
        fill: "#FBBC05"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M32.9747 14.4494C38.6138 14.4494 42.4178 16.8853 44.5868 18.9209L53.0623 10.6455C47.857 5.80707 41.0831 2.83728 32.9747 2.83728C21.2289 2.83728 11.0849 9.57763 6.14648 19.3878L15.8566 26.9292C18.2927 19.6883 25.0331 14.4494 32.9747 14.4494Z",
        fill: "#EB4335"
      }
    )
  ] }),
  /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_11981_28666", children: /* @__PURE__ */ s.jsx("rect", { width: 60.27, height: 60.27, fill: "white", transform: "translate(2.26562 2.83704)" }) }) })
] }), A4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 39 39", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M35.2153 18.2859L20.4843 3.55466L19.0679 2.13818L8.01963 13.1866L2.96765 18.2388C2.44828 18.7581 2.44828 19.608 2.96765 20.1746L13.0717 30.2787L19.0679 36.3223L30.1161 25.2738L30.305 25.085L35.2153 20.1746C35.7348 19.6551 35.7348 18.8054 35.2153 18.2859ZM19.0679 24.2823L14.016 19.2302L19.0679 14.1781L24.1199 19.2302L19.0679 24.2823Z",
      fill: "#2684FF"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M19.0584 14.1781C15.7534 10.873 15.7534 5.49041 19.0112 2.1853L7.96289 13.2338L13.9592 19.2302L19.0584 14.1781Z",
      fill: "url(#paint0_linear_11981_28647)"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M24.1184 19.2288L19.0664 24.2809C22.3714 27.5859 22.3714 32.9685 19.0664 36.3208L30.1618 25.2251L24.1184 19.2288Z",
      fill: "url(#paint1_linear_11981_28647)"
    }
  ),
  /* @__PURE__ */ s.jsxs("defs", { children: [
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint0_linear_11981_28647",
        x1: 18.1572,
        y1: 9.05962,
        x2: 11.1016,
        y2: 16.1151,
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { offset: 0.176, stopColor: "#0052CC" }),
          /* @__PURE__ */ s.jsx("stop", { offset: 1, stopColor: "#2684FF" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint1_linear_11981_28647",
        x1: 20.0327,
        y1: 29.3262,
        x2: 27.0742,
        y2: 22.2849,
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { offset: 0.176, stopColor: "#0052CC" }),
          /* @__PURE__ */ s.jsx("stop", { offset: 1, stopColor: "#2684FF" })
        ]
      }
    )
  ] })
] }), T4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "-1.94 -9.28 64.2 64.2", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M10.6018 45.1V42.1C10.6018 40.95 9.90178 40.2 8.70178 40.2C8.10178 40.2 7.45178 40.4 7.00178 41.05C6.65178 40.5 6.15178 40.2 5.40178 40.2C4.90178 40.2 4.40178 40.35 4.00178 40.9V40.3H2.95179V45.1H4.00178V42.45C4.00178 41.6 4.45178 41.2 5.15178 41.2C5.85178 41.2 6.20178 41.65 6.20178 42.45V45.1H7.25178V42.45C7.25178 41.6 7.75178 41.2 8.40178 41.2C9.10178 41.2 9.45178 41.65 9.45178 42.45V45.1H10.6018ZM26.1518 40.3H24.4518V38.85H23.4018V40.3H22.4518V41.25H23.4018V43.45C23.4018 44.55 23.8518 45.2 25.0518 45.2C25.5018 45.2 26.0018 45.05 26.3518 44.85L26.0518 43.95C25.7518 44.15 25.4018 44.2 25.1518 44.2C24.6518 44.2 24.4518 43.9 24.4518 43.4V41.25H26.1518V40.3ZM35.0518 40.2C34.4518 40.2 34.0518 40.5 33.8018 40.9V40.3H32.7518V45.1H33.8018V42.4C33.8018 41.6 34.1518 41.15 34.8018 41.15C35.0018 41.15 35.2518 41.2 35.4518 41.25L35.7518 40.25C35.5518 40.2 35.2518 40.2 35.0518 40.2ZM21.6018 40.7C21.1018 40.35 20.4018 40.2 19.6518 40.2C18.4518 40.2 17.6518 40.8 17.6518 41.75C17.6518 42.55 18.2518 43 19.3018 43.15L19.8018 43.2C20.3518 43.3 20.6518 43.45 20.6518 43.7C20.6518 44.05 20.2518 44.3 19.5518 44.3C18.8518 44.3 18.3018 44.05 17.9518 43.8L17.4518 44.6C18.0018 45 18.7518 45.2 19.5018 45.2C20.9018 45.2 21.7018 44.55 21.7018 43.65C21.7018 42.8 21.0518 42.35 20.0518 42.2L19.5518 42.15C19.1018 42.1 18.7518 42 18.7518 41.7C18.7518 41.35 19.1018 41.15 19.6518 41.15C20.2518 41.15 20.8518 41.4 21.1518 41.55L21.6018 40.7ZM49.5017 40.2C48.9017 40.2 48.5017 40.5 48.2517 40.9V40.3H47.2017V45.1H48.2517V42.4C48.2517 41.6 48.6017 41.15 49.2517 41.15C49.4517 41.15 49.7017 41.2 49.9017 41.25L50.2017 40.25C50.0017 40.2 49.7017 40.2 49.5017 40.2ZM36.1018 42.7C36.1018 44.15 37.1018 45.2 38.6518 45.2C39.3518 45.2 39.8518 45.05 40.3518 44.65L39.8518 43.8C39.4518 44.1 39.0518 44.25 38.6018 44.25C37.7518 44.25 37.1518 43.65 37.1518 42.7C37.1518 41.8 37.7518 41.2 38.6018 41.15C39.0518 41.15 39.4518 41.3 39.8518 41.6L40.3518 40.75C39.8518 40.35 39.3518 40.2 38.6518 40.2C37.1018 40.2 36.1018 41.25 36.1018 42.7ZM45.8017 42.7V40.3H44.7517V40.9C44.4017 40.45 43.9017 40.2 43.2517 40.2C41.9018 40.2 40.8518 41.25 40.8518 42.7C40.8518 44.15 41.9018 45.2 43.2517 45.2C43.9517 45.2 44.4517 44.95 44.7517 44.5V45.1H45.8017V42.7ZM41.9518 42.7C41.9518 41.85 42.5017 41.15 43.4017 41.15C44.2517 41.15 44.8517 41.8 44.8517 42.7C44.8517 43.55 44.2517 44.25 43.4017 44.25C42.5017 44.2 41.9518 43.55 41.9518 42.7ZM29.4018 40.2C28.0018 40.2 27.0018 41.2 27.0018 42.7C27.0018 44.2 28.0018 45.2 29.4518 45.2C30.1518 45.2 30.8518 45 31.4018 44.55L30.9018 43.8C30.5018 44.1 30.0018 44.3 29.5018 44.3C28.8518 44.3 28.2018 44 28.0518 43.15H31.6018V42.75C31.6518 41.2 30.7518 40.2 29.4018 40.2ZM29.4018 41.1C30.0518 41.1 30.5018 41.5 30.6018 42.25H28.1018C28.2018 41.6 28.6518 41.1 29.4018 41.1ZM55.4517 42.7V38.4H54.4017V40.9C54.0517 40.45 53.5517 40.2 52.9017 40.2C51.5517 40.2 50.5017 41.25 50.5017 42.7C50.5017 44.15 51.5517 45.2 52.9017 45.2C53.6017 45.2 54.1017 44.95 54.4017 44.5V45.1H55.4517V42.7ZM51.6017 42.7C51.6017 41.85 52.1517 41.15 53.0517 41.15C53.9017 41.15 54.5017 41.8 54.5017 42.7C54.5017 43.55 53.9017 44.25 53.0517 44.25C52.1517 44.2 51.6017 43.55 51.6017 42.7ZM16.5018 42.7V40.3H15.4518V40.9C15.1018 40.45 14.6018 40.2 13.9518 40.2C12.6018 40.2 11.5518 41.25 11.5518 42.7C11.5518 44.15 12.6018 45.2 13.9518 45.2C14.6518 45.2 15.1518 44.95 15.4518 44.5V45.1H16.5018V42.7ZM12.6018 42.7C12.6018 41.85 13.1518 41.15 14.0518 41.15C14.9018 41.15 15.5018 41.8 15.5018 42.7C15.5018 43.55 14.9018 44.25 14.0518 44.25C13.1518 44.2 12.6018 43.55 12.6018 42.7Z",
      fill: "black"
    }
  ),
  /* @__PURE__ */ s.jsx("path", { d: "M37.0028 3.85008H21.2528V32.1501H37.0028V3.85008Z", fill: "#FF5F00" }),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M22.25 18C22.25 12.25 24.95 7.15 29.1 3.85C26.05 1.45 22.2 2.86102e-06 18 2.86102e-06C8.04999 2.86102e-06 0 8.05 0 18C0 27.95 8.04999 36 18 36C22.2 36 26.05 34.55 29.1 32.15C24.95 28.9 22.25 23.75 22.25 18Z",
      fill: "#EB001B"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M58.2538 18C58.2538 27.95 50.2038 36 40.2538 36C36.0538 36 32.2038 34.55 29.1538 32.15C33.3538 28.85 36.0038 23.75 36.0038 18C36.0038 12.25 33.3038 7.14999 29.1538 3.85C32.2038 1.45 36.0538 0 40.2538 0C50.2038 0 58.2538 8.09999 58.2538 18Z",
      fill: "#F79E1B"
    }
  )
] }), I4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 59 59", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx("path", { d: "M27.8332 27.8285H3.5V3.49976H27.8332V27.8285Z", fill: "#F1511B" }),
  /* @__PURE__ */ s.jsx("path", { d: "M54.698 27.8285H30.3652V3.49976H54.698V27.8285Z", fill: "#80CC28" }),
  /* @__PURE__ */ s.jsx("path", { d: "M27.8325 54.6998H3.5V30.3712H27.8325V54.6998Z", fill: "#00ADEF" }),
  /* @__PURE__ */ s.jsx("path", { d: "M54.698 54.6998H30.3652V30.3712H54.698V54.6998Z", fill: "#FBBC09" })
] }), O4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 31 31", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx("g", { filter: "url(#filter0_i_11981_28655)", children: /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M21.7677 28.3357C21.8344 28.3624 22.4754 28.6224 22.5674 28.6599C22.5699 28.6608 22.5753 28.6629 22.5818 28.6656C22.5925 28.6698 22.5882 28.668 22.5934 28.6701C22.6044 28.6746 22.6081 28.6761 22.612 28.6776C22.6121 28.4762 22.6122 28.1778 22.6122 27.8588C22.6122 27.4505 22.6122 27.0174 22.6122 26.8022V1.68481H17.3105V15.7336C17.4728 16.1923 18.1593 18.1388 18.335 18.629C18.6633 19.564 20.5316 24.8409 20.681 25.2629C20.8149 25.6417 21.1878 26.6947 21.3064 27.0315C21.3757 27.2266 21.5566 27.7369 21.6527 28.0089C21.7279 28.2217 21.7211 28.2043 21.7677 28.3357Z",
      fill: "#B11F24"
    }
  ) }),
  /* @__PURE__ */ s.jsx("g", { filter: "url(#filter1_i_11981_28655)", children: /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M8.61596 2.02679C8.54925 1.99993 7.90832 1.74016 7.81631 1.70273C7.81381 1.70171 7.80838 1.69949 7.80187 1.69685C7.79124 1.69265 7.79542 1.69445 7.79033 1.69238C7.77926 1.68794 7.77558 1.6864 7.77167 1.68481C7.7716 1.88631 7.7715 2.18468 7.7715 2.50376C7.77147 2.91183 7.7715 3.34512 7.7715 3.56043V28.6778C9.8775 28.4248 10.9307 28.3263 13.0732 28.2287V14.6289C12.9109 14.1703 12.2244 12.2237 12.0487 11.7335C11.7204 10.7986 9.85209 5.5217 9.70271 5.09956C9.56883 4.72077 9.19588 3.66786 9.07734 3.33089C9.00804 3.13597 8.82708 2.62577 8.73095 2.35367C8.65581 2.14092 8.66259 2.15838 8.61596 2.02679Z",
      fill: "#B11F24"
    }
  ) }),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M13.0712 1.68518H7.76953L17.1575 28.2292C19.7957 28.2959 22.6179 28.6783 22.6179 28.6783L13.0712 1.68518Z",
      fill: "#ED1C24"
    }
  ),
  /* @__PURE__ */ s.jsxs("defs", { children: [
    /* @__PURE__ */ s.jsxs(
      "filter",
      {
        id: "filter0_i_11981_28655",
        x: 17.3105,
        y: -0.59276,
        width: 5.30078,
        height: 29.2704,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [
          /* @__PURE__ */ s.jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
          /* @__PURE__ */ s.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
          /* @__PURE__ */ s.jsx(
            "feColorMatrix",
            {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }
          ),
          /* @__PURE__ */ s.jsx("feOffset", { dy: -3.79596 }),
          /* @__PURE__ */ s.jsx("feGaussianBlur", { stdDeviation: 1.13879 }),
          /* @__PURE__ */ s.jsx("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: -1, k3: 1 }),
          /* @__PURE__ */ s.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" }),
          /* @__PURE__ */ s.jsx("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_11981_28655" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "filter",
      {
        id: "filter1_i_11981_28655",
        x: 7.77148,
        y: 1.68481,
        width: 5.30078,
        height: 29.2705,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [
          /* @__PURE__ */ s.jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
          /* @__PURE__ */ s.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
          /* @__PURE__ */ s.jsx(
            "feColorMatrix",
            {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }
          ),
          /* @__PURE__ */ s.jsx("feOffset", { dy: 3.79596 }),
          /* @__PURE__ */ s.jsx("feGaussianBlur", { stdDeviation: 1.13879 }),
          /* @__PURE__ */ s.jsx("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: -1, k3: 1 }),
          /* @__PURE__ */ s.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" }),
          /* @__PURE__ */ s.jsx("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_11981_28655" })
        ]
      }
    )
  ] })
] }), L4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 28 28", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M3.63597 2.60737L17.2984 1.60123C18.9761 1.45732 19.4078 1.55372 20.4623 2.31977L24.8236 5.38513C25.5432 5.91226 25.783 6.05577 25.783 6.63038L25.783 23.4428C25.783 24.4965 25.3992 25.1196 24.0572 25.2149L8.19116 26.173C7.18384 26.2211 6.70438 26.0775 6.17685 25.4066L2.96519 21.2394C2.38971 20.4724 2.15039 19.8985 2.15039 19.2272L2.15039 4.28317C2.15039 3.42151 2.53431 2.70279 3.63597 2.60737Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.2984 1.60123L3.63597 2.60737C2.53431 2.70279 2.15039 3.42151 2.15039 4.28317L2.15039 19.2272C2.15039 19.8985 2.38971 20.4724 2.96519 21.2394L6.17685 25.4066C6.70438 26.0775 7.18384 26.2211 8.19116 26.173L24.0572 25.2149C25.3992 25.1196 25.783 24.4965 25.783 23.4428L25.783 6.63038C25.783 6.08573 25.5675 5.9284 24.9322 5.46458C24.8972 5.43905 24.8611 5.4126 24.8236 5.38513L20.4623 2.31977C19.4078 1.55372 18.9761 1.45732 17.2984 1.60123ZM8.55091 6.35461C7.25553 6.4421 6.96118 6.46196 6.22557 5.86434L4.35489 4.37956C4.16411 4.18755 4.2598 3.94806 4.73882 3.90054L17.8737 2.9425C18.9759 2.84649 19.5511 3.2303 19.9827 3.56542L22.2356 5.19411C22.3314 5.24181 22.5707 5.52882 22.283 5.52882L8.7181 6.34337C8.66104 6.34719 8.6057 6.35091 8.55209 6.35455L8.55091 6.35461ZM7.03999 23.2988L7.03999 9.02575C7.03999 8.40319 7.23176 8.11559 7.80668 8.06727L23.3855 7.15751C23.9138 7.10962 24.1531 7.44514 24.1531 8.06727L24.1531 22.2446C24.1531 22.8677 24.057 23.3954 23.1939 23.4428L8.28607 24.3054C7.42333 24.3528 7.03999 24.0659 7.03999 23.2988ZM21.7569 9.79136C21.8525 10.2229 21.7569 10.654 21.3247 10.7025L20.6064 10.8456L20.6064 21.3829C19.9827 21.7182 19.4077 21.9097 18.9284 21.9097C18.1612 21.9097 17.969 21.6701 17.3943 20.952L12.6959 13.5758L12.6959 20.7125L14.1826 21.048C14.1826 21.048 14.1826 21.9097 12.9831 21.9097L9.67637 22.1016C9.58029 21.9097 9.67637 21.4312 10.0118 21.3353L10.8747 21.0961L10.8747 11.6602L9.67656 11.5641C9.58047 11.1326 9.81979 10.5105 10.4914 10.4622L14.0388 10.2231L18.9284 17.6953L18.9284 11.0851L17.6817 10.942C17.586 10.4145 17.969 10.0314 18.4484 9.98399L21.7569 9.79136Z",
      fill: "#000008"
    }
  )
] }), D4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 56 56", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M45.2165 26.3545C44.1976 32.1631 39.4576 36.5551 33.2408 36.5551H29.2921C28.4864 36.5532 27.6763 37.3004 27.5423 38.1213L25.8114 49.0948C25.7126 49.7181 25.4195 49.9257 24.7867 49.9257H18.4416C17.8007 49.9257 17.6479 49.7118 17.7479 49.0784L18.4675 41.4938L10.8449 41.0994C10.2033 41.0994 9.96242 40.7434 10.0631 40.11L15.2634 7.13216C15.3622 6.50755 15.7515 6.23901 16.383 6.23901H29.572C35.9215 6.23901 39.9375 10.5128 40.4307 16.054C44.214 18.6113 45.9795 22.0046 45.2165 26.3545Z",
      fill: "#001C64"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M20.4024 29.2079L17.2493 49.2027C17.1494 49.836 17.6387 50.409 18.2796 50.409H24.9858C25.6179 50.409 26.1557 49.9492 26.2544 49.3247L28.0206 38.1221C28.1193 37.4976 28.6571 37.0378 29.2899 37.0378H33.2379C39.4554 37.0378 44.7312 32.5017 45.6954 26.3555C46.3798 21.993 44.1834 18.0236 40.4284 16.0549C40.419 16.5115 40.3793 16.9738 40.3064 17.4418C39.3422 23.588 34.0663 28.1235 27.8489 28.1235H21.671C21.0389 28.1235 20.5006 28.5833 20.4024 29.2079Z",
      fill: "#0070E0"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M18.4661 41.4945H10.663C10.0215 41.4945 9.53212 40.9216 9.63216 40.2882L14.8941 6.92222C14.9922 6.29829 15.5307 5.8385 16.1628 5.8385H29.5713C35.9202 5.8385 40.5375 10.4589 40.4294 16.0548C38.8493 15.2264 36.9938 14.7522 34.9598 14.7522H23.781C23.1488 14.7522 22.6111 15.212 22.5123 15.8366L18.4661 41.4945Z",
      fill: "#003087"
    }
  )
] }), F4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "-4.09 -4.11 71.74 71.74", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M13.4013 40.1488C13.4013 43.8401 10.4179 46.8234 6.72666 46.8234C3.03539 46.8234 0.0520371 43.8401 0.0520371 40.1488C0.0520371 36.4575 3.03539 33.4742 6.72666 33.4742H13.4013V40.1488ZM16.7386 40.1488C16.7386 36.4575 19.7219 33.4742 23.4132 33.4742C27.1045 33.4742 30.0878 36.4575 30.0878 40.1488V56.8353C30.0878 60.5266 27.1045 63.51 23.4132 63.51C19.7219 63.51 16.7386 60.5266 16.7386 56.8353V40.1488Z",
      fill: "#E01E5A"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M23.4117 13.3492C19.7205 13.3492 16.7371 10.3659 16.7371 6.67462C16.7371 2.98335 19.7205 0 23.4117 0C27.103 0 30.0864 2.98335 30.0864 6.67462V13.3492H23.4117ZM23.4117 16.7371C27.103 16.7371 30.0864 19.7205 30.0864 23.4117C30.0864 27.103 27.103 30.0864 23.4117 30.0864H6.67462C2.98335 30.0864 0 27.103 0 23.4117C0 19.7205 2.98335 16.7371 6.67462 16.7371H23.4117Z",
      fill: "#36C5F0"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M50.1603 23.4117C50.1603 19.7205 53.1436 16.7371 56.8349 16.7371C60.5262 16.7371 63.5095 19.7205 63.5095 23.4117C63.5095 27.103 60.5262 30.0864 56.8349 30.0864H50.1603V23.4117ZM46.823 23.4117C46.823 27.103 43.8396 30.0864 40.1484 30.0864C36.4571 30.0864 33.4737 27.103 33.4737 23.4117V6.67462C33.4737 2.98335 36.4571 0 40.1484 0C43.8396 0 46.823 2.98335 46.823 6.67462V23.4117Z",
      fill: "#2EB67D"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M40.1484 50.1607C43.8396 50.1607 46.823 53.1441 46.823 56.8353C46.823 60.5266 43.8396 63.51 40.1484 63.51C36.4571 63.51 33.4737 60.5266 33.4737 56.8353V50.1607H40.1484ZM40.1484 46.8234C36.4571 46.8234 33.4737 43.8401 33.4737 40.1488C33.4737 36.4575 36.4571 33.4742 40.1484 33.4742H56.8855C60.5767 33.4742 63.5601 36.4575 63.5601 40.1488C63.5601 43.8401 60.5767 46.8234 56.8855 46.8234H40.1484Z",
      fill: "#ECB22E"
    }
  )
] }), V4 = (e) => /* @__PURE__ */ s.jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", ...e, children: /* @__PURE__ */ s.jsx(
  "path",
  {
    d: "M23.985 14.1419C19.4789 11.4658 12.046 11.2198 7.74433 12.5255C7.05358 12.735 6.32307 12.345 6.11376 11.6543C5.90443 10.9632 6.29402 10.2332 6.98529 10.0232C11.9233 8.5242 20.1321 8.81381 25.3196 11.8931C25.9409 12.2619 26.1448 13.0643 25.7765 13.6846C25.4079 14.3059 24.6048 14.5108 23.985 14.1419ZM23.8375 18.1054C23.5213 18.6184 22.8506 18.7793 22.3382 18.4643C18.5815 16.1552 12.8529 15.4863 8.40837 16.8353C7.83198 17.0096 7.22318 16.6845 7.04823 16.1093C6.87444 15.5329 7.19963 14.9253 7.77487 14.75C12.8522 13.2094 19.164 13.9556 23.4789 16.6071C23.9912 16.9226 24.1524 17.5938 23.8375 18.1054ZM22.1269 21.9119C21.8757 22.3239 21.3393 22.4529 20.9288 22.2019C17.646 20.1955 13.5141 19.7425 8.64808 20.8539C8.17918 20.9614 7.71193 20.6676 7.60496 20.1987C7.4976 19.73 7.79025 19.2626 8.2603 19.1556C13.5852 17.9383 18.1531 18.4622 21.8378 20.7137C22.2486 20.9646 22.378 21.5013 22.1269 21.9119ZM15.7158 1.74902C7.99522 1.74902 1.73633 8.00771 1.73633 15.728C1.73633 23.4492 7.99522 29.7074 15.7158 29.7074C23.4365 29.7074 29.695 23.4492 29.695 15.728C29.695 8.00771 23.4365 1.74902 15.7158 1.74902Z",
    fill: "#1ED760"
  }
) }), H4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 28 32", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_11981_28603)", children: [
    /* @__PURE__ */ s.jsx("mask", { id: "mask0_11981_28603", maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 28, height: 32, children: /* @__PURE__ */ s.jsx("path", { d: "M0.00195312 0H27.0789V32H0.00195312V0Z", fill: "white" }) }),
    /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_11981_28603)", children: /* @__PURE__ */ s.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.00195312 28.6622H27.0789V32.0037H0.00221432L0.00195312 28.6622Z",
        fill: "#FF322E"
      }
    ) }),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.23506 7.54572L1.68359 21.486H4.97898L8.07044 11.6325L9.61992 16.5588H7.61553L6.81507 19.3709H10.5044L11.1697 21.486H14.5592L10.0083 7.54572H6.23506Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7313 7.54572H15V21.486H18.2719V10.3579H19.5903C21.12 10.3579 21.9911 11.1028 21.9911 12.4488C21.9911 13.7708 21.12 14.5399 19.5903 14.5399H19.3785V17.352H19.7313C23.262 17.352 25.3334 15.5372 25.3334 12.4488C25.3334 9.30025 23.262 7.54572 19.7313 7.54572Z",
        fill: "black"
      }
    )
  ] }),
  /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_11981_28603", children: /* @__PURE__ */ s.jsx("rect", { width: 27.0769, height: 32, fill: "white" }) }) })
] }), $4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 133 32", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx("g", { clipPath: "url(#clip0_11981_28600)", children: /* @__PURE__ */ s.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 10.24H4.77009C7.42327 10.24 8.81058 11.6117 8.81058 13.2963C8.81058 14.4592 8.15481 15.249 7.24548 15.6668V15.6969C8.40837 16.1147 9.06414 17.0386 9.06414 18.216C9.06414 19.9006 7.76718 21.3763 4.96439 21.3763H0V10.24ZM4.62145 14.6525C5.41128 14.6525 5.76977 14.2503 5.76977 13.8025C5.76977 13.3546 5.41225 12.9378 4.62145 12.9378H3.22054V14.6525H4.62145ZM4.66614 18.6775C5.50066 18.6775 5.90383 18.2753 5.90383 17.7536C5.90383 17.2319 5.48609 16.8297 4.68168 16.8297H3.22054V18.6785H4.66614V18.6775ZM9.74905 16.8443V10.24H12.9987V16.8141C12.9987 18.0518 13.6098 18.7076 14.6532 18.7076C15.6966 18.7076 16.3524 18.0518 16.3524 16.7996V10.24H19.6176V16.8443C19.6176 19.647 17.7397 21.66 14.6532 21.66C11.5667 21.66 9.74808 19.647 9.74808 16.8443H9.74905ZM27.8919 10.7762V13.6383C27.1914 13.1467 25.9984 12.8038 25.0299 12.8038C24.1506 12.8038 23.7028 13.0874 23.7028 13.4595C23.7028 13.8316 24.1944 14.0259 25.0745 14.3387C26.5658 14.8604 28.5924 15.5609 28.5924 17.9314C28.5924 20.0483 26.9971 21.6134 24.1944 21.6134C22.7488 21.6134 21.4217 21.1956 20.6017 20.6448V17.6331C21.4071 18.2889 22.6293 18.8106 23.8067 18.8106C24.8054 18.8106 25.2679 18.4375 25.2679 18.0207C25.2679 17.4845 24.5072 17.2455 23.5978 16.9171C22.4048 16.4848 20.5124 15.7095 20.5124 13.5479C20.5124 11.5952 22.0483 10 24.7909 10C25.9984 10 27.0865 10.3128 27.8919 10.7753V10.7762ZM29.4269 10.24H32.6766V21.3763H29.4269V10.24ZM44.2307 21.3763H41.1296L37.1193 15.3987H37.1047V21.3763H34.0192V10.24H37.1202L41.1306 16.1137H41.1452V10.24H44.2307V21.3763ZM45.5723 10.24H53.2647V13.1321H48.822V14.4738H52.8168V17.0978H48.822V18.4842H53.2647V21.3763H45.5723V10.24ZM61.4195 10.7762V13.6383C60.719 13.1467 59.526 12.8038 58.5574 12.8038C57.6782 12.8038 57.2304 13.0874 57.2304 13.4595C57.2304 13.8316 57.722 14.0259 58.6021 14.3387C60.0934 14.8604 62.12 15.5609 62.12 17.9314C62.12 20.0483 60.5247 21.6134 57.722 21.6134C56.2764 21.6134 54.9493 21.1956 54.1293 20.6448V17.6331C54.9347 18.2889 56.1569 18.8106 57.3343 18.8106C58.333 18.8106 58.7955 18.4375 58.7955 18.0207C58.7955 17.4845 58.0348 17.2455 57.1255 16.9171C55.9324 16.4848 54.04 15.7095 54.04 13.5479C54.04 11.5952 55.5759 10 58.3185 10C59.526 10 60.6141 10.3128 61.4195 10.7753V10.7762ZM70.0212 10.7762V13.6383C69.3207 13.1467 68.1277 12.8038 67.1591 12.8038C66.2799 12.8038 65.8321 13.0874 65.8321 13.4595C65.8321 13.8316 66.3237 14.0259 67.2038 14.3387C68.6951 14.8604 70.7217 15.5609 70.7217 17.9314C70.7217 20.0483 69.1264 21.6134 66.3237 21.6134C64.8781 21.6134 63.551 21.1956 62.731 20.6448V17.6331C63.5364 18.2889 64.7586 18.8106 65.936 18.8106C66.9347 18.8106 67.3972 18.4375 67.3972 18.0207C67.3972 17.4845 66.6365 17.2455 65.7271 16.9171C64.5341 16.4848 62.6417 15.7095 62.6417 13.5479C62.6417 11.5952 64.1776 10 66.9202 10C68.1277 10 69.2158 10.3128 70.0212 10.7753V10.7762ZM74.4872 21.3977H77.7369V10.2623H74.4872V21.3987V21.3977ZM89.2891 10.2623H86.2036V16.136H86.189L82.1786 10.2623H79.0776V21.3987H82.1631V15.421H82.1776L86.188 21.3987H89.2891V10.2623ZM94.5196 10.0233C91.7761 10.0233 90.2411 11.6185 90.2411 13.5713C90.2411 15.7328 92.1346 16.5081 93.3266 16.9404C94.236 17.2688 94.9967 17.5068 94.9967 18.0441C94.9967 18.4618 94.5342 18.8339 93.5355 18.8339C92.358 18.8339 91.1349 18.3122 90.3305 17.6564V20.6681C91.1505 21.2199 92.4775 21.6367 93.9231 21.6367C96.7259 21.6367 98.3211 20.0716 98.3211 17.9547C98.3211 15.5842 96.2936 14.8838 94.8033 14.3621C93.9241 14.0492 93.4315 13.8705 93.4315 13.4828C93.4315 13.0952 93.8784 12.8271 94.7586 12.8271C95.7272 12.8271 96.9202 13.17 97.6207 13.6616V10.7986C96.8153 10.3361 95.7272 10.0233 94.5196 10.0233ZM99.0799 21.3977H102.33V10.2623H99.0799V21.3987V21.3977ZM106.921 18.4608H107.548C109.232 18.4608 110.32 17.5068 110.32 15.8368C110.32 14.1668 109.232 13.1982 107.548 13.1982H106.921V18.4608ZM113.6 15.8368C113.6 19.1914 111.065 21.3977 107.428 21.3977H103.671V10.2623H107.428C111.065 10.2623 113.6 12.4832 113.6 15.8378V15.8368ZM114.481 21.3977H122.174V18.5055H117.731V17.1192H121.726V14.4952H117.731V13.1535H122.174V10.2623H114.481V21.3987V21.3977ZM127.288 15.524C128.108 15.524 128.75 15.1363 128.75 14.3611C128.75 13.5858 128.108 13.1982 127.274 13.1982H126.588V15.524H127.288ZM132.61 21.3977H128.779L126.662 17.9537H126.587V21.3977H123.337V10.2623H127.303C130.091 10.2623 132.028 11.5 132.028 14.1386C132.028 15.182 131.566 16.7024 129.717 17.4777L132.609 21.3987L132.61 21.3977Z",
      fill: "#0A0A0A"
    }
  ) }),
  /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_11981_28600", children: /* @__PURE__ */ s.jsx("rect", { width: 133, height: 32, fill: "white" }) }) })
] }), B4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 96 32", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_11981_28586)", children: [
    /* @__PURE__ */ s.jsx("path", { d: "M88.4754 21.5191L88.5014 21.5183H88.4492L88.4754 21.5191Z", fill: "#E40784" }),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M82.2857 23.4141C81.6014 23.4139 80.9323 23.2107 80.3635 22.8302C79.7944 22.4498 79.3511 21.9092 79.0895 21.2768C78.8275 20.6444 78.7592 19.9486 78.8928 19.2773C79.0267 18.6061 79.3564 17.9895 79.8403 17.5056C80.3245 17.0217 80.9411 16.6922 81.6123 16.5588C82.2835 16.4253 82.9794 16.4939 83.6116 16.7559C84.2441 17.0178 84.7845 17.4614 85.1648 18.0305C85.545 18.5996 85.748 19.2686 85.748 19.953C85.7473 20.871 85.3824 21.7511 84.733 22.4C84.084 23.049 83.2039 23.4137 82.2857 23.4141ZM82.2857 18.5166C82.0019 18.5171 81.7244 18.6019 81.4884 18.7601C81.2527 18.9183 81.0688 19.1429 80.9604 19.4054C80.8521 19.668 80.824 19.9568 80.8799 20.2353C80.9358 20.5138 81.0728 20.7695 81.2739 20.9702C81.4749 21.1708 81.7309 21.3074 82.0094 21.3625C82.2882 21.4177 82.577 21.3891 82.8392 21.2802C83.1015 21.1714 83.3256 20.9872 83.4833 20.751C83.6413 20.5148 83.7252 20.2371 83.7252 19.9531C83.7246 19.5718 83.5726 19.2065 83.3025 18.9372C83.0328 18.6679 82.6672 18.5166 82.2857 18.5166Z",
        fill: "#E40784"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M82.2873 7.80487C81.8075 7.80515 81.3283 7.83349 80.8516 7.88974V10.08C82.2686 9.87385 83.7131 9.97502 85.0874 10.3766C86.4614 10.7782 87.7333 11.4709 88.816 12.4075C89.899 13.3441 90.7675 14.5028 91.3629 15.8049C91.9582 17.1069 92.2664 18.5219 92.2664 19.9536C92.2673 20.4345 92.2323 20.9148 92.1618 21.3904H94.3528C94.5569 19.6855 94.3968 17.9566 93.8835 16.318C93.3703 14.6794 92.5155 13.1683 91.3754 11.8844C90.2349 10.6005 88.8353 9.57304 87.269 8.86983C85.7025 8.16661 84.0044 7.80364 82.2873 7.80487Z",
        fill: "#E40784"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M82.2873 12.0686C81.8059 12.0691 81.3252 12.1138 80.8516 12.2021V14.4233C81.6964 14.2039 82.5802 14.1809 83.4353 14.356C84.2904 14.5311 85.094 14.8997 85.7846 15.4335C86.4751 15.9674 87.034 16.6523 87.4189 17.4357C87.8035 18.2192 88.004 19.0803 88.0043 19.9531C88.0036 20.4378 87.9421 20.9206 87.821 21.39H90.042C90.1288 20.9159 90.1725 20.435 90.1728 19.9531C90.1703 17.8626 89.3389 15.8584 87.8603 14.3803C86.3821 12.9021 84.3778 12.0708 82.2873 12.0686Z",
        fill: "#E40784"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M40.9956 12.1082H39.2851C38.3566 12.1092 37.4666 12.4785 36.81 13.135C36.1535 13.7915 35.7845 14.6816 35.7832 15.61V21.5017H38.2143V15.61C38.2146 15.3261 38.3276 15.054 38.5283 14.8533C38.7291 14.6527 39.0013 14.5398 39.2851 14.5396H40.9956V12.1082Z",
        fill: "#1E1715"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M46.2476 19.0704C45.7974 19.0704 45.3569 18.9369 44.9826 18.6867C44.608 18.4365 44.3161 18.0809 44.1437 17.6648C43.9714 17.2487 43.9261 16.7909 44.0142 16.3491C44.1019 15.9074 44.3186 15.5016 44.637 15.1831C44.9554 14.8646 45.3613 14.6477 45.8031 14.5598C46.2448 14.4719 46.7025 14.517 47.1186 14.6893C47.5348 14.8616 47.8904 15.1535 48.1408 15.5279C48.3911 15.9024 48.5245 16.3426 48.5248 16.793C48.5238 17.3967 48.2838 17.9755 47.857 18.4024C47.4302 18.8294 46.8514 19.0696 46.2476 19.0704ZM46.2476 12.0854C45.5286 12.0845 44.819 12.2482 44.1731 12.564C43.5271 12.8799 42.9621 13.3395 42.5216 13.9076C42.0807 14.4757 41.776 15.1371 41.6306 15.8413C41.4851 16.5454 41.5029 17.2735 41.6824 17.9697C41.8619 18.6659 42.1984 19.3117 42.6664 19.8577C43.1344 20.4036 43.721 20.8351 44.3816 21.1192C45.0422 21.4032 45.759 21.5322 46.4771 21.4962C47.1951 21.4603 47.8954 21.2603 48.5241 20.9117V21.5021H50.9555V16.799V16.793C50.9543 15.5448 50.4579 14.3482 49.5753 13.4656C48.6924 12.5831 47.4958 12.0867 46.2476 12.0854Z",
        fill: "#1E1715"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M23.3454 18.8336C22.9153 19.3767 22.3268 19.7724 21.6616 19.9658C20.9963 20.1592 20.2874 20.1408 19.6331 19.9131C18.9788 19.6854 18.4117 19.2596 18.0103 18.6949C17.609 18.1303 17.3933 17.4547 17.3933 16.7619C17.3933 16.0691 17.609 15.3935 18.0103 14.8289C18.4117 14.2642 18.9788 13.8385 19.6331 13.6108C20.2874 13.383 20.9963 13.3646 21.6616 13.558C22.3268 13.7515 22.9153 14.1471 23.3454 14.6902L23.3997 14.7579L24.3972 13.7604L24.3512 13.7058C23.7247 12.9633 22.8853 12.4313 21.9464 12.1818C21.0076 11.9324 20.0147 11.9774 19.1024 12.3109C18.1899 12.6444 17.4021 13.2502 16.8454 14.0464C16.2888 14.8425 15.9902 15.7905 15.9902 16.7619C15.9902 17.7334 16.2888 18.6813 16.8454 19.4775C17.4021 20.2736 18.1899 20.8794 19.1024 21.2129C20.0147 21.5464 21.0076 21.5915 21.9464 21.342C22.8853 21.0925 23.7247 20.5605 24.3512 19.8181L24.3972 19.7635L23.3997 18.7659L23.3454 18.8336Z",
        fill: "#1E1715"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M10.164 12.0229C9.30983 12.0227 8.47153 12.2534 7.73771 12.6904C7.0039 13.1275 6.40186 13.7548 5.99526 14.506C5.58865 15.2571 5.39259 16.1042 5.42787 16.9576C5.46315 17.811 5.72839 18.639 6.19559 19.354C6.66279 20.0691 7.31456 20.6445 8.08194 21.0196C8.84931 21.3946 9.70379 21.5554 10.555 21.4847C11.4062 21.414 12.2225 21.1146 12.9175 20.6181C13.6125 20.1216 14.1604 19.4465 14.5033 18.6642L14.5508 18.5558H12.9756L12.9524 18.5906C12.5919 19.1408 12.0767 19.5722 11.4716 19.8303C10.8666 20.0884 10.1987 20.1618 9.552 20.0412C8.90532 19.9207 8.30872 19.6115 7.83736 19.1526C7.36598 18.6938 7.04086 18.1058 6.9029 17.4625H14.8502L14.8596 17.3956C14.888 17.1853 14.9025 16.9734 14.903 16.7612C14.9014 15.5048 14.4016 14.3004 13.5132 13.4121C12.6248 12.5238 11.4203 12.0242 10.164 12.0229ZM6.90253 16.0605C7.06271 15.3145 7.47381 14.646 8.06723 14.1665C8.66068 13.6869 9.40059 13.4253 10.1636 13.4253C10.9266 13.4253 11.6664 13.6869 12.2599 14.1665C12.8533 14.646 13.2644 15.3145 13.4246 16.0605H6.90253Z",
        fill: "#1E1715"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M25.7227 21.5014H27.1251V16.1761C27.1241 15.8123 27.1948 15.4518 27.3334 15.1153C27.4719 14.7789 27.6754 14.4731 27.9324 14.2154C28.1893 13.9578 28.4945 13.7534 28.8306 13.6139C29.1666 13.4744 29.5269 13.4026 29.8907 13.4026C30.2547 13.4026 30.615 13.4744 30.9509 13.6139C31.2871 13.7534 31.5921 13.9578 31.8491 14.2154C32.106 14.4731 32.3096 14.7789 32.4482 15.1153C32.5868 15.4518 32.6574 15.8123 32.6564 16.1761V21.501H34.0591V15.9929H34.0541C34.0198 15.206 33.7635 14.4448 33.3142 13.7978C32.865 13.1508 32.2415 12.6444 31.516 12.3375C30.7904 12.0306 29.9929 11.9357 29.2157 12.0639C28.4385 12.1921 27.7136 12.538 27.1251 13.0616V7.89789H25.7227V21.5014Z",
        fill: "#1E1715"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M0.522928 12.024H-1.09375V13.4264H0.522928V18.5274C0.523817 19.3161 0.837502 20.0722 1.39516 20.6298C1.95282 21.1875 2.70894 21.5012 3.49758 21.502H4.96471V20.0992H3.49758C3.08086 20.0987 2.68134 19.933 2.38669 19.6383C2.09201 19.3436 1.92625 18.9441 1.92576 18.5274V13.4264H4.19602V12.024H1.92576V8.78503H0.522928V12.024Z",
        fill: "#1E1715"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M59.044 12.6627C58.5669 12.4028 58.0484 12.2281 57.5111 12.1467C57.458 12.1385 57.4049 12.1292 57.3509 12.1225C57.2913 12.1149 57.231 12.1097 57.1708 12.1045C57.0562 12.0948 56.941 12.0884 56.8243 12.0869C56.8121 12.0869 56.7999 12.0854 56.788 12.0854L56.7793 12.0858L56.7671 12.0854C55.5183 12.0854 54.3208 12.5815 53.4379 13.4645C52.5547 14.3475 52.0586 15.5451 52.0586 16.7938C52.0586 18.0425 52.5547 19.2401 53.4379 20.1231C54.3208 21.0061 55.5183 21.5022 56.7671 21.5022C56.7709 21.5022 56.7737 21.5014 56.7774 21.5014C56.7809 21.5014 56.7843 21.5022 56.788 21.5022C56.9391 21.5022 57.0877 21.4924 57.2357 21.4779C57.2426 21.4775 57.2501 21.4764 57.2573 21.476C57.892 21.413 58.507 21.221 59.0649 20.9118V21.5021H61.4944L61.476 7.89789H59.044V12.6627ZM59.044 16.7949C59.0436 17.3985 58.8036 17.9772 58.3765 18.4038C57.9494 18.8304 57.3703 19.0698 56.7668 19.0696C56.1633 19.0694 55.5845 18.8295 55.1578 18.4026C54.731 17.9757 54.4912 17.3968 54.4912 16.7932C54.4912 16.1896 54.731 15.6107 55.1578 15.1839C55.5845 14.757 56.1633 14.517 56.7668 14.5168C57.3703 14.5166 57.9494 14.7561 58.3765 15.1827C58.8036 15.6092 59.0436 16.1879 59.044 16.7915V16.7949Z",
        fill: "#1E1715"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M69.7473 21.4842H72.1774V16.7822C72.1761 15.7481 71.8349 14.7432 71.2065 13.9221C70.578 13.101 69.697 12.5093 68.6992 12.2382C67.7011 11.967 66.6419 12.0314 65.6844 12.4215C64.7265 12.8115 63.9239 13.5056 63.3994 14.3968C62.8749 15.2879 62.6579 16.3268 62.7822 17.3534C62.9061 18.3799 63.3641 19.3373 64.0859 20.0779C64.8074 20.8185 65.7524 21.3014 66.7755 21.4522C67.7985 21.6029 68.8425 21.4132 69.7473 20.9122V21.4842ZM67.4701 19.0711C67.0199 19.0711 66.5797 18.9376 66.2054 18.6875C65.8311 18.4373 65.5392 18.0818 65.3668 17.6658C65.1945 17.2499 65.1496 16.7922 65.2373 16.3506C65.325 15.909 65.5417 15.5033 65.8601 15.1849C66.1782 14.8664 66.5838 14.6495 67.0255 14.5615C67.467 14.4735 67.9247 14.5184 68.3408 14.6905C68.7567 14.8627 69.1126 15.1543 69.3626 15.5285C69.613 15.9027 69.7469 16.3428 69.7473 16.793V16.7957C69.7463 17.3992 69.5062 17.9778 69.0792 18.4044C68.6524 18.831 68.0736 19.0708 67.4701 19.0711Z",
        fill: "#1E1715"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M77.1831 12.0869C76.2547 12.0882 75.3643 12.4576 74.7077 13.1141C74.0509 13.7706 73.6812 14.6606 73.6797 15.5891V21.5022H76.1139V15.5891C76.1139 15.3054 76.2263 15.0332 76.4267 14.8325C76.6274 14.6316 76.8994 14.5187 77.1831 14.5183H78.8955V12.0869L77.1831 12.0869Z",
        fill: "#1E1715"
      }
    )
  ] }),
  /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_11981_28586", children: /* @__PURE__ */ s.jsx("rect", { width: 96, height: 32, fill: "white" }) }) })
] }), z4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 55.71 55.71", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M20.2048 28.4925C21.2609 28.4925 22.117 29.3486 22.117 30.4048C22.117 31.4609 21.2609 32.317 20.2048 32.317H7.45619C6.40007 32.317 5.54391 31.4609 5.54391 30.4048C5.54391 29.3486 6.40007 28.4925 7.45619 28.4925H20.2048Z",
      fill: "#FF00FF"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M38.6902 22.7556C38.6902 21.9103 38.3542 21.0999 37.7565 20.5022C37.1588 19.9045 36.3483 19.5685 35.5031 19.5685H29.7662V28.4925H35.5031C36.3483 28.4925 37.1588 28.1564 37.7565 27.5587C38.3542 26.961 38.6902 26.1506 38.6902 25.3053V22.7556ZM42.5148 25.3053C42.5148 27.1649 41.7755 28.9479 40.4606 30.2628C39.1456 31.5778 37.3627 32.317 35.5031 32.317H29.7662V38.0539C29.7662 39.11 28.91 39.9662 27.8539 39.9662C26.7978 39.9662 25.9416 39.11 25.9416 38.0539V17.6562C25.9416 16.6001 26.7978 15.7439 27.8539 15.7439H35.5031C37.3627 15.7439 39.1456 16.4832 40.4606 17.7981C41.7755 19.1131 42.5148 20.896 42.5148 22.7556V25.3053Z",
      fill: "#FF00FF"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M46.3393 38.0539V17.6562C46.3393 16.6001 47.1955 15.7439 48.2516 15.7439C49.3077 15.7439 50.1639 16.6001 50.1639 17.6562V38.0539C50.1639 39.11 49.3077 39.9662 48.2516 39.9662C47.1955 39.9662 46.3393 39.11 46.3393 38.0539Z",
      fill: "#FF00FF"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M18.2925 38.0539V24.0305C18.2925 22.8471 17.822 21.7125 16.9853 20.8757C16.1485 20.0389 15.0139 19.5685 13.8305 19.5685C12.6471 19.5685 11.5125 20.0389 10.6757 20.8757C9.83892 21.7125 9.36848 22.8471 9.36848 24.0305V38.0539C9.36848 39.11 8.51232 39.9662 7.45619 39.9662C6.40007 39.9662 5.54391 39.11 5.54391 38.0539V24.0305C5.54391 21.8327 6.41758 19.7256 7.97161 18.1716C9.52565 16.6176 11.6327 15.7439 13.8305 15.7439C16.0282 15.7439 18.1353 16.6176 19.6893 18.1716C21.2434 19.7256 22.117 21.8327 22.117 24.0305V38.0539C22.117 39.11 21.2609 39.9662 20.2048 39.9662C19.1486 39.9662 18.2925 39.11 18.2925 38.0539Z",
      fill: "#FF00FF"
    }
  )
] }), xs = Zl(null), Hc = () => {
  const e = Ul(xs);
  if (!e)
    throw new Error("useLinkComponent must be used within a LinkContextProvider");
  return e;
}, Ae = fs(({ scope: e, ...t }, n) => {
  const { LinkComponent: o, scope: r } = Hc();
  return r === e || !e ? /* @__PURE__ */ s.jsx(o, { ...t }) : /* @__PURE__ */ s.jsx("a", { ...t, ref: n });
}), $c = ({ children: e, LinkComponent: t, scope: n }) => /* @__PURE__ */ s.jsx(xs.Provider, { value: { LinkComponent: t, scope: n }, children: e });
var ie = /* @__PURE__ */ ((e) => (e.Microsite = "microsite", e.Docs = "docs", e.Blog = "blog", e.App = "app", e))(ie || {});
function Cs(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = Cs(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function bs() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = Cs(e)) && (o && (o += " "), o += t);
  return o;
}
const jr = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Pr = bs, Bt = (e, t) => (n) => {
  var o;
  if ((t == null ? void 0 : t.variants) == null) return Pr(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: r, defaultVariants: a } = t, i = Object.keys(r).map((u) => {
    const f = n == null ? void 0 : n[u], m = a == null ? void 0 : a[u];
    if (f === null) return null;
    const g = jr(f) || jr(m);
    return r[u][g];
  }), l = n && Object.entries(n).reduce((u, f) => {
    let [m, g] = f;
    return g === void 0 || (u[m] = g), u;
  }, {}), c = t == null || (o = t.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((u, f) => {
    let { class: m, className: g, ...x } = f;
    return Object.entries(x).every((b) => {
      let [p, v] = b;
      return Array.isArray(v) ? v.includes({
        ...a,
        ...l
      }[p]) : {
        ...a,
        ...l
      }[p] === v;
    }) ? [
      ...u,
      m,
      g
    ] : u;
  }, []);
  return Pr(e, i, c, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, _o = "-", Bc = (e) => {
  const t = Wc(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: o
  } = e;
  return {
    getClassGroupId: (i) => {
      const l = i.split(_o);
      return l[0] === "" && l.length !== 1 && l.shift(), ws(l, t) || zc(i);
    },
    getConflictingClassGroupIds: (i, l) => {
      const c = n[i] || [];
      return l && o[i] ? [...c, ...o[i]] : c;
    }
  };
}, ws = (e, t) => {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], o = t.nextPart.get(n), r = o ? ws(e.slice(1), o) : void 0;
  if (r)
    return r;
  if (t.validators.length === 0)
    return;
  const a = e.join(_o);
  return (i = t.validators.find(({
    validator: l
  }) => l(a))) == null ? void 0 : i.classGroupId;
}, Nr = /^\[(.+)\]$/, zc = (e) => {
  if (Nr.test(e)) {
    const t = Nr.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, Wc = (e) => {
  const {
    theme: t,
    classGroups: n
  } = e, o = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const r in n)
    lo(n[r], o, r, t);
  return o;
}, lo = (e, t, n, o) => {
  e.forEach((r) => {
    if (typeof r == "string") {
      const a = r === "" ? t : _r(t, r);
      a.classGroupId = n;
      return;
    }
    if (typeof r == "function") {
      if (Gc(r)) {
        lo(r(o), t, n, o);
        return;
      }
      t.validators.push({
        validator: r,
        classGroupId: n
      });
      return;
    }
    Object.entries(r).forEach(([a, i]) => {
      lo(i, _r(t, a), n, o);
    });
  });
}, _r = (e, t) => {
  let n = e;
  return t.split(_o).forEach((o) => {
    n.nextPart.has(o) || n.nextPart.set(o, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(o);
  }), n;
}, Gc = (e) => e.isThemeGetter, Zc = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  const r = (a, i) => {
    n.set(a, i), t++, t > e && (t = 0, o = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let i = n.get(a);
      if (i !== void 0)
        return i;
      if ((i = o.get(a)) !== void 0)
        return r(a, i), i;
    },
    set(a, i) {
      n.has(a) ? n.set(a, i) : r(a, i);
    }
  };
}, co = "!", uo = ":", Uc = uo.length, Kc = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: n
  } = e;
  let o = (r) => {
    const a = [];
    let i = 0, l = 0, c = 0, u;
    for (let b = 0; b < r.length; b++) {
      let p = r[b];
      if (i === 0 && l === 0) {
        if (p === uo) {
          a.push(r.slice(c, b)), c = b + Uc;
          continue;
        }
        if (p === "/") {
          u = b;
          continue;
        }
      }
      p === "[" ? i++ : p === "]" ? i-- : p === "(" ? l++ : p === ")" && l--;
    }
    const f = a.length === 0 ? r : r.substring(c), m = Yc(f), g = m !== f, x = u && u > c ? u - c : void 0;
    return {
      modifiers: a,
      hasImportantModifier: g,
      baseClassName: m,
      maybePostfixModifierPosition: x
    };
  };
  if (t) {
    const r = t + uo, a = o;
    o = (i) => i.startsWith(r) ? a(i.substring(r.length)) : {
      isExternal: !0,
      modifiers: [],
      hasImportantModifier: !1,
      baseClassName: i,
      maybePostfixModifierPosition: void 0
    };
  }
  if (n) {
    const r = o;
    o = (a) => n({
      className: a,
      parseClassName: r
    });
  }
  return o;
}, Yc = (e) => e.endsWith(co) ? e.substring(0, e.length - 1) : e.startsWith(co) ? e.substring(1) : e, Xc = (e) => {
  const t = Object.fromEntries(e.orderSensitiveModifiers.map((o) => [o, !0]));
  return (o) => {
    if (o.length <= 1)
      return o;
    const r = [];
    let a = [];
    return o.forEach((i) => {
      i[0] === "[" || t[i] ? (r.push(...a.sort(), i), a = []) : a.push(i);
    }), r.push(...a.sort()), r;
  };
}, qc = (e) => ({
  cache: Zc(e.cacheSize),
  parseClassName: Kc(e),
  sortModifiers: Xc(e),
  ...Bc(e)
}), Jc = /\s+/, Qc = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: o,
    getConflictingClassGroupIds: r,
    sortModifiers: a
  } = t, i = [], l = e.trim().split(Jc);
  let c = "";
  for (let u = l.length - 1; u >= 0; u -= 1) {
    const f = l[u], {
      isExternal: m,
      modifiers: g,
      hasImportantModifier: x,
      baseClassName: b,
      maybePostfixModifierPosition: p
    } = n(f);
    if (m) {
      c = f + (c.length > 0 ? " " + c : c);
      continue;
    }
    let v = !!p, w = o(v ? b.substring(0, p) : b);
    if (!w) {
      if (!v) {
        c = f + (c.length > 0 ? " " + c : c);
        continue;
      }
      if (w = o(b), !w) {
        c = f + (c.length > 0 ? " " + c : c);
        continue;
      }
      v = !1;
    }
    const C = a(g).join(":"), y = x ? C + co : C, S = y + w;
    if (i.includes(S))
      continue;
    i.push(S);
    const E = r(w, v);
    for (let M = 0; M < E.length; ++M) {
      const j = E[M];
      i.push(y + j);
    }
    c = f + (c.length > 0 ? " " + c : c);
  }
  return c;
};
function e1() {
  let e = 0, t, n, o = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = ys(t)) && (o && (o += " "), o += n);
  return o;
}
const ys = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let o = 0; o < e.length; o++)
    e[o] && (t = ys(e[o])) && (n && (n += " "), n += t);
  return n;
};
function kr(e, ...t) {
  let n, o, r, a = i;
  function i(c) {
    const u = t.reduce((f, m) => m(f), e());
    return n = qc(u), o = n.cache.get, r = n.cache.set, a = l, l(c);
  }
  function l(c) {
    const u = o(c);
    if (u)
      return u;
    const f = Qc(c, n);
    return r(c, f), f;
  }
  return function() {
    return a(e1.apply(null, arguments));
  };
}
const he = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, Ss = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Es = /^\((?:(\w[\w-]*):)?(.+)\)$/i, t1 = /^\d+\/\d+$/, n1 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, o1 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, r1 = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, s1 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, a1 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, bt = (e) => t1.test(e), W = (e) => !!e && !Number.isNaN(Number(e)), qe = (e) => !!e && Number.isInteger(Number(e)), Yn = (e) => e.endsWith("%") && W(e.slice(0, -1)), We = (e) => n1.test(e), i1 = () => !0, l1 = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  o1.test(e) && !r1.test(e)
), Rs = () => !1, c1 = (e) => s1.test(e), d1 = (e) => a1.test(e), u1 = (e) => !T(e) && !I(e), f1 = (e) => Nt(e, Ps, Rs), T = (e) => Ss.test(e), lt = (e) => Nt(e, Ns, l1), Xn = (e) => Nt(e, v1, W), Ar = (e) => Nt(e, Ms, Rs), p1 = (e) => Nt(e, js, d1), Xt = (e) => Nt(e, _s, c1), I = (e) => Es.test(e), Lt = (e) => _t(e, Ns), m1 = (e) => _t(e, x1), Tr = (e) => _t(e, Ms), h1 = (e) => _t(e, Ps), g1 = (e) => _t(e, js), qt = (e) => _t(e, _s, !0), Nt = (e, t, n) => {
  const o = Ss.exec(e);
  return o ? o[1] ? t(o[1]) : n(o[2]) : !1;
}, _t = (e, t, n = !1) => {
  const o = Es.exec(e);
  return o ? o[1] ? t(o[1]) : n : !1;
}, Ms = (e) => e === "position" || e === "percentage", js = (e) => e === "image" || e === "url", Ps = (e) => e === "length" || e === "size" || e === "bg-size", Ns = (e) => e === "length", v1 = (e) => e === "number", x1 = (e) => e === "family-name", _s = (e) => e === "shadow", Ir = () => {
  const e = he("color"), t = he("font"), n = he("text"), o = he("font-weight"), r = he("tracking"), a = he("leading"), i = he("breakpoint"), l = he("container"), c = he("spacing"), u = he("radius"), f = he("shadow"), m = he("inset-shadow"), g = he("text-shadow"), x = he("drop-shadow"), b = he("blur"), p = he("perspective"), v = he("aspect"), w = he("ease"), C = he("animate"), y = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], S = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], E = () => [...S(), I, T], M = () => ["auto", "hidden", "clip", "visible", "scroll"], j = () => ["auto", "contain", "none"], R = () => [I, T, c], _ = () => [bt, "full", "auto", ...R()], L = () => [qe, "none", "subgrid", I, T], B = () => ["auto", {
    span: ["full", qe, I, T]
  }, qe, I, T], X = () => [qe, "auto", I, T], $ = () => ["auto", "min", "max", "fr", I, T], z = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], G = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], D = () => ["auto", ...R()], Z = () => [bt, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...R()], P = () => [e, I, T], te = () => [...S(), Tr, Ar, {
    position: [I, T]
  }], fe = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], ge = () => ["auto", "cover", "contain", h1, f1, {
    size: [I, T]
  }], Re = () => [Yn, Lt, lt], le = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    u,
    I,
    T
  ], ce = () => ["", W, Lt, lt], Se = () => ["solid", "dashed", "dotted", "double"], be = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], A = () => [W, Yn, Tr, Ar], Q = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    b,
    I,
    T
  ], ae = () => ["none", W, I, T], U = () => ["none", W, I, T], q = () => [W, I, T], K = () => [bt, "full", ...R()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [We],
      breakpoint: [We],
      color: [i1],
      container: [We],
      "drop-shadow": [We],
      ease: ["in", "out", "in-out"],
      font: [u1],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [We],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [We],
      shadow: [We],
      spacing: ["px", W],
      text: [We],
      "text-shadow": [We],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", bt, T, I, v]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [W, T, I, l]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": y()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": y()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: E()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: M()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": M()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": M()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: j()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": j()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": j()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: _()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": _()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": _()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: _()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: _()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: _()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: _()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: _()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: _()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [qe, "auto", I, T]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [bt, "full", "auto", l, ...R()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [W, bt, "auto", "initial", "none", T]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", W, I, T]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", W, I, T]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [qe, "first", "last", "none", I, T]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": L()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: B()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": X()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": X()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": L()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: B()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": X()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": X()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": $()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": $()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: R()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": R()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": R()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...z(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...G(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...G()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...z()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...G(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...G(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": z()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...G(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...G()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: R()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: R()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: R()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: R()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: R()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: R()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: R()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: R()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: R()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: D()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: D()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: D()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: D()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: D()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: D()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: D()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: D()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: D()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": R()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": R()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: Z()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [l, "screen", ...Z()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          l,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...Z()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          l,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [i]
          },
          ...Z()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...Z()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...Z()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...Z()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", n, Lt, lt]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [o, I, Xn]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Yn, T]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [m1, T, t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [r, I, T]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [W, "none", I, Xn]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          a,
          ...R()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", I, T]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", I, T]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: P()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: P()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Se(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [W, "from-font", "auto", I, lt]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: P()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [W, "auto", I, T]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: R()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", I, T]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", I, T]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: te()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: fe()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ge()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, qe, I, T],
          radial: ["", I, T],
          conic: [qe, I, T]
        }, g1, p1]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: P()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: Re()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: Re()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: Re()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: P()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: P()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: P()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: le()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": le()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": le()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": le()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": le()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": le()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": le()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": le()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": le()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": le()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": le()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": le()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": le()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": le()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": le()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: ce()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": ce()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": ce()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": ce()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": ce()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": ce()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": ce()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": ce()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": ce()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": ce()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": ce()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Se(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...Se(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: P()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": P()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": P()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": P()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": P()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": P()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": P()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": P()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": P()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: P()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...Se(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [W, I, T]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", W, Lt, lt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: P()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          f,
          qt,
          Xt
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: P()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", m, qt, Xt]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": P()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: ce()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: P()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [W, lt]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": P()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": ce()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": P()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", g, qt, Xt]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": P()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [W, I, T]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...be(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": be()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [W]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": A()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": A()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": P()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": P()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": A()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": A()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": P()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": P()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": A()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": A()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": P()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": P()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": A()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": A()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": P()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": P()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": A()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": A()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": P()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": P()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": A()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": A()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": P()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": P()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": A()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": A()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": P()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": P()
      }],
      "mask-image-radial": [{
        "mask-radial": [I, T]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": A()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": A()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": P()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": P()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": S()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [W]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": A()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": A()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": P()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": P()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: te()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: fe()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: ge()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", I, T]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          I,
          T
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: Q()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [W, I, T]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [W, I, T]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          x,
          qt,
          Xt
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": P()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", W, I, T]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [W, I, T]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", W, I, T]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [W, I, T]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", W, I, T]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          I,
          T
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": Q()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [W, I, T]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [W, I, T]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", W, I, T]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [W, I, T]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", W, I, T]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [W, I, T]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [W, I, T]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", W, I, T]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": R()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": R()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": R()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", I, T]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [W, "initial", I, T]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", w, I, T]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [W, I, T]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", C, I, T]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [p, I, T]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": E()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: ae()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": ae()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": ae()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": ae()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: U()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": U()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": U()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": U()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: q()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": q()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": q()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [I, T, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: E()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: K()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": K()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": K()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": K()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: P()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: P()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", I, T]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": R()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": R()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": R()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": R()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": R()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": R()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": R()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": R()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": R()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": R()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": R()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": R()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": R()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": R()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": R()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": R()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": R()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": R()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", I, T]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...P()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [W, Lt, lt, Xn]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...P()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, C1 = (e, {
  cacheSize: t,
  prefix: n,
  experimentalParseClassName: o,
  extend: r = {},
  override: a = {}
}) => (Dt(e, "cacheSize", t), Dt(e, "prefix", n), Dt(e, "experimentalParseClassName", o), Jt(e.theme, a.theme), Jt(e.classGroups, a.classGroups), Jt(e.conflictingClassGroups, a.conflictingClassGroups), Jt(e.conflictingClassGroupModifiers, a.conflictingClassGroupModifiers), Dt(e, "orderSensitiveModifiers", a.orderSensitiveModifiers), Qt(e.theme, r.theme), Qt(e.classGroups, r.classGroups), Qt(e.conflictingClassGroups, r.conflictingClassGroups), Qt(e.conflictingClassGroupModifiers, r.conflictingClassGroupModifiers), ks(e, r, "orderSensitiveModifiers"), e), Dt = (e, t, n) => {
  n !== void 0 && (e[t] = n);
}, Jt = (e, t) => {
  if (t)
    for (const n in t)
      Dt(e, n, t[n]);
}, Qt = (e, t) => {
  if (t)
    for (const n in t)
      ks(e, t, n);
}, ks = (e, t, n) => {
  const o = t[n];
  o !== void 0 && (e[n] = e[n] ? e[n].concat(o) : o);
}, b1 = (e, ...t) => typeof e == "function" ? kr(Ir, e, ...t) : kr(() => C1(Ir(), e), ...t), w1 = b1({
  extend: {
    classGroups: {
      "font-size": [
        "text-heading-h1",
        "text-heading-h2",
        "text-heading-h3",
        "text-paragraph-big",
        "text-paragraph-medium",
        "text-paragraph-medium-bold",
        "text-paragraph-small",
        "text-paragraph-small-bold",
        "text-paragraph-extrasmall",
        "text-paragraph-extrasmall-bold",
        "text-button-big",
        "text-button-small",
        "text-link-big",
        "text-link-medium",
        "text-link-medium-bold",
        "text-link-small",
        "text-link-extrasmall",
        "text-link-extrasmall-bold",
        "text-code-small",
        "text-code-medium",
        "text-code-large"
      ]
    }
  }
});
function O(...e) {
  return w1(bs(e));
}
const en = "text-accent-primary underline hover:text-accent-secondary hover:no-underline transition-all", y1 = Bt("", {
  variants: {
    variant: {
      "Heading/Hero": "text-heading-hero",
      "Heading/H1": "text-heading-h1",
      "Heading/H2": "text-heading-h2",
      "Heading/H3": "text-heading-h3",
      "Heading/H4": "text-heading-h4",
      "Paragraph/Big": "text-paragraph-big",
      "Paragraph/Medium": "text-paragraph-medium",
      "Paragraph/Medium/Bold": "text-paragraph-medium-bold",
      "Paragraph/Small": "text-paragraph-small",
      "Paragraph/Small/Bold": "text-paragraph-small-bold",
      "Paragraph/ExtraSmall": "text-paragraph-extrasmall",
      "Paragraph/ExtraSmall/Bold": "text-paragraph-extrasmall-bold",
      "Link/Big": O("text-link-big", en),
      "Link/Medium": O("text-link-medium", en),
      "Link/Medium/Bold": O("text-link-medium-bold", en),
      "Link/Small": O("text-link-small", en),
      Label: "text-label",
      "Code/Small": "text-code-small",
      "Code/Medium": "text-code-medium",
      "Code/Large": "text-code-large"
    }
  }
}), As = ({ as: e, variant: t, className: n, children: o }) => ln(e, { className: y1({ variant: t, className: n }) }, o), S1 = Bt("inline-flex items-center rounded-full px-3 py-1", {
  variants: {
    tone: {
      danger: "bg-status-danger-bg text-status-danger-text",
      success: "bg-status-success-bg text-status-success-text",
      warning: "bg-status-warning-bg text-status-warning-text"
    }
  }
}), W4 = ({ tone: e, className: t, children: n }) => /* @__PURE__ */ s.jsx(As, { as: "span", variant: "Paragraph/ExtraSmall/Bold", className: S1({ tone: e, className: t }), children: n }), E1 = ({ as: e = "span", variant: t, className: n, showArrow: o, children: r }) => /* @__PURE__ */ s.jsxs(As, { as: e, variant: t, className: O("flex items-center gap-2", n), children: [
  r,
  o && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    "⁠",
    /* @__PURE__ */ s.jsx(tt, { className: "size-4 rotate-270" })
  ] })
] });
function Or(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function ko(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((r) => {
      const a = Or(r, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let r = 0; r < o.length; r++) {
          const a = o[r];
          typeof a == "function" ? a() : Or(e[r], null);
        }
      };
  };
}
function ne(...e) {
  return d.useCallback(ko(...e), e);
}
// @__NO_SIDE_EFFECTS__
function dt(e) {
  const t = /* @__PURE__ */ R1(e), n = d.forwardRef((o, r) => {
    const { children: a, ...i } = o, l = d.Children.toArray(a), c = l.find(j1);
    if (c) {
      const u = c.props.children, f = l.map((m) => m === c ? d.Children.count(u) > 1 ? d.Children.only(null) : d.isValidElement(u) ? u.props.children : null : m);
      return /* @__PURE__ */ s.jsx(t, { ...i, ref: r, children: d.isValidElement(u) ? d.cloneElement(u, void 0, f) : null });
    }
    return /* @__PURE__ */ s.jsx(t, { ...i, ref: r, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
var Ts = /* @__PURE__ */ dt("Slot");
// @__NO_SIDE_EFFECTS__
function R1(e) {
  const t = d.forwardRef((n, o) => {
    const { children: r, ...a } = n;
    if (d.isValidElement(r)) {
      const i = N1(r), l = P1(a, r.props);
      return r.type !== d.Fragment && (l.ref = o ? ko(o, i) : i), d.cloneElement(r, l);
    }
    return d.Children.count(r) > 1 ? d.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var M1 = Symbol("radix.slottable");
function j1(e) {
  return d.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === M1;
}
function P1(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], a = t[o];
    /^on[A-Z]/.test(o) ? r && a ? n[o] = (...l) => {
      const c = a(...l);
      return r(...l), c;
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...a } : o === "className" && (n[o] = [r, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function N1(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var _1 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], V = _1.reduce((e, t) => {
  const n = /* @__PURE__ */ dt(`Primitive.${t}`), o = d.forwardRef((r, a) => {
    const { asChild: i, ...l } = r, c = i ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s.jsx(c, { ...l, ref: a });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function fo(e, t) {
  e && En.flushSync(() => e.dispatchEvent(t));
}
var Is = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), k1 = "VisuallyHidden", Os = d.forwardRef(
  (e, t) => /* @__PURE__ */ s.jsx(
    V.span,
    {
      ...e,
      ref: t,
      style: { ...Is, ...e.style }
    }
  )
);
Os.displayName = k1;
var A1 = Os;
function T1(e, t) {
  const n = d.createContext(t), o = (a) => {
    const { children: i, ...l } = a, c = d.useMemo(() => l, Object.values(l));
    return /* @__PURE__ */ s.jsx(n.Provider, { value: c, children: i });
  };
  o.displayName = e + "Provider";
  function r(a) {
    const i = d.useContext(n);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [o, r];
}
function He(e, t = []) {
  let n = [];
  function o(a, i) {
    const l = d.createContext(i), c = n.length;
    n = [...n, i];
    const u = (m) => {
      var w;
      const { scope: g, children: x, ...b } = m, p = ((w = g == null ? void 0 : g[e]) == null ? void 0 : w[c]) || l, v = d.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ s.jsx(p.Provider, { value: v, children: x });
    };
    u.displayName = a + "Provider";
    function f(m, g) {
      var p;
      const x = ((p = g == null ? void 0 : g[e]) == null ? void 0 : p[c]) || l, b = d.useContext(x);
      if (b) return b;
      if (i !== void 0) return i;
      throw new Error(`\`${m}\` must be used within \`${a}\``);
    }
    return [u, f];
  }
  const r = () => {
    const a = n.map((i) => d.createContext(i));
    return function(l) {
      const c = (l == null ? void 0 : l[e]) || a;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: c } }),
        [l, c]
      );
    };
  };
  return r.scopeName = e, [o, I1(r, ...t)];
}
function I1(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(a) {
      const i = o.reduce((l, { useScope: c, scopeName: u }) => {
        const m = c(a)[`__scope${u}`];
        return { ...l, ...m };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function zt(e) {
  const t = e + "CollectionProvider", [n, o] = He(t), [r, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (p) => {
    const { scope: v, children: w } = p, C = ee.useRef(null), y = ee.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ s.jsx(r, { scope: v, itemMap: y, collectionRef: C, children: w });
  };
  i.displayName = t;
  const l = e + "CollectionSlot", c = /* @__PURE__ */ dt(l), u = ee.forwardRef(
    (p, v) => {
      const { scope: w, children: C } = p, y = a(l, w), S = ne(v, y.collectionRef);
      return /* @__PURE__ */ s.jsx(c, { ref: S, children: C });
    }
  );
  u.displayName = l;
  const f = e + "CollectionItemSlot", m = "data-radix-collection-item", g = /* @__PURE__ */ dt(f), x = ee.forwardRef(
    (p, v) => {
      const { scope: w, children: C, ...y } = p, S = ee.useRef(null), E = ne(v, S), M = a(f, w);
      return ee.useEffect(() => (M.itemMap.set(S, { ref: S, ...y }), () => void M.itemMap.delete(S))), /* @__PURE__ */ s.jsx(g, { [m]: "", ref: E, children: C });
    }
  );
  x.displayName = f;
  function b(p) {
    const v = a(e + "CollectionConsumer", p);
    return ee.useCallback(() => {
      const C = v.collectionRef.current;
      if (!C) return [];
      const y = Array.from(C.querySelectorAll(`[${m}]`));
      return Array.from(v.itemMap.values()).sort(
        (M, j) => y.indexOf(M.ref.current) - y.indexOf(j.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: i, Slot: u, ItemSlot: x },
    b,
    o
  ];
}
function F(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
var me = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
}, O1 = d[" useInsertionEffect ".trim().toString()] || me;
function Ee({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: o
}) {
  const [r, a, i] = L1({
    defaultProp: t,
    onChange: n
  }), l = e !== void 0, c = l ? e : r;
  {
    const f = d.useRef(e !== void 0);
    d.useEffect(() => {
      const m = f.current;
      m !== l && console.warn(
        `${o} is changing from ${m ? "controlled" : "uncontrolled"} to ${l ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), f.current = l;
    }, [l, o]);
  }
  const u = d.useCallback(
    (f) => {
      var m;
      if (l) {
        const g = D1(f) ? f(e) : f;
        g !== e && ((m = i.current) == null || m.call(i, g));
      } else
        a(f);
    },
    [l, e, a, i]
  );
  return [c, u];
}
function L1({
  defaultProp: e,
  onChange: t
}) {
  const [n, o] = d.useState(e), r = d.useRef(n), a = d.useRef(t);
  return O1(() => {
    a.current = t;
  }, [t]), d.useEffect(() => {
    var i;
    r.current !== n && ((i = a.current) == null || i.call(a, n), r.current = n);
  }, [n, r]), [n, o, a];
}
function D1(e) {
  return typeof e == "function";
}
function F1(e, t) {
  return d.useReducer((n, o) => t[n][o] ?? n, e);
}
var $e = (e) => {
  const { present: t, children: n } = e, o = V1(t), r = typeof n == "function" ? n({ present: o.isPresent }) : d.Children.only(n), a = ne(o.ref, H1(r));
  return typeof n == "function" || o.isPresent ? d.cloneElement(r, { ref: a }) : null;
};
$e.displayName = "Presence";
function V1(e) {
  const [t, n] = d.useState(), o = d.useRef(null), r = d.useRef(e), a = d.useRef("none"), i = e ? "mounted" : "unmounted", [l, c] = F1(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const u = tn(o.current);
    a.current = l === "mounted" ? u : "none";
  }, [l]), me(() => {
    const u = o.current, f = r.current;
    if (f !== e) {
      const g = a.current, x = tn(u);
      e ? c("MOUNT") : x === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(f && g !== x ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, c]), me(() => {
    if (t) {
      let u;
      const f = t.ownerDocument.defaultView ?? window, m = (x) => {
        const p = tn(o.current).includes(CSS.escape(x.animationName));
        if (x.target === t && p && (c("ANIMATION_END"), !r.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, g = (x) => {
        x.target === t && (a.current = tn(o.current));
      };
      return t.addEventListener("animationstart", g), t.addEventListener("animationcancel", m), t.addEventListener("animationend", m), () => {
        f.clearTimeout(u), t.removeEventListener("animationstart", g), t.removeEventListener("animationcancel", m), t.removeEventListener("animationend", m);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: d.useCallback((u) => {
      o.current = u ? getComputedStyle(u) : null, n(u);
    }, [])
  };
}
function tn(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function H1(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var $1 = d[" useId ".trim().toString()] || (() => {
}), B1 = 0;
function Pe(e) {
  const [t, n] = d.useState($1());
  return me(() => {
    n((o) => o ?? String(B1++));
  }, [e]), t ? `radix-${t}` : "";
}
var Rn = "Collapsible", [z1, Ls] = He(Rn), [W1, Ao] = z1(Rn), Ds = d.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: o,
      defaultOpen: r,
      disabled: a,
      onOpenChange: i,
      ...l
    } = e, [c, u] = Ee({
      prop: o,
      defaultProp: r ?? !1,
      onChange: i,
      caller: Rn
    });
    return /* @__PURE__ */ s.jsx(
      W1,
      {
        scope: n,
        disabled: a,
        contentId: Pe(),
        open: c,
        onOpenToggle: d.useCallback(() => u((f) => !f), [u]),
        children: /* @__PURE__ */ s.jsx(
          V.div,
          {
            "data-state": Lo(c),
            "data-disabled": a ? "" : void 0,
            ...l,
            ref: t
          }
        )
      }
    );
  }
);
Ds.displayName = Rn;
var Fs = "CollapsibleTrigger", To = d.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...o } = e, r = Ao(Fs, n);
    return /* @__PURE__ */ s.jsx(
      V.button,
      {
        type: "button",
        "aria-controls": r.contentId,
        "aria-expanded": r.open || !1,
        "data-state": Lo(r.open),
        "data-disabled": r.disabled ? "" : void 0,
        disabled: r.disabled,
        ...o,
        ref: t,
        onClick: F(e.onClick, r.onOpenToggle)
      }
    );
  }
);
To.displayName = Fs;
var Io = "CollapsibleContent", Oo = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, r = Ao(Io, e.__scopeCollapsible);
    return /* @__PURE__ */ s.jsx($e, { present: n || r.open, children: ({ present: a }) => /* @__PURE__ */ s.jsx(G1, { ...o, ref: t, present: a }) });
  }
);
Oo.displayName = Io;
var G1 = d.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: o, children: r, ...a } = e, i = Ao(Io, n), [l, c] = d.useState(o), u = d.useRef(null), f = ne(t, u), m = d.useRef(0), g = m.current, x = d.useRef(0), b = x.current, p = i.open || l, v = d.useRef(p), w = d.useRef(void 0);
  return d.useEffect(() => {
    const C = requestAnimationFrame(() => v.current = !1);
    return () => cancelAnimationFrame(C);
  }, []), me(() => {
    const C = u.current;
    if (C) {
      w.current = w.current || {
        transitionDuration: C.style.transitionDuration,
        animationName: C.style.animationName
      }, C.style.transitionDuration = "0s", C.style.animationName = "none";
      const y = C.getBoundingClientRect();
      m.current = y.height, x.current = y.width, v.current || (C.style.transitionDuration = w.current.transitionDuration, C.style.animationName = w.current.animationName), c(o);
    }
  }, [i.open, o]), /* @__PURE__ */ s.jsx(
    V.div,
    {
      "data-state": Lo(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !p,
      ...a,
      ref: f,
      style: {
        "--radix-collapsible-content-height": g ? `${g}px` : void 0,
        "--radix-collapsible-content-width": b ? `${b}px` : void 0,
        ...e.style
      },
      children: p && r
    }
  );
});
function Lo(e) {
  return e ? "open" : "closed";
}
var Vs = Ds, Z1 = To, U1 = Oo, K1 = d.createContext(void 0);
function Wt(e) {
  const t = d.useContext(K1);
  return e || t || "ltr";
}
var Te = "Accordion", Y1 = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Do, X1, q1] = zt(Te), [Mn] = He(Te, [
  q1,
  Ls
]), Fo = Ls(), Hs = ee.forwardRef(
  (e, t) => {
    const { type: n, ...o } = e, r = o, a = o;
    return /* @__PURE__ */ s.jsx(Do.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ s.jsx(td, { ...a, ref: t }) : /* @__PURE__ */ s.jsx(ed, { ...r, ref: t }) });
  }
);
Hs.displayName = Te;
var [$s, J1] = Mn(Te), [Bs, Q1] = Mn(
  Te,
  { collapsible: !1 }
), ed = ee.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: o,
      onValueChange: r = () => {
      },
      collapsible: a = !1,
      ...i
    } = e, [l, c] = Ee({
      prop: n,
      defaultProp: o ?? "",
      onChange: r,
      caller: Te
    });
    return /* @__PURE__ */ s.jsx(
      $s,
      {
        scope: e.__scopeAccordion,
        value: ee.useMemo(() => l ? [l] : [], [l]),
        onItemOpen: c,
        onItemClose: ee.useCallback(() => a && c(""), [a, c]),
        children: /* @__PURE__ */ s.jsx(Bs, { scope: e.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ s.jsx(zs, { ...i, ref: t }) })
      }
    );
  }
), td = ee.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: o,
    onValueChange: r = () => {
    },
    ...a
  } = e, [i, l] = Ee({
    prop: n,
    defaultProp: o ?? [],
    onChange: r,
    caller: Te
  }), c = ee.useCallback(
    (f) => l((m = []) => [...m, f]),
    [l]
  ), u = ee.useCallback(
    (f) => l((m = []) => m.filter((g) => g !== f)),
    [l]
  );
  return /* @__PURE__ */ s.jsx(
    $s,
    {
      scope: e.__scopeAccordion,
      value: i,
      onItemOpen: c,
      onItemClose: u,
      children: /* @__PURE__ */ s.jsx(Bs, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ s.jsx(zs, { ...a, ref: t }) })
    }
  );
}), [nd, jn] = Mn(Te), zs = ee.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: o, dir: r, orientation: a = "vertical", ...i } = e, l = ee.useRef(null), c = ne(l, t), u = X1(n), m = Wt(r) === "ltr", g = F(e.onKeyDown, (x) => {
      var R;
      if (!Y1.includes(x.key)) return;
      const b = x.target, p = u().filter((_) => {
        var L;
        return !((L = _.ref.current) != null && L.disabled);
      }), v = p.findIndex((_) => _.ref.current === b), w = p.length;
      if (v === -1) return;
      x.preventDefault();
      let C = v;
      const y = 0, S = w - 1, E = () => {
        C = v + 1, C > S && (C = y);
      }, M = () => {
        C = v - 1, C < y && (C = S);
      };
      switch (x.key) {
        case "Home":
          C = y;
          break;
        case "End":
          C = S;
          break;
        case "ArrowRight":
          a === "horizontal" && (m ? E() : M());
          break;
        case "ArrowDown":
          a === "vertical" && E();
          break;
        case "ArrowLeft":
          a === "horizontal" && (m ? M() : E());
          break;
        case "ArrowUp":
          a === "vertical" && M();
          break;
      }
      const j = C % w;
      (R = p[j].ref.current) == null || R.focus();
    });
    return /* @__PURE__ */ s.jsx(
      nd,
      {
        scope: n,
        disabled: o,
        direction: r,
        orientation: a,
        children: /* @__PURE__ */ s.jsx(Do.Slot, { scope: n, children: /* @__PURE__ */ s.jsx(
          V.div,
          {
            ...i,
            "data-orientation": a,
            ref: c,
            onKeyDown: o ? void 0 : g
          }
        ) })
      }
    );
  }
), pn = "AccordionItem", [od, Vo] = Mn(pn), Ws = ee.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: o, ...r } = e, a = jn(pn, n), i = J1(pn, n), l = Fo(n), c = Pe(), u = o && i.value.includes(o) || !1, f = a.disabled || e.disabled;
    return /* @__PURE__ */ s.jsx(
      od,
      {
        scope: n,
        open: u,
        disabled: f,
        triggerId: c,
        children: /* @__PURE__ */ s.jsx(
          Vs,
          {
            "data-orientation": a.orientation,
            "data-state": Xs(u),
            ...l,
            ...r,
            ref: t,
            disabled: f,
            open: u,
            onOpenChange: (m) => {
              m ? i.onItemOpen(o) : i.onItemClose(o);
            }
          }
        )
      }
    );
  }
);
Ws.displayName = pn;
var Gs = "AccordionHeader", Zs = ee.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = jn(Te, n), a = Vo(Gs, n);
    return /* @__PURE__ */ s.jsx(
      V.h3,
      {
        "data-orientation": r.orientation,
        "data-state": Xs(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    );
  }
);
Zs.displayName = Gs;
var po = "AccordionTrigger", Us = ee.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = jn(Te, n), a = Vo(po, n), i = Q1(po, n), l = Fo(n);
    return /* @__PURE__ */ s.jsx(Do.ItemSlot, { scope: n, children: /* @__PURE__ */ s.jsx(
      Z1,
      {
        "aria-disabled": a.open && !i.collapsible || void 0,
        "data-orientation": r.orientation,
        id: a.triggerId,
        ...l,
        ...o,
        ref: t
      }
    ) });
  }
);
Us.displayName = po;
var Ks = "AccordionContent", Ys = ee.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = jn(Te, n), a = Vo(Ks, n), i = Fo(n);
    return /* @__PURE__ */ s.jsx(
      U1,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": r.orientation,
        ...i,
        ...o,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
Ys.displayName = Ks;
function Xs(e) {
  return e ? "open" : "closed";
}
var rd = Hs, sd = Ws, ad = Zs, id = Us, ld = Ys;
function Ce(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...n);
  }, []);
}
function cd(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ce(e);
  d.useEffect(() => {
    const o = (r) => {
      r.key === "Escape" && n(r);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [n, t]);
}
var dd = "DismissableLayer", mo = "dismissableLayer.update", ud = "dismissableLayer.pointerDownOutside", fd = "dismissableLayer.focusOutside", Lr, qs = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Gt = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: r,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: l,
      ...c
    } = e, u = d.useContext(qs), [f, m] = d.useState(null), g = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, x] = d.useState({}), b = ne(t, (j) => m(j)), p = Array.from(u.layers), [v] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), w = p.indexOf(v), C = f ? p.indexOf(f) : -1, y = u.layersWithOutsidePointerEventsDisabled.size > 0, S = C >= w, E = hd((j) => {
      const R = j.target, _ = [...u.branches].some((L) => L.contains(R));
      !S || _ || (r == null || r(j), i == null || i(j), j.defaultPrevented || l == null || l());
    }, g), M = gd((j) => {
      const R = j.target;
      [...u.branches].some((L) => L.contains(R)) || (a == null || a(j), i == null || i(j), j.defaultPrevented || l == null || l());
    }, g);
    return cd((j) => {
      C === u.layers.size - 1 && (o == null || o(j), !j.defaultPrevented && l && (j.preventDefault(), l()));
    }, g), d.useEffect(() => {
      if (f)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Lr = g.body.style.pointerEvents, g.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(f)), u.layers.add(f), Dr(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (g.body.style.pointerEvents = Lr);
        };
    }, [f, g, n, u]), d.useEffect(() => () => {
      f && (u.layers.delete(f), u.layersWithOutsidePointerEventsDisabled.delete(f), Dr());
    }, [f, u]), d.useEffect(() => {
      const j = () => x({});
      return document.addEventListener(mo, j), () => document.removeEventListener(mo, j);
    }, []), /* @__PURE__ */ s.jsx(
      V.div,
      {
        ...c,
        ref: b,
        style: {
          pointerEvents: y ? S ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: F(e.onFocusCapture, M.onFocusCapture),
        onBlurCapture: F(e.onBlurCapture, M.onBlurCapture),
        onPointerDownCapture: F(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
Gt.displayName = dd;
var pd = "DismissableLayerBranch", md = d.forwardRef((e, t) => {
  const n = d.useContext(qs), o = d.useRef(null), r = ne(t, o);
  return d.useEffect(() => {
    const a = o.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ s.jsx(V.div, { ...e, ref: r });
});
md.displayName = pd;
function hd(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ce(e), o = d.useRef(!1), r = d.useRef(() => {
  });
  return d.useEffect(() => {
    const a = (l) => {
      if (l.target && !o.current) {
        let c = function() {
          Js(
            ud,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: l };
        l.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = c, t.addEventListener("click", r.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", r.current);
      o.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", r.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function gd(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ce(e), o = d.useRef(!1);
  return d.useEffect(() => {
    const r = (a) => {
      a.target && !o.current && Js(fd, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [t, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function Dr() {
  const e = new CustomEvent(mo);
  document.dispatchEvent(e);
}
function Js(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && r.addEventListener(e, t, { once: !0 }), o ? fo(r, a) : r.dispatchEvent(a);
}
var qn = "focusScope.autoFocusOnMount", Jn = "focusScope.autoFocusOnUnmount", Fr = { bubbles: !1, cancelable: !0 }, vd = "FocusScope", Pn = d.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: o = !1,
    onMountAutoFocus: r,
    onUnmountAutoFocus: a,
    ...i
  } = e, [l, c] = d.useState(null), u = Ce(r), f = Ce(a), m = d.useRef(null), g = ne(t, (p) => c(p)), x = d.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  d.useEffect(() => {
    if (o) {
      let p = function(y) {
        if (x.paused || !l) return;
        const S = y.target;
        l.contains(S) ? m.current = S : Je(m.current, { select: !0 });
      }, v = function(y) {
        if (x.paused || !l) return;
        const S = y.relatedTarget;
        S !== null && (l.contains(S) || Je(m.current, { select: !0 }));
      }, w = function(y) {
        if (document.activeElement === document.body)
          for (const E of y)
            E.removedNodes.length > 0 && Je(l);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", v);
      const C = new MutationObserver(w);
      return l && C.observe(l, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", v), C.disconnect();
      };
    }
  }, [o, l, x.paused]), d.useEffect(() => {
    if (l) {
      Hr.add(x);
      const p = document.activeElement;
      if (!l.contains(p)) {
        const w = new CustomEvent(qn, Fr);
        l.addEventListener(qn, u), l.dispatchEvent(w), w.defaultPrevented || (xd(Sd(Qs(l)), { select: !0 }), document.activeElement === p && Je(l));
      }
      return () => {
        l.removeEventListener(qn, u), setTimeout(() => {
          const w = new CustomEvent(Jn, Fr);
          l.addEventListener(Jn, f), l.dispatchEvent(w), w.defaultPrevented || Je(p ?? document.body, { select: !0 }), l.removeEventListener(Jn, f), Hr.remove(x);
        }, 0);
      };
    }
  }, [l, u, f, x]);
  const b = d.useCallback(
    (p) => {
      if (!n && !o || x.paused) return;
      const v = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, w = document.activeElement;
      if (v && w) {
        const C = p.currentTarget, [y, S] = Cd(C);
        y && S ? !p.shiftKey && w === S ? (p.preventDefault(), n && Je(y, { select: !0 })) : p.shiftKey && w === y && (p.preventDefault(), n && Je(S, { select: !0 })) : w === C && p.preventDefault();
      }
    },
    [n, o, x.paused]
  );
  return /* @__PURE__ */ s.jsx(V.div, { tabIndex: -1, ...i, ref: g, onKeyDown: b });
});
Pn.displayName = vd;
function xd(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (Je(o, { select: t }), document.activeElement !== n) return;
}
function Cd(e) {
  const t = Qs(e), n = Vr(t, e), o = Vr(t.reverse(), e);
  return [n, o];
}
function Qs(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Vr(e, t) {
  for (const n of e)
    if (!bd(n, { upTo: t })) return n;
}
function bd(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function wd(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Je(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && wd(e) && t && e.select();
  }
}
var Hr = yd();
function yd() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = $r(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = $r(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function $r(e, t) {
  const n = [...e], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function Sd(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Ed = "Portal", Ho = d.forwardRef((e, t) => {
  var l;
  const { container: n, ...o } = e, [r, a] = d.useState(!1);
  me(() => a(!0), []);
  const i = n || r && ((l = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : l.body);
  return i ? ps.createPortal(/* @__PURE__ */ s.jsx(V.div, { ...o, ref: t }), i) : null;
});
Ho.displayName = Ed;
var Qn = 0;
function $o() {
  d.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Br()), document.body.insertAdjacentElement("beforeend", e[1] ?? Br()), Qn++, () => {
      Qn === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Qn--;
    };
  }, []);
}
function Br() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Le = function() {
  return Le = Object.assign || function(t) {
    for (var n, o = 1, r = arguments.length; o < r; o++) {
      n = arguments[o];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Le.apply(this, arguments);
};
function ea(e, t) {
  var n = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}
function Rd(e, t, n) {
  if (n || arguments.length === 2) for (var o = 0, r = t.length, a; o < r; o++)
    (a || !(o in t)) && (a || (a = Array.prototype.slice.call(t, 0, o)), a[o] = t[o]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var cn = "right-scroll-bar-position", dn = "width-before-scroll-bar", Md = "with-scroll-bars-hidden", jd = "--removed-body-scroll-bar-size";
function eo(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Pd(e, t) {
  var n = $t(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var r = n.value;
          r !== o && (n.value = o, n.callback(o, r));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Nd = typeof window < "u" ? d.useLayoutEffect : d.useEffect, zr = /* @__PURE__ */ new WeakMap();
function _d(e, t) {
  var n = Pd(null, function(o) {
    return e.forEach(function(r) {
      return eo(r, o);
    });
  });
  return Nd(function() {
    var o = zr.get(n);
    if (o) {
      var r = new Set(o), a = new Set(e), i = n.current;
      r.forEach(function(l) {
        a.has(l) || eo(l, null);
      }), a.forEach(function(l) {
        r.has(l) || eo(l, i);
      });
    }
    zr.set(n, e);
  }, [e]), n;
}
function kd(e) {
  return e;
}
function Ad(e, t) {
  t === void 0 && (t = kd);
  var n = [], o = !1, r = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var i = t(a, o);
      return n.push(i), function() {
        n = n.filter(function(l) {
          return l !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (o = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(a);
      }
      n = {
        push: function(l) {
          return a(l);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      o = !0;
      var i = [];
      if (n.length) {
        var l = n;
        n = [], l.forEach(a), i = n;
      }
      var c = function() {
        var f = i;
        i = [], f.forEach(a);
      }, u = function() {
        return Promise.resolve().then(c);
      };
      u(), n = {
        push: function(f) {
          i.push(f), u();
        },
        filter: function(f) {
          return i = i.filter(f), n;
        }
      };
    }
  };
  return r;
}
function Td(e) {
  e === void 0 && (e = {});
  var t = Ad(null);
  return t.options = Le({ async: !0, ssr: !1 }, e), t;
}
var ta = function(e) {
  var t = e.sideCar, n = ea(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return d.createElement(o, Le({}, n));
};
ta.isSideCarExport = !0;
function Id(e, t) {
  return e.useMedium(t), ta;
}
var na = Td(), to = function() {
}, Nn = d.forwardRef(function(e, t) {
  var n = d.useRef(null), o = d.useState({
    onScrollCapture: to,
    onWheelCapture: to,
    onTouchMoveCapture: to
  }), r = o[0], a = o[1], i = e.forwardProps, l = e.children, c = e.className, u = e.removeScrollBar, f = e.enabled, m = e.shards, g = e.sideCar, x = e.noRelative, b = e.noIsolation, p = e.inert, v = e.allowPinchZoom, w = e.as, C = w === void 0 ? "div" : w, y = e.gapMode, S = ea(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = g, M = _d([n, t]), j = Le(Le({}, S), r);
  return d.createElement(
    d.Fragment,
    null,
    f && d.createElement(E, { sideCar: na, removeScrollBar: u, shards: m, noRelative: x, noIsolation: b, inert: p, setCallbacks: a, allowPinchZoom: !!v, lockRef: n, gapMode: y }),
    i ? d.cloneElement(d.Children.only(l), Le(Le({}, j), { ref: M })) : d.createElement(C, Le({}, j, { className: c, ref: M }), l)
  );
});
Nn.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Nn.classNames = {
  fullWidth: dn,
  zeroRight: cn
};
var Od = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Ld() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Od();
  return t && e.setAttribute("nonce", t), e;
}
function Dd(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Fd(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Vd = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Ld()) && (Dd(t, n), Fd(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Hd = function() {
  var e = Vd();
  return function(t, n) {
    d.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, oa = function() {
  var e = Hd(), t = function(n) {
    var o = n.styles, r = n.dynamic;
    return e(o, r), null;
  };
  return t;
}, $d = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, no = function(e) {
  return parseInt(e || "", 10) || 0;
}, Bd = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], r = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [no(n), no(o), no(r)];
}, zd = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return $d;
  var t = Bd(e), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - n + t[2] - t[0])
  };
}, Wd = oa(), Et = "data-scroll-locked", Gd = function(e, t, n, o) {
  var r = e.left, a = e.top, i = e.right, l = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Md, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(l, "px ").concat(o, `;
  }
  body[`).concat(Et, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(l, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(cn, ` {
    right: `).concat(l, "px ").concat(o, `;
  }
  
  .`).concat(dn, ` {
    margin-right: `).concat(l, "px ").concat(o, `;
  }
  
  .`).concat(cn, " .").concat(cn, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(dn, " .").concat(dn, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(Et, `] {
    `).concat(jd, ": ").concat(l, `px;
  }
`);
}, Wr = function() {
  var e = parseInt(document.body.getAttribute(Et) || "0", 10);
  return isFinite(e) ? e : 0;
}, Zd = function() {
  d.useEffect(function() {
    return document.body.setAttribute(Et, (Wr() + 1).toString()), function() {
      var e = Wr() - 1;
      e <= 0 ? document.body.removeAttribute(Et) : document.body.setAttribute(Et, e.toString());
    };
  }, []);
}, Ud = function(e) {
  var t = e.noRelative, n = e.noImportant, o = e.gapMode, r = o === void 0 ? "margin" : o;
  Zd();
  var a = d.useMemo(function() {
    return zd(r);
  }, [r]);
  return d.createElement(Wd, { styles: Gd(a, !t, r, n ? "" : "!important") });
}, ho = !1;
if (typeof window < "u")
  try {
    var nn = Object.defineProperty({}, "passive", {
      get: function() {
        return ho = !0, !0;
      }
    });
    window.addEventListener("test", nn, nn), window.removeEventListener("test", nn, nn);
  } catch {
    ho = !1;
  }
var wt = ho ? { passive: !1 } : !1, Kd = function(e) {
  return e.tagName === "TEXTAREA";
}, ra = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Kd(e) && n[t] === "visible")
  );
}, Yd = function(e) {
  return ra(e, "overflowY");
}, Xd = function(e) {
  return ra(e, "overflowX");
}, Gr = function(e, t) {
  var n = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var r = sa(e, o);
    if (r) {
      var a = aa(e, o), i = a[1], l = a[2];
      if (i > l)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== n.body);
  return !1;
}, qd = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, Jd = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, sa = function(e, t) {
  return e === "v" ? Yd(t) : Xd(t);
}, aa = function(e, t) {
  return e === "v" ? qd(t) : Jd(t);
}, Qd = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, eu = function(e, t, n, o, r) {
  var a = Qd(e, window.getComputedStyle(t).direction), i = a * o, l = n.target, c = t.contains(l), u = !1, f = i > 0, m = 0, g = 0;
  do {
    if (!l)
      break;
    var x = aa(e, l), b = x[0], p = x[1], v = x[2], w = p - v - a * b;
    (b || w) && sa(e, l) && (m += w, g += b);
    var C = l.parentNode;
    l = C && C.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? C.host : C;
  } while (
    // portaled content
    !c && l !== document.body || // self content
    c && (t.contains(l) || t === l)
  );
  return (f && Math.abs(m) < 1 || !f && Math.abs(g) < 1) && (u = !0), u;
}, on = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Zr = function(e) {
  return [e.deltaX, e.deltaY];
}, Ur = function(e) {
  return e && "current" in e ? e.current : e;
}, tu = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, nu = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, ou = 0, yt = [];
function ru(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), o = d.useRef(), r = d.useState(ou++)[0], a = d.useState(oa)[0], i = d.useRef(e);
  d.useEffect(function() {
    i.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var p = Rd([e.lockRef.current], (e.shards || []).map(Ur), !0).filter(Boolean);
      return p.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), p.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = d.useCallback(function(p, v) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = on(p), C = n.current, y = "deltaX" in p ? p.deltaX : C[0] - w[0], S = "deltaY" in p ? p.deltaY : C[1] - w[1], E, M = p.target, j = Math.abs(y) > Math.abs(S) ? "h" : "v";
    if ("touches" in p && j === "h" && M.type === "range")
      return !1;
    var R = window.getSelection(), _ = R && R.anchorNode, L = _ ? _ === M || _.contains(M) : !1;
    if (L)
      return !1;
    var B = Gr(j, M);
    if (!B)
      return !0;
    if (B ? E = j : (E = j === "v" ? "h" : "v", B = Gr(j, M)), !B)
      return !1;
    if (!o.current && "changedTouches" in p && (y || S) && (o.current = E), !E)
      return !0;
    var X = o.current || E;
    return eu(X, v, p, X === "h" ? y : S);
  }, []), c = d.useCallback(function(p) {
    var v = p;
    if (!(!yt.length || yt[yt.length - 1] !== a)) {
      var w = "deltaY" in v ? Zr(v) : on(v), C = t.current.filter(function(E) {
        return E.name === v.type && (E.target === v.target || v.target === E.shadowParent) && tu(E.delta, w);
      })[0];
      if (C && C.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!C) {
        var y = (i.current.shards || []).map(Ur).filter(Boolean).filter(function(E) {
          return E.contains(v.target);
        }), S = y.length > 0 ? l(v, y[0]) : !i.current.noIsolation;
        S && v.cancelable && v.preventDefault();
      }
    }
  }, []), u = d.useCallback(function(p, v, w, C) {
    var y = { name: p, delta: v, target: w, should: C, shadowParent: su(w) };
    t.current.push(y), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== y;
      });
    }, 1);
  }, []), f = d.useCallback(function(p) {
    n.current = on(p), o.current = void 0;
  }, []), m = d.useCallback(function(p) {
    u(p.type, Zr(p), p.target, l(p, e.lockRef.current));
  }, []), g = d.useCallback(function(p) {
    u(p.type, on(p), p.target, l(p, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return yt.push(a), e.setCallbacks({
      onScrollCapture: m,
      onWheelCapture: m,
      onTouchMoveCapture: g
    }), document.addEventListener("wheel", c, wt), document.addEventListener("touchmove", c, wt), document.addEventListener("touchstart", f, wt), function() {
      yt = yt.filter(function(p) {
        return p !== a;
      }), document.removeEventListener("wheel", c, wt), document.removeEventListener("touchmove", c, wt), document.removeEventListener("touchstart", f, wt);
    };
  }, []);
  var x = e.removeScrollBar, b = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    b ? d.createElement(a, { styles: nu(r) }) : null,
    x ? d.createElement(Ud, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function su(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const au = Id(na, ru);
var _n = d.forwardRef(function(e, t) {
  return d.createElement(Nn, Le({}, e, { ref: t, sideCar: au }));
});
_n.classNames = Nn.classNames;
var iu = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, St = /* @__PURE__ */ new WeakMap(), rn = /* @__PURE__ */ new WeakMap(), sn = {}, oo = 0, ia = function(e) {
  return e && (e.host || ia(e.parentNode));
}, lu = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var o = ia(n);
    return o && e.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, cu = function(e, t, n, o) {
  var r = lu(t, Array.isArray(e) ? e : [e]);
  sn[n] || (sn[n] = /* @__PURE__ */ new WeakMap());
  var a = sn[n], i = [], l = /* @__PURE__ */ new Set(), c = new Set(r), u = function(m) {
    !m || l.has(m) || (l.add(m), u(m.parentNode));
  };
  r.forEach(u);
  var f = function(m) {
    !m || c.has(m) || Array.prototype.forEach.call(m.children, function(g) {
      if (l.has(g))
        f(g);
      else
        try {
          var x = g.getAttribute(o), b = x !== null && x !== "false", p = (St.get(g) || 0) + 1, v = (a.get(g) || 0) + 1;
          St.set(g, p), a.set(g, v), i.push(g), p === 1 && b && rn.set(g, !0), v === 1 && g.setAttribute(n, "true"), b || g.setAttribute(o, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", g, w);
        }
    });
  };
  return f(t), l.clear(), oo++, function() {
    i.forEach(function(m) {
      var g = St.get(m) - 1, x = a.get(m) - 1;
      St.set(m, g), a.set(m, x), g || (rn.has(m) || m.removeAttribute(o), rn.delete(m)), x || m.removeAttribute(n);
    }), oo--, oo || (St = /* @__PURE__ */ new WeakMap(), St = /* @__PURE__ */ new WeakMap(), rn = /* @__PURE__ */ new WeakMap(), sn = {});
  };
}, Bo = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), r = iu(e);
  return r ? (o.push.apply(o, Array.from(r.querySelectorAll("[aria-live], script"))), cu(o, r, n, "aria-hidden")) : function() {
    return null;
  };
}, kn = "Dialog", [la] = He(kn), [du, Be] = la(kn), ca = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    modal: i = !0
  } = e, l = d.useRef(null), c = d.useRef(null), [u, f] = Ee({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: kn
  });
  return /* @__PURE__ */ s.jsx(
    du,
    {
      scope: t,
      triggerRef: l,
      contentRef: c,
      contentId: Pe(),
      titleId: Pe(),
      descriptionId: Pe(),
      open: u,
      onOpenChange: f,
      onOpenToggle: d.useCallback(() => f((m) => !m), [f]),
      modal: i,
      children: n
    }
  );
};
ca.displayName = kn;
var da = "DialogTrigger", ua = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Be(da, n), a = ne(t, r.triggerRef);
    return /* @__PURE__ */ s.jsx(
      V.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": Wo(r.open),
        ...o,
        ref: a,
        onClick: F(e.onClick, r.onOpenToggle)
      }
    );
  }
);
ua.displayName = da;
var uu = "DialogPortal", [G4, fa] = la(uu, {
  forceMount: void 0
}), mn = "DialogOverlay", pa = d.forwardRef(
  (e, t) => {
    const n = fa(mn, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, a = Be(mn, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ s.jsx($e, { present: o || a.open, children: /* @__PURE__ */ s.jsx(pu, { ...r, ref: t }) }) : null;
  }
);
pa.displayName = mn;
var fu = /* @__PURE__ */ dt("DialogOverlay.RemoveScroll"), pu = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Be(mn, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ s.jsx(_n, { as: fu, allowPinchZoom: !0, shards: [r.contentRef], children: /* @__PURE__ */ s.jsx(
        V.div,
        {
          "data-state": Wo(r.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), ut = "DialogContent", ma = d.forwardRef(
  (e, t) => {
    const n = fa(ut, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, a = Be(ut, e.__scopeDialog);
    return /* @__PURE__ */ s.jsx($e, { present: o || a.open, children: a.modal ? /* @__PURE__ */ s.jsx(mu, { ...r, ref: t }) : /* @__PURE__ */ s.jsx(hu, { ...r, ref: t }) });
  }
);
ma.displayName = ut;
var mu = d.forwardRef(
  (e, t) => {
    const n = Be(ut, e.__scopeDialog), o = d.useRef(null), r = ne(t, n.contentRef, o);
    return d.useEffect(() => {
      const a = o.current;
      if (a) return Bo(a);
    }, []), /* @__PURE__ */ s.jsx(
      ha,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: F(e.onCloseAutoFocus, (a) => {
          var i;
          a.preventDefault(), (i = n.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: F(e.onPointerDownOutside, (a) => {
          const i = a.detail.originalEvent, l = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || l) && a.preventDefault();
        }),
        onFocusOutside: F(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), hu = d.forwardRef(
  (e, t) => {
    const n = Be(ut, e.__scopeDialog), o = d.useRef(!1), r = d.useRef(!1);
    return /* @__PURE__ */ s.jsx(
      ha,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, l;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (o.current || (l = n.triggerRef.current) == null || l.focus(), a.preventDefault()), o.current = !1, r.current = !1;
        },
        onInteractOutside: (a) => {
          var c, u;
          (c = e.onInteractOutside) == null || c.call(e, a), a.defaultPrevented || (o.current = !0, a.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const i = a.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && r.current && a.preventDefault();
        }
      }
    );
  }
), ha = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: r, onCloseAutoFocus: a, ...i } = e, l = Be(ut, n), c = d.useRef(null), u = ne(t, c);
    return $o(), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        Pn,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: r,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ s.jsx(
            Gt,
            {
              role: "dialog",
              id: l.contentId,
              "aria-describedby": l.descriptionId,
              "aria-labelledby": l.titleId,
              "data-state": Wo(l.open),
              ...i,
              ref: u,
              onDismiss: () => l.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(gu, { titleId: l.titleId }),
        /* @__PURE__ */ s.jsx(xu, { contentRef: c, descriptionId: l.descriptionId })
      ] })
    ] });
  }
), zo = "DialogTitle", ga = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Be(zo, n);
    return /* @__PURE__ */ s.jsx(V.h2, { id: r.titleId, ...o, ref: t });
  }
);
ga.displayName = zo;
var va = "DialogDescription", xa = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Be(va, n);
    return /* @__PURE__ */ s.jsx(V.p, { id: r.descriptionId, ...o, ref: t });
  }
);
xa.displayName = va;
var Ca = "DialogClose", ba = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Be(Ca, n);
    return /* @__PURE__ */ s.jsx(
      V.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: F(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
ba.displayName = Ca;
function Wo(e) {
  return e ? "open" : "closed";
}
var wa = "DialogTitleWarning", [Z4, ya] = T1(wa, {
  contentName: ut,
  titleName: zo,
  docsSlug: "dialog"
}), gu = ({ titleId: e }) => {
  const t = ya(wa), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return d.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, vu = "DialogDescriptionWarning", xu = ({ contentRef: e, descriptionId: t }) => {
  const o = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${ya(vu).contentName}}.`;
  return d.useEffect(() => {
    var a;
    const r = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && r && (document.getElementById(t) || console.warn(o));
  }, [o, e, t]), null;
}, Cu = ca, bu = ua, wu = pa, yu = ma, Su = ga, Eu = xa, Sa = ba;
function Ea(e) {
  const t = d.useRef({ value: e, previous: e });
  return d.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function Ru(e) {
  const [t, n] = d.useState(void 0);
  return me(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const a = r[0];
        let i, l;
        if ("borderBoxSize" in a) {
          const c = a.borderBoxSize, u = Array.isArray(c) ? c[0] : c;
          i = u.inlineSize, l = u.blockSize;
        } else
          i = e.offsetWidth, l = e.offsetHeight;
        n({ width: i, height: l });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
const Mu = ["top", "right", "bottom", "left"], Qe = Math.min, Ze = Math.max, hn = Math.round, an = Math.floor, Ue = (e) => ({
  x: e,
  y: e
}), ju = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Ra(e, t, n) {
  return Ze(e, Qe(t, n));
}
function Ke(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function et(e) {
  return e.split("-")[0];
}
function kt(e) {
  return e.split("-")[1];
}
function Go(e) {
  return e === "x" ? "y" : "x";
}
function Zo(e) {
  return e === "y" ? "height" : "width";
}
function De(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function Uo(e) {
  return Go(De(e));
}
function Pu(e, t, n) {
  n === void 0 && (n = !1);
  const o = kt(e), r = Uo(e), a = Zo(r);
  let i = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = gn(i)), [i, gn(i)];
}
function Nu(e) {
  const t = gn(e);
  return [go(e), t, go(t)];
}
function go(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const Kr = ["left", "right"], Yr = ["right", "left"], _u = ["top", "bottom"], ku = ["bottom", "top"];
function Au(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Yr : Kr : t ? Kr : Yr;
    case "left":
    case "right":
      return t ? _u : ku;
    default:
      return [];
  }
}
function Tu(e, t, n, o) {
  const r = kt(e);
  let a = Au(et(e), n === "start", o);
  return r && (a = a.map((i) => i + "-" + r), t && (a = a.concat(a.map(go)))), a;
}
function gn(e) {
  const t = et(e);
  return ju[t] + e.slice(t.length);
}
function Iu(e) {
  var t, n, o, r;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (n = e.right) != null ? n : 0,
    bottom: (o = e.bottom) != null ? o : 0,
    left: (r = e.left) != null ? r : 0
  };
}
function Ma(e) {
  return typeof e != "number" ? Iu(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function vn(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: r
  } = e;
  return {
    width: o,
    height: r,
    top: n,
    left: t,
    right: t + o,
    bottom: n + r,
    x: t,
    y: n
  };
}
function Xr(e, t, n) {
  let {
    reference: o,
    floating: r
  } = e;
  const a = De(t), i = Uo(t), l = Zo(i), c = et(t), u = a === "y", f = o.x + o.width / 2 - r.width / 2, m = o.y + o.height / 2 - r.height / 2, g = o[l] / 2 - r[l] / 2;
  let x;
  switch (c) {
    case "top":
      x = {
        x: f,
        y: o.y - r.height
      };
      break;
    case "bottom":
      x = {
        x: f,
        y: o.y + o.height
      };
      break;
    case "right":
      x = {
        x: o.x + o.width,
        y: m
      };
      break;
    case "left":
      x = {
        x: o.x - r.width,
        y: m
      };
      break;
    default:
      x = {
        x: o.x,
        y: o.y
      };
  }
  const b = kt(t);
  return b && (x[i] += g * (b === "end" ? 1 : -1) * (n && u ? -1 : 1)), x;
}
async function Ou(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: r,
    platform: a,
    rects: i,
    elements: l,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: m = "floating",
    altBoundary: g = !1,
    padding: x = 0
  } = Ke(t, e), b = Ma(x), v = l[g ? m === "floating" ? "reference" : "floating" : m], w = vn(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(v))) == null || n ? v : v.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(l.floating)),
    boundary: u,
    rootBoundary: f,
    strategy: c
  })), C = m === "floating" ? {
    x: o,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, y = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l.floating)), S = await (a.isElement == null ? void 0 : a.isElement(y)) && await (a.getScale == null ? void 0 : a.getScale(y)) || {
    x: 1,
    y: 1
  }, E = vn(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: C,
    offsetParent: y,
    strategy: c
  }) : C);
  return {
    top: (w.top - E.top + b.top) / S.y,
    bottom: (E.bottom - w.bottom + b.bottom) / S.y,
    left: (w.left - E.left + b.left) / S.x,
    right: (E.right - w.right + b.right) / S.x
  };
}
const Lu = 50, Du = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: i
  } = n, l = i.detectOverflow ? i : {
    ...i,
    detectOverflow: Ou
  }, c = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let u = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: f,
    y: m
  } = Xr(u, o, c), g = o, x = 0;
  const b = {};
  for (let p = 0; p < a.length; p++) {
    const v = a[p];
    if (!v)
      continue;
    const {
      name: w,
      fn: C
    } = v, {
      x: y,
      y: S,
      data: E,
      reset: M
    } = await C({
      x: f,
      y: m,
      initialPlacement: o,
      placement: g,
      strategy: r,
      middlewareData: b,
      rects: u,
      platform: l,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = y ?? f, m = S ?? m, b[w] = {
      ...b[w],
      ...E
    }, M && x < Lu && (x++, typeof M == "object" && (M.placement && (g = M.placement), M.rects && (u = M.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : M.rects), {
      x: f,
      y: m
    } = Xr(u, g, c)), p = -1);
  }
  return {
    x: f,
    y: m,
    placement: g,
    strategy: r,
    middlewareData: b
  };
}, Fu = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: a,
      platform: i,
      elements: l,
      middlewareData: c
    } = t, {
      element: u,
      padding: f = 0
    } = Ke(e, t) || {};
    if (u == null)
      return {};
    const m = Ma(f), g = {
      x: n,
      y: o
    }, x = Uo(r), b = Zo(x), p = await i.getDimensions(u), v = x === "y", w = v ? "top" : "left", C = v ? "bottom" : "right", y = v ? "clientHeight" : "clientWidth", S = a.reference[b] + a.reference[x] - g[x] - a.floating[b], E = g[x] - a.reference[x], M = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(u));
    let j = M ? M[y] : 0;
    (!j || !await (i.isElement == null ? void 0 : i.isElement(M))) && (j = l.floating[y] || a.floating[b]);
    const R = S / 2 - E / 2, _ = j / 2 - p[b] / 2 - 1, L = Qe(m[w], _), B = Qe(m[C], _), X = j - p[b] - B, $ = j / 2 - p[b] / 2 + R, z = Ra(L, $, X), G = !c.arrow && kt(r) != null && $ !== z && a.reference[b] / 2 - ($ < L ? L : B) - p[b] / 2 < 0, D = G ? $ < L ? $ - L : $ - X : 0;
    return {
      [x]: g[x] + D,
      data: {
        [x]: z,
        centerOffset: $ - z - D,
        ...G && {
          alignmentOffset: D
        }
      },
      reset: G
    };
  }
}), Vu = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        middlewareData: a,
        rects: i,
        initialPlacement: l,
        platform: c,
        elements: u
      } = t, {
        mainAxis: f = !0,
        crossAxis: m = !0,
        fallbackPlacements: g,
        fallbackStrategy: x = "bestFit",
        fallbackAxisSideDirection: b = "none",
        flipAlignment: p = !0,
        ...v
      } = Ke(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const w = et(r), C = De(l), y = et(l) === l, S = await (c.isRTL == null ? void 0 : c.isRTL(u.floating)), E = g || (y || !p ? [gn(l)] : Nu(l)), M = b !== "none";
      !g && M && E.push(...Tu(l, p, b, S));
      const j = [l, ...E], R = await c.detectOverflow(t, v), _ = [];
      let L = ((o = a.flip) == null ? void 0 : o.overflows) || [];
      if (f && _.push(R[w]), m) {
        const z = Pu(r, i, S);
        _.push(R[z[0]], R[z[1]]);
      }
      if (L = [...L, {
        placement: r,
        overflows: _
      }], !_.every((z) => z <= 0)) {
        var B, X;
        const z = (((B = a.flip) == null ? void 0 : B.index) || 0) + 1, G = j[z];
        if (G && (!(m === "alignment" ? C !== De(G) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        L.every((P) => De(P.placement) === C ? P.overflows[0] > 0 : !0)))
          return {
            data: {
              index: z,
              overflows: L
            },
            reset: {
              placement: G
            }
          };
        let D = (X = L.filter((Z) => Z.overflows[0] <= 0).sort((Z, P) => Z.overflows[1] - P.overflows[1])[0]) == null ? void 0 : X.placement;
        if (!D)
          switch (x) {
            case "bestFit": {
              var $;
              const Z = ($ = L.filter((P) => {
                if (M) {
                  const te = De(P.placement);
                  return te === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  te === "y";
                }
                return !0;
              }).map((P) => [P.placement, P.overflows.filter((te) => te > 0).reduce((te, fe) => te + fe, 0)]).sort((P, te) => P[1] - te[1])[0]) == null ? void 0 : $[0];
              Z && (D = Z);
              break;
            }
            case "initialPlacement":
              D = l;
              break;
          }
        if (r !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
};
function qr(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Jr(e) {
  return Mu.some((t) => e[t] >= 0);
}
const Hu = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n,
        platform: o
      } = t, {
        strategy: r = "referenceHidden",
        ...a
      } = Ke(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await o.detectOverflow(t, {
            ...a,
            elementContext: "reference"
          }), l = qr(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: l,
              referenceHidden: Jr(l)
            }
          };
        }
        case "escaped": {
          const i = await o.detectOverflow(t, {
            ...a,
            altBoundary: !0
          }), l = qr(i, n.floating);
          return {
            data: {
              escapedOffsets: l,
              escaped: Jr(l)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, ja = /* @__PURE__ */ new Set(["left", "top"]);
async function $u(e, t) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = e, a = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), i = et(n), l = kt(n), c = De(n) === "y", u = ja.has(i) ? -1 : 1, f = a && c ? -1 : 1, m = Ke(t, e);
  let {
    mainAxis: g,
    crossAxis: x,
    alignmentAxis: b
  } = typeof m == "number" ? {
    mainAxis: m,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: m.mainAxis || 0,
    crossAxis: m.crossAxis || 0,
    alignmentAxis: m.alignmentAxis
  };
  return l && typeof b == "number" && (x = l === "end" ? b * -1 : b), c ? {
    x: x * f,
    y: g * u
  } : {
    x: g * u,
    y: x * f
  };
}
const Bu = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: r,
        y: a,
        placement: i,
        middlewareData: l
      } = t, c = await $u(t, e);
      return i === ((n = l.offset) == null ? void 0 : n.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : {
        x: r + c.x,
        y: a + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, zu = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: r,
        platform: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: l = !1,
        limiter: c = {
          fn: (C) => {
            let {
              x: y,
              y: S
            } = C;
            return {
              x: y,
              y: S
            };
          }
        },
        ...u
      } = Ke(e, t), f = {
        x: n,
        y: o
      }, m = await a.detectOverflow(t, u), g = De(r), x = Go(g);
      let b = f[x], p = f[g];
      const v = (C, y) => Ra(y + m[C === "y" ? "top" : "left"], y, y - m[C === "y" ? "bottom" : "right"]);
      i && (b = v(x, b)), l && (p = v(g, p));
      const w = c.fn({
        ...t,
        [x]: b,
        [g]: p
      });
      return {
        ...w,
        data: {
          x: w.x - n,
          y: w.y - o,
          enabled: {
            [x]: i,
            [g]: l
          }
        }
      };
    }
  };
}, Wu = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      var n, o;
      const {
        x: r,
        y: a,
        placement: i,
        rects: l,
        middlewareData: c
      } = t, {
        offset: u = 0,
        mainAxis: f = !0,
        crossAxis: m = !0
      } = Ke(e, t), g = {
        x: r,
        y: a
      }, x = De(i), b = Go(x);
      let p = g[b], v = g[x];
      const w = Ke(u, t), C = typeof w == "number" ? {
        mainAxis: w,
        crossAxis: 0
      } : {
        mainAxis: (n = w.mainAxis) != null ? n : 0,
        crossAxis: (o = w.crossAxis) != null ? o : 0
      };
      if (f) {
        const E = b === "y" ? "height" : "width", M = l.reference[b] - l.floating[E] + C.mainAxis, j = l.reference[b] + l.reference[E] - C.mainAxis;
        p < M ? p = M : p > j && (p = j);
      }
      if (m) {
        var y, S;
        const E = b === "y" ? "width" : "height", M = ja.has(et(i)), j = l.reference[x] - l.floating[E] + (M && ((y = c.offset) == null ? void 0 : y[x]) || 0) + (M ? 0 : C.crossAxis), R = l.reference[x] + l.reference[E] + (M ? 0 : ((S = c.offset) == null ? void 0 : S[x]) || 0) - (M ? C.crossAxis : 0);
        v < j ? v = j : v > R && (v = R);
      }
      return {
        [b]: p,
        [x]: v
      };
    }
  };
}, Gu = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: o,
        platform: r,
        elements: a
      } = t, {
        apply: i = () => {
        },
        ...l
      } = Ke(e, t), c = await r.detectOverflow(t, l), u = et(n), f = kt(n), m = De(n) === "y", {
        width: g,
        height: x
      } = o.floating;
      let b, p;
      u === "top" || u === "bottom" ? (b = u, p = f === (await (r.isRTL == null ? void 0 : r.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (p = u, b = f === "end" ? "top" : "bottom");
      const v = x - c.top - c.bottom, w = g - c.left - c.right, C = Qe(x - c[b], v), y = Qe(g - c[p], w), S = t.middlewareData.shift, E = !S;
      let M = C, j = y;
      S != null && S.enabled.x && (j = w), S != null && S.enabled.y && (M = v), E && !f && (m ? j = g - 2 * Ze(c.left, c.right) : M = x - 2 * Ze(c.top, c.bottom)), await i({
        ...t,
        availableWidth: j,
        availableHeight: M
      });
      const R = await r.getDimensions(a.floating);
      return g !== R.width || x !== R.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function An() {
  return typeof window < "u";
}
function At(e) {
  return Pa(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ye(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ye(e) {
  var t;
  return (t = (Pa(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Pa(e) {
  return An() ? e instanceof Node || e instanceof ye(e).Node : !1;
}
function Fe(e) {
  return An() ? e instanceof Element || e instanceof ye(e).Element : !1;
}
function nt(e) {
  return An() ? e instanceof HTMLElement || e instanceof ye(e).HTMLElement : !1;
}
function Qr(e) {
  return !An() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ye(e).ShadowRoot;
}
function Tn(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: r
  } = Ve(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && r !== "inline" && r !== "contents";
}
function Zu(e) {
  return /^(table|td|th)$/.test(At(e));
}
function In(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const Uu = /transform|translate|scale|rotate|perspective|filter/, Ku = /paint|layout|strict|content/, ct = (e) => !!e && e !== "none";
let ro;
function Ko(e) {
  const t = Fe(e) ? Ve(e) : e;
  return ct(t.transform) || ct(t.translate) || ct(t.scale) || ct(t.rotate) || ct(t.perspective) || !Yo() && (ct(t.backdropFilter) || ct(t.filter)) || Uu.test(t.willChange || "") || Ku.test(t.contain || "");
}
function Yu(e) {
  let t = ft(e);
  for (; nt(t) && !Vt(t); ) {
    if (Ko(t))
      return t;
    if (In(t))
      return null;
    t = ft(t);
  }
  return null;
}
function Yo() {
  return ro == null && (ro = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), ro;
}
function Vt(e) {
  return /^(html|body|#document)$/.test(At(e));
}
function Ve(e) {
  return ye(e).getComputedStyle(e);
}
function On(e) {
  return Fe(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ft(e) {
  if (At(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Qr(e) && e.host || // Fallback.
    Ye(e)
  );
  return Qr(t) ? t.host : t;
}
function Na(e) {
  const t = ft(e);
  return Vt(t) ? (e.ownerDocument || e).body : nt(t) && Tn(t) ? t : Na(t);
}
function Ht(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = Na(e), a = r === ((o = e.ownerDocument) == null ? void 0 : o.body), i = ye(r);
  if (a) {
    const l = vo(i);
    return t.concat(i, i.visualViewport || [], Tn(r) ? r : [], l && n ? Ht(l) : []);
  } else
    return t.concat(r, Ht(r, [], n));
}
function vo(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function _a(e) {
  const t = Ve(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = nt(e), a = r ? e.offsetWidth : n, i = r ? e.offsetHeight : o, l = hn(n) !== a || hn(o) !== i;
  return l && (n = a, o = i), {
    width: n,
    height: o,
    $: l
  };
}
function Xo(e) {
  return Fe(e) ? e : e.contextElement;
}
function Rt(e) {
  const t = Xo(e);
  if (!nt(t))
    return Ue(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: a
  } = _a(t);
  let i = (a ? hn(n.width) : n.width) / o, l = (a ? hn(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: i,
    y: l
  };
}
const Xu = /* @__PURE__ */ Ue(0);
function ka(e) {
  const t = ye(e);
  return !Yo() || !t.visualViewport ? Xu : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function qu(e, t, n) {
  return t === void 0 && (t = !1), !!n && t && n === ye(e);
}
function pt(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), a = Xo(e);
  let i = Ue(1);
  t && (o ? Fe(o) && (i = Rt(o)) : i = Rt(e));
  const l = qu(a, n, o) ? ka(a) : Ue(0);
  let c = (r.left + l.x) / i.x, u = (r.top + l.y) / i.y, f = r.width / i.x, m = r.height / i.y;
  if (a && o) {
    const g = ye(a), x = Fe(o) ? ye(o) : o;
    let b = g, p = vo(b);
    for (; p && x !== b; ) {
      const v = Rt(p), w = p.getBoundingClientRect(), C = Ve(p), y = w.left + (p.clientLeft + parseFloat(C.paddingLeft)) * v.x, S = w.top + (p.clientTop + parseFloat(C.paddingTop)) * v.y;
      c *= v.x, u *= v.y, f *= v.x, m *= v.y, c += y, u += S, b = ye(p), p = vo(b);
    }
  }
  return vn({
    width: f,
    height: m,
    x: c,
    y: u
  });
}
function Ln(e, t) {
  const n = On(e).scrollLeft;
  return t ? t.left + n : pt(Ye(e)).left + n;
}
function Aa(e, t) {
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - Ln(e, n), r = n.top + t.scrollTop;
  return {
    x: o,
    y: r
  };
}
function Ju(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: r
  } = e;
  const a = r === "fixed", i = Ye(o), l = t ? In(t.floating) : !1;
  if (o === i || l && a)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Ue(1);
  const f = Ue(0), m = nt(o);
  if ((m || !a) && ((At(o) !== "body" || Tn(i)) && (c = On(o)), m)) {
    const x = pt(o);
    u = Rt(o), f.x = x.x + o.clientLeft, f.y = x.y + o.clientTop;
  }
  const g = i && !m && !a ? Aa(i, c) : Ue(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - c.scrollLeft * u.x + f.x + g.x,
    y: n.y * u.y - c.scrollTop * u.y + f.y + g.y
  };
}
function Qu(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function e2(e) {
  const t = On(e), n = e.ownerDocument.body, o = Ze(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), r = Ze(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let a = -t.scrollLeft + Ln(e);
  const i = -t.scrollTop;
  return Ve(n).direction === "rtl" && (a += Ze(e.clientWidth, n.clientWidth) - o), {
    width: o,
    height: r,
    x: a,
    y: i
  };
}
const t2 = 25;
function n2(e, t, n) {
  n === void 0 && (n = "viewport");
  const o = n === "layoutViewport", r = ye(e), a = Ye(e), i = r.visualViewport;
  let l = a.clientWidth, c = a.clientHeight, u = 0, f = 0;
  if (i) {
    const g = !Yo() || t === "fixed";
    o ? g || (u = -i.offsetLeft, f = -i.offsetTop) : (l = i.width, c = i.height, g && (u = i.offsetLeft, f = i.offsetTop));
  }
  if (Ln(a) <= 0) {
    const g = a.ownerDocument, x = g.body, b = getComputedStyle(x), p = g.compatMode === "CSS1Compat" && parseFloat(b.marginLeft) + parseFloat(b.marginRight) || 0, v = Math.abs(a.clientWidth - x.clientWidth - p), w = getComputedStyle(a).scrollbarGutter === "stable both-edges" ? v / 2 : v;
    w <= t2 && (l -= w);
  }
  return {
    width: l,
    height: c,
    x: u,
    y: f
  };
}
function o2(e, t) {
  const n = pt(e, !0, t === "fixed"), o = n.top + e.clientTop, r = n.left + e.clientLeft, a = Rt(e), i = e.clientWidth * a.x, l = e.clientHeight * a.y, c = r * a.x, u = o * a.y;
  return {
    width: i,
    height: l,
    x: c,
    y: u
  };
}
function es(e, t, n) {
  let o;
  if (t === "viewport" || t === "layoutViewport")
    o = n2(e, n, t);
  else if (t === "document")
    o = e2(Ye(e));
  else if (Fe(t))
    o = o2(t, n);
  else {
    const r = ka(e);
    o = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return vn(o);
}
function r2(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = Ht(e, [], !1).filter((l) => Fe(l) && At(l) !== "body"), r = null;
  const a = Ve(e).position === "fixed";
  let i = a ? ft(e) : e;
  for (; Fe(i) && !Vt(i); ) {
    const l = Ve(i), c = Ko(i), u = r ? r.position : a ? "fixed" : "";
    !c && (u === "fixed" || u === "absolute" && l.position === "static") ? o = o.filter((m) => m !== i) : r = l, i = ft(i);
  }
  return t.set(e, o), o;
}
function s2(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = e;
  const i = [...n === "clippingAncestors" ? In(t) ? [] : r2(t, this._c) : [].concat(n), o], l = es(t, i[0], r);
  let c = l.top, u = l.right, f = l.bottom, m = l.left;
  for (let g = 1; g < i.length; g++) {
    const x = es(t, i[g], r);
    c = Ze(x.top, c), u = Qe(x.right, u), f = Qe(x.bottom, f), m = Ze(x.left, m);
  }
  return {
    width: u - m,
    height: f - c,
    x: m,
    y: c
  };
}
function a2(e) {
  const {
    width: t,
    height: n
  } = _a(e);
  return {
    width: t,
    height: n
  };
}
function i2(e, t, n) {
  const o = nt(t), r = Ye(t), a = n === "fixed", i = pt(e, !0, a, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Ue(0);
  if ((o || !a) && ((At(t) !== "body" || Tn(r)) && (l = On(t)), o)) {
    const g = pt(t, !0, a, t);
    c.x = g.x + t.clientLeft, c.y = g.y + t.clientTop;
  }
  !o && r && (c.x = Ln(r));
  const u = r && !o && !a ? Aa(r, l) : Ue(0), f = i.left + l.scrollLeft - c.x - u.x, m = i.top + l.scrollTop - c.y - u.y;
  return {
    x: f,
    y: m,
    width: i.width,
    height: i.height
  };
}
function so(e) {
  return Ve(e).position === "static";
}
function ts(e, t) {
  if (!nt(e) || Ve(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Ye(e) === n && (n = n.ownerDocument.body), n;
}
function Ta(e, t) {
  const n = ye(e);
  if (In(e))
    return n;
  if (!nt(e)) {
    let r = ft(e);
    for (; r && !Vt(r); ) {
      if (Fe(r) && !so(r))
        return r;
      r = ft(r);
    }
    return n;
  }
  let o = ts(e, t);
  for (; o && Zu(o) && so(o); )
    o = ts(o, t);
  return o && Vt(o) && so(o) && !Ko(o) ? n : o || Yu(e) || n;
}
const l2 = async function(e) {
  const t = this.getOffsetParent || Ta, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: i2(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function c2(e) {
  return Ve(e).direction === "rtl";
}
const d2 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ju,
  getDocumentElement: Ye,
  getClippingRect: s2,
  getOffsetParent: Ta,
  getElementRects: l2,
  getClientRects: Qu,
  getDimensions: a2,
  getScale: Rt,
  isElement: Fe,
  isRTL: c2
};
function Ia(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function u2(e, t, n) {
  let o = null, r;
  const a = Ye(e);
  function i() {
    var f;
    clearTimeout(r), (f = o) == null || f.disconnect(), o = null;
  }
  function l(f, m) {
    f === void 0 && (f = !1), m === void 0 && (m = 1), i();
    const g = e.getBoundingClientRect(), {
      left: x,
      top: b,
      width: p,
      height: v
    } = g;
    if (f || t(), !p || !v)
      return;
    const w = an(b), C = an(a.clientWidth - (x + p)), y = an(a.clientHeight - (b + v)), S = an(x), M = {
      rootMargin: -w + "px " + -C + "px " + -y + "px " + -S + "px",
      threshold: Ze(0, Qe(1, m)) || 1
    };
    let j = !0;
    function R(_) {
      const L = _[0].intersectionRatio;
      if (!Ia(g, e.getBoundingClientRect()))
        return l();
      if (L !== m) {
        if (!j)
          return l();
        L ? l(!1, L) : r = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      j = !1;
    }
    try {
      o = new IntersectionObserver(R, {
        ...M,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      o = new IntersectionObserver(R, M);
    }
    o.observe(e);
  }
  const c = ye(e), u = () => l(n);
  return c.addEventListener("resize", u), l(!0), () => {
    c.removeEventListener("resize", u), i();
  };
}
function f2(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = o, u = Xo(e), f = r || a ? [...u ? Ht(u) : [], ...t ? Ht(t) : []] : [];
  f.forEach((w) => {
    r && w.addEventListener("scroll", n), a && w.addEventListener("resize", n);
  });
  const m = u && l ? u2(u, n, a) : null;
  let g = -1, x = null;
  i && (x = new ResizeObserver((w) => {
    let [C] = w;
    C && C.target === u && x && t && (x.unobserve(t), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var y;
      (y = x) == null || y.observe(t);
    })), n();
  }), u && !c && x.observe(u), t && x.observe(t));
  let b, p = c ? pt(e) : null;
  c && v();
  function v() {
    const w = pt(e);
    p && !Ia(p, w) && n(), p = w, b = requestAnimationFrame(v);
  }
  return n(), () => {
    var w;
    f.forEach((C) => {
      r && C.removeEventListener("scroll", n), a && C.removeEventListener("resize", n);
    }), m == null || m(), (w = x) == null || w.disconnect(), x = null, c && cancelAnimationFrame(b);
  };
}
const p2 = Bu, m2 = zu, h2 = Vu, g2 = Gu, v2 = Hu, ns = Fu, x2 = Wu, C2 = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = n ?? {}, a = {
    ...d2,
    ...r.platform,
    _c: o
  };
  return Du(e, t, {
    ...r,
    platform: a
  });
};
var b2 = typeof document < "u", w2 = function() {
}, un = b2 ? Kl : w2;
function xn(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (o = n; o-- !== 0; )
        if (!xn(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const a = r[o];
      if (!(a === "_owner" && e.$$typeof) && !xn(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Oa(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function os(e, t) {
  const n = Oa(e);
  return Math.round(t * n) / n;
}
function ao(e) {
  const t = d.useRef(e);
  return un(() => {
    t.current = e;
  }), t;
}
function y2(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: l = !0,
    whileElementsMounted: c,
    open: u
  } = e, [f, m] = d.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [g, x] = d.useState(o);
  xn(g, o) || x(o);
  const [b, p] = d.useState(null), [v, w] = d.useState(null), C = d.useCallback((P) => {
    P !== M.current && (M.current = P, p(P));
  }, []), y = d.useCallback((P) => {
    P !== j.current && (j.current = P, w(P));
  }, []), S = a || b, E = i || v, M = d.useRef(null), j = d.useRef(null), R = d.useRef(f), _ = c != null, L = ao(c), B = ao(r), X = ao(u), $ = d.useCallback(() => {
    if (!M.current || !j.current)
      return;
    const P = {
      placement: t,
      strategy: n,
      middleware: g
    };
    B.current && (P.platform = B.current), C2(M.current, j.current, P).then((te) => {
      const fe = {
        ...te,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: X.current !== !1
      };
      z.current && !xn(R.current, fe) && (R.current = fe, En.flushSync(() => {
        m(fe);
      }));
    });
  }, [g, t, n, B, X]);
  un(() => {
    u === !1 && R.current.isPositioned && (R.current.isPositioned = !1, m((P) => ({
      ...P,
      isPositioned: !1
    })));
  }, [u]);
  const z = d.useRef(!1);
  un(() => (z.current = !0, () => {
    z.current = !1;
  }), []), un(() => {
    if (S && (M.current = S), E && (j.current = E), S && E) {
      if (L.current)
        return L.current(S, E, $);
      $();
    }
  }, [S, E, $, L, _]);
  const G = d.useMemo(() => ({
    reference: M,
    floating: j,
    setReference: C,
    setFloating: y
  }), [C, y]), D = d.useMemo(() => ({
    reference: S,
    floating: E
  }), [S, E]), Z = d.useMemo(() => {
    const P = {
      position: n,
      left: 0,
      top: 0
    };
    if (!D.floating)
      return P;
    const te = os(D.floating, f.x), fe = os(D.floating, f.y);
    return l ? {
      ...P,
      transform: "translate(" + te + "px, " + fe + "px)",
      ...Oa(D.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: te,
      top: fe
    };
  }, [n, l, D.floating, f.x, f.y]);
  return d.useMemo(() => ({
    ...f,
    update: $,
    refs: G,
    elements: D,
    floatingStyles: Z
  }), [f, $, G, D, Z]);
}
const S2 = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? ns({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? ns({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
}, E2 = (e, t) => {
  const n = p2(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, R2 = (e, t) => {
  const n = m2(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, M2 = (e, t) => ({
  fn: x2(e).fn,
  options: [e, t]
}), j2 = (e, t) => {
  const n = h2(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, P2 = (e, t) => {
  const n = g2(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, N2 = (e, t) => {
  const n = v2(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, _2 = (e, t) => {
  const n = S2(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
};
var k2 = "Arrow", La = d.forwardRef((e, t) => {
  const { children: n, width: o = 10, height: r = 5, ...a } = e;
  return /* @__PURE__ */ s.jsx(
    V.svg,
    {
      ...a,
      ref: t,
      width: o,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ s.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
La.displayName = k2;
var A2 = La, qo = "Popper", [Da, Dn] = He(qo), [T2, Fa] = Da(qo), Va = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = d.useState(null);
  return /* @__PURE__ */ s.jsx(T2, { scope: t, anchor: o, onAnchorChange: r, children: n });
};
Va.displayName = qo;
var Ha = "PopperAnchor", $a = d.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: o, ...r } = e, a = Fa(Ha, n), i = d.useRef(null), l = ne(t, i), c = d.useRef(null);
    return d.useEffect(() => {
      const u = c.current;
      c.current = (o == null ? void 0 : o.current) || i.current, u !== c.current && a.onAnchorChange(c.current);
    }), o ? null : /* @__PURE__ */ s.jsx(V.div, { ...r, ref: l });
  }
);
$a.displayName = Ha;
var Jo = "PopperContent", [I2, O2] = Da(Jo), Ba = d.forwardRef(
  (e, t) => {
    var A, Q, ae, U, q, K;
    const {
      __scopePopper: n,
      side: o = "bottom",
      sideOffset: r = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: l = 0,
      avoidCollisions: c = !0,
      collisionBoundary: u = [],
      collisionPadding: f = 0,
      sticky: m = "partial",
      hideWhenDetached: g = !1,
      updatePositionStrategy: x = "optimized",
      onPlaced: b,
      ...p
    } = e, v = Fa(Jo, n), [w, C] = d.useState(null), y = ne(t, (ve) => C(ve)), [S, E] = d.useState(null), M = Ru(S), j = (M == null ? void 0 : M.width) ?? 0, R = (M == null ? void 0 : M.height) ?? 0, _ = o + (a !== "center" ? "-" + a : ""), L = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, B = Array.isArray(u) ? u : [u], X = B.length > 0, $ = {
      padding: L,
      boundary: B.filter(D2),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: X
    }, { refs: z, floatingStyles: G, placement: D, isPositioned: Z, middlewareData: P } = y2({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: _,
      whileElementsMounted: (...ve) => f2(...ve, {
        animationFrame: x === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        E2({ mainAxis: r + R, alignmentAxis: i }),
        c && R2({
          mainAxis: !0,
          crossAxis: !1,
          limiter: m === "partial" ? M2() : void 0,
          ...$
        }),
        c && j2({ ...$ }),
        P2({
          ...$,
          apply: ({ elements: ve, rects: Me, availableWidth: Ie, availableHeight: _e }) => {
            const { width: Xe, height: Kt } = Me.reference, ze = ve.floating.style;
            ze.setProperty("--radix-popper-available-width", `${Ie}px`), ze.setProperty("--radix-popper-available-height", `${_e}px`), ze.setProperty("--radix-popper-anchor-width", `${Xe}px`), ze.setProperty("--radix-popper-anchor-height", `${Kt}px`);
          }
        }),
        S && _2({ element: S, padding: l }),
        F2({ arrowWidth: j, arrowHeight: R }),
        g && N2({ strategy: "referenceHidden", ...$ })
      ]
    }), [te, fe] = Ga(D), ge = Ce(b);
    me(() => {
      Z && (ge == null || ge());
    }, [Z, ge]);
    const Re = (A = P.arrow) == null ? void 0 : A.x, le = (Q = P.arrow) == null ? void 0 : Q.y, ce = ((ae = P.arrow) == null ? void 0 : ae.centerOffset) !== 0, [Se, be] = d.useState();
    return me(() => {
      w && be(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ s.jsx(
      "div",
      {
        ref: z.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...G,
          transform: Z ? G.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Se,
          "--radix-popper-transform-origin": [
            (U = P.transformOrigin) == null ? void 0 : U.x,
            (q = P.transformOrigin) == null ? void 0 : q.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((K = P.hide) == null ? void 0 : K.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ s.jsx(
          I2,
          {
            scope: n,
            placedSide: te,
            onArrowChange: E,
            arrowX: Re,
            arrowY: le,
            shouldHideArrow: ce,
            children: /* @__PURE__ */ s.jsx(
              V.div,
              {
                "data-side": te,
                "data-align": fe,
                ...p,
                ref: y,
                style: {
                  ...p.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: Z ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Ba.displayName = Jo;
var za = "PopperArrow", L2 = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Wa = d.forwardRef(function(t, n) {
  const { __scopePopper: o, ...r } = t, a = O2(za, o), i = L2[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ s.jsx(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ s.jsx(
          A2,
          {
            ...r,
            ref: n,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Wa.displayName = za;
function D2(e) {
  return e !== null;
}
var F2 = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var v, w, C;
    const { placement: n, rects: o, middlewareData: r } = t, i = ((v = r.arrow) == null ? void 0 : v.centerOffset) !== 0, l = i ? 0 : e.arrowWidth, c = i ? 0 : e.arrowHeight, [u, f] = Ga(n), m = { start: "0%", center: "50%", end: "100%" }[f], g = (((w = r.arrow) == null ? void 0 : w.x) ?? 0) + l / 2, x = (((C = r.arrow) == null ? void 0 : C.y) ?? 0) + c / 2;
    let b = "", p = "";
    return u === "bottom" ? (b = i ? m : `${g}px`, p = `${-c}px`) : u === "top" ? (b = i ? m : `${g}px`, p = `${o.floating.height + c}px`) : u === "right" ? (b = `${-c}px`, p = i ? m : `${x}px`) : u === "left" && (b = `${o.floating.width + c}px`, p = i ? m : `${x}px`), { data: { x: b, y: p } };
  }
});
function Ga(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Za = Va, Qo = $a, Ua = Ba, Ka = Wa, io = "rovingFocusGroup.onEntryFocus", V2 = { bubbles: !1, cancelable: !0 }, Zt = "RovingFocusGroup", [xo, Ya, H2] = zt(Zt), [$2, Xa] = He(
  Zt,
  [H2]
), [B2, z2] = $2(Zt), qa = d.forwardRef(
  (e, t) => /* @__PURE__ */ s.jsx(xo.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ s.jsx(xo.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ s.jsx(W2, { ...e, ref: t }) }) })
);
qa.displayName = Zt;
var W2 = d.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: o,
    loop: r = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: l,
    onCurrentTabStopIdChange: c,
    onEntryFocus: u,
    preventScrollOnEntryFocus: f = !1,
    ...m
  } = e, g = d.useRef(null), x = ne(t, g), b = Wt(a), [p, v] = Ee({
    prop: i,
    defaultProp: l ?? null,
    onChange: c,
    caller: Zt
  }), [w, C] = d.useState(!1), y = Ce(u), S = Ya(n), E = d.useRef(!1), [M, j] = d.useState(0);
  return d.useEffect(() => {
    const R = g.current;
    if (R)
      return R.addEventListener(io, y), () => R.removeEventListener(io, y);
  }, [y]), /* @__PURE__ */ s.jsx(
    B2,
    {
      scope: n,
      orientation: o,
      dir: b,
      loop: r,
      currentTabStopId: p,
      onItemFocus: d.useCallback(
        (R) => v(R),
        [v]
      ),
      onItemShiftTab: d.useCallback(() => C(!0), []),
      onFocusableItemAdd: d.useCallback(
        () => j((R) => R + 1),
        []
      ),
      onFocusableItemRemove: d.useCallback(
        () => j((R) => R - 1),
        []
      ),
      children: /* @__PURE__ */ s.jsx(
        V.div,
        {
          tabIndex: w || M === 0 ? -1 : 0,
          "data-orientation": o,
          ...m,
          ref: x,
          style: { outline: "none", ...e.style },
          onMouseDown: F(e.onMouseDown, () => {
            E.current = !0;
          }),
          onFocus: F(e.onFocus, (R) => {
            const _ = !E.current;
            if (R.target === R.currentTarget && _ && !w) {
              const L = new CustomEvent(io, V2);
              if (R.currentTarget.dispatchEvent(L), !L.defaultPrevented) {
                const B = S().filter((D) => D.focusable), X = B.find((D) => D.active), $ = B.find((D) => D.id === p), G = [X, $, ...B].filter(
                  Boolean
                ).map((D) => D.ref.current);
                ei(G, f);
              }
            }
            E.current = !1;
          }),
          onBlur: F(e.onBlur, () => C(!1))
        }
      )
    }
  );
}), Ja = "RovingFocusGroupItem", Qa = d.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: o = !0,
      active: r = !1,
      tabStopId: a,
      children: i,
      ...l
    } = e, c = Pe(), u = a || c, f = z2(Ja, n), m = f.currentTabStopId === u, g = Ya(n), { onFocusableItemAdd: x, onFocusableItemRemove: b, currentTabStopId: p } = f;
    return d.useEffect(() => {
      if (o)
        return x(), () => b();
    }, [o, x, b]), /* @__PURE__ */ s.jsx(
      xo.ItemSlot,
      {
        scope: n,
        id: u,
        focusable: o,
        active: r,
        children: /* @__PURE__ */ s.jsx(
          V.span,
          {
            tabIndex: m ? 0 : -1,
            "data-orientation": f.orientation,
            ...l,
            ref: t,
            onMouseDown: F(e.onMouseDown, (v) => {
              o ? f.onItemFocus(u) : v.preventDefault();
            }),
            onFocus: F(e.onFocus, () => f.onItemFocus(u)),
            onKeyDown: F(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                f.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const w = U2(v, f.orientation, f.dir);
              if (w !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let y = g().filter((S) => S.focusable).map((S) => S.ref.current);
                if (w === "last") y.reverse();
                else if (w === "prev" || w === "next") {
                  w === "prev" && y.reverse();
                  const S = y.indexOf(v.currentTarget);
                  y = f.loop ? K2(y, S + 1) : y.slice(S + 1);
                }
                setTimeout(() => ei(y));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: m, hasTabStop: p != null }) : i
          }
        )
      }
    );
  }
);
Qa.displayName = Ja;
var G2 = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Z2(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function U2(e, t, n) {
  const o = Z2(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return G2[o];
}
function ei(e, t = !1) {
  const n = document.activeElement;
  for (const o of e)
    if (o === n || (o.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function K2(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var Y2 = qa, X2 = Qa, gt = "NavigationMenu", [er, ti, q2] = zt(gt), [Co, J2, Q2] = zt(gt), [tr] = He(
  gt,
  [q2, Q2]
), [ef, Ne] = tr(gt), [tf, nf] = tr(gt), ni = d.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: o,
      onValueChange: r,
      defaultValue: a,
      delayDuration: i = 200,
      skipDelayDuration: l = 300,
      orientation: c = "horizontal",
      dir: u,
      ...f
    } = e, [m, g] = d.useState(null), x = ne(t, (_) => g(_)), b = Wt(u), p = d.useRef(0), v = d.useRef(0), w = d.useRef(0), [C, y] = d.useState(!0), [S, E] = Ee({
      prop: o,
      onChange: (_) => {
        const L = _ !== "", B = l > 0;
        L ? (window.clearTimeout(w.current), B && y(!1)) : (window.clearTimeout(w.current), w.current = window.setTimeout(
          () => y(!0),
          l
        )), r == null || r(_);
      },
      defaultProp: a ?? "",
      caller: gt
    }), M = d.useCallback(() => {
      window.clearTimeout(v.current), v.current = window.setTimeout(() => E(""), 150);
    }, [E]), j = d.useCallback(
      (_) => {
        window.clearTimeout(v.current), E(_);
      },
      [E]
    ), R = d.useCallback(
      (_) => {
        S === _ ? window.clearTimeout(v.current) : p.current = window.setTimeout(() => {
          window.clearTimeout(v.current), E(_);
        }, i);
      },
      [S, E, i]
    );
    return d.useEffect(() => () => {
      window.clearTimeout(p.current), window.clearTimeout(v.current), window.clearTimeout(w.current);
    }, []), /* @__PURE__ */ s.jsx(
      oi,
      {
        scope: n,
        isRootMenu: !0,
        value: S,
        dir: b,
        orientation: c,
        rootNavigationMenu: m,
        onTriggerEnter: (_) => {
          window.clearTimeout(p.current), C ? R(_) : j(_);
        },
        onTriggerLeave: () => {
          window.clearTimeout(p.current), M();
        },
        onContentEnter: () => window.clearTimeout(v.current),
        onContentLeave: M,
        onItemSelect: (_) => {
          E((L) => L === _ ? "" : _);
        },
        onItemDismiss: () => E(""),
        children: /* @__PURE__ */ s.jsx(
          V.nav,
          {
            "aria-label": "Main",
            "data-orientation": c,
            dir: b,
            ...f,
            ref: x
          }
        )
      }
    );
  }
);
ni.displayName = gt;
var bo = "NavigationMenuSub", of = d.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: o,
      onValueChange: r,
      defaultValue: a,
      orientation: i = "horizontal",
      ...l
    } = e, c = Ne(bo, n), [u, f] = Ee({
      prop: o,
      onChange: r,
      defaultProp: a ?? "",
      caller: bo
    });
    return /* @__PURE__ */ s.jsx(
      oi,
      {
        scope: n,
        isRootMenu: !1,
        value: u,
        dir: c.dir,
        orientation: i,
        rootNavigationMenu: c.rootNavigationMenu,
        onTriggerEnter: (m) => f(m),
        onItemSelect: (m) => f(m),
        onItemDismiss: () => f(""),
        children: /* @__PURE__ */ s.jsx(V.div, { "data-orientation": i, ...l, ref: t })
      }
    );
  }
);
of.displayName = bo;
var oi = (e) => {
  const {
    scope: t,
    isRootMenu: n,
    rootNavigationMenu: o,
    dir: r,
    orientation: a,
    children: i,
    value: l,
    onItemSelect: c,
    onItemDismiss: u,
    onTriggerEnter: f,
    onTriggerLeave: m,
    onContentEnter: g,
    onContentLeave: x
  } = e, [b, p] = d.useState(null), [v, w] = d.useState(/* @__PURE__ */ new Map()), [C, y] = d.useState(null);
  return /* @__PURE__ */ s.jsx(
    ef,
    {
      scope: t,
      isRootMenu: n,
      rootNavigationMenu: o,
      value: l,
      previousValue: Ea(l),
      baseId: Pe(),
      dir: r,
      orientation: a,
      viewport: b,
      onViewportChange: p,
      indicatorTrack: C,
      onIndicatorTrackChange: y,
      onTriggerEnter: Ce(f),
      onTriggerLeave: Ce(m),
      onContentEnter: Ce(g),
      onContentLeave: Ce(x),
      onItemSelect: Ce(c),
      onItemDismiss: Ce(u),
      onViewportContentChange: d.useCallback((S, E) => {
        w((M) => (M.set(S, E), new Map(M)));
      }, []),
      onViewportContentRemove: d.useCallback((S) => {
        w((E) => E.has(S) ? (E.delete(S), new Map(E)) : E);
      }, []),
      children: /* @__PURE__ */ s.jsx(er.Provider, { scope: t, children: /* @__PURE__ */ s.jsx(tf, { scope: t, items: v, children: i }) })
    }
  );
}, ri = "NavigationMenuList", si = d.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...o } = e, r = Ne(ri, n), a = /* @__PURE__ */ s.jsx(V.ul, { "data-orientation": r.orientation, ...o, ref: t });
    return /* @__PURE__ */ s.jsx(V.div, { style: { position: "relative" }, ref: r.onIndicatorTrackChange, children: /* @__PURE__ */ s.jsx(er.Slot, { scope: n, children: r.isRootMenu ? /* @__PURE__ */ s.jsx(hi, { asChild: !0, children: a }) : a }) });
  }
);
si.displayName = ri;
var ai = "NavigationMenuItem", [rf, ii] = tr(ai), li = d.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, value: o, ...r } = e, a = Pe(), i = o || a || "LEGACY_REACT_AUTO_VALUE", l = d.useRef(null), c = d.useRef(null), u = d.useRef(null), f = d.useRef(() => {
    }), m = d.useRef(!1), g = d.useCallback((b = "start") => {
      if (l.current) {
        f.current();
        const p = yo(l.current);
        p.length && rr(b === "start" ? p : p.reverse());
      }
    }, []), x = d.useCallback(() => {
      if (l.current) {
        const b = yo(l.current);
        b.length && (f.current = ff(b));
      }
    }, []);
    return /* @__PURE__ */ s.jsx(
      rf,
      {
        scope: n,
        value: i,
        triggerRef: c,
        contentRef: l,
        focusProxyRef: u,
        wasEscapeCloseRef: m,
        onEntryKeyDown: g,
        onFocusProxyEnter: g,
        onRootContentClose: x,
        onContentFocusOutside: x,
        children: /* @__PURE__ */ s.jsx(V.li, { ...r, ref: t })
      }
    );
  }
);
li.displayName = ai;
var wo = "NavigationMenuTrigger", ci = d.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, disabled: o, ...r } = e, a = Ne(wo, e.__scopeNavigationMenu), i = ii(wo, e.__scopeNavigationMenu), l = d.useRef(null), c = ne(l, i.triggerRef, t), u = vi(a.baseId, i.value), f = xi(a.baseId, i.value), m = d.useRef(!1), g = d.useRef(!1), x = i.value === a.value;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(er.ItemSlot, { scope: n, value: i.value, children: /* @__PURE__ */ s.jsx(gi, { asChild: !0, children: /* @__PURE__ */ s.jsx(
      V.button,
      {
        id: u,
        disabled: o,
        "data-disabled": o ? "" : void 0,
        "data-state": sr(x),
        "aria-expanded": x,
        "aria-controls": f,
        ...r,
        ref: c,
        onPointerEnter: F(e.onPointerEnter, () => {
          g.current = !1, i.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: F(
          e.onPointerMove,
          Cn(() => {
            o || g.current || i.wasEscapeCloseRef.current || m.current || (a.onTriggerEnter(i.value), m.current = !0);
          })
        ),
        onPointerLeave: F(
          e.onPointerLeave,
          Cn(() => {
            o || (a.onTriggerLeave(), m.current = !1);
          })
        ),
        onClick: F(e.onClick, () => {
          a.onItemSelect(i.value), g.current = x;
        }),
        onKeyDown: F(e.onKeyDown, (b) => {
          const v = { horizontal: "ArrowDown", vertical: a.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[a.orientation];
          x && b.key === v && (i.onEntryKeyDown(), b.preventDefault());
        })
      }
    ) }) }),
    x && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        A1,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: i.focusProxyRef,
          onFocus: (b) => {
            const p = i.contentRef.current, v = b.relatedTarget, w = v === l.current, C = p == null ? void 0 : p.contains(v);
            (w || !C) && i.onFocusProxyEnter(w ? "start" : "end");
          }
        }
      ),
      a.viewport && /* @__PURE__ */ s.jsx("span", { "aria-owns": f })
    ] })
  ] });
});
ci.displayName = wo;
var sf = "NavigationMenuLink", rs = "navigationMenu.linkSelect", di = d.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, active: o, onSelect: r, ...a } = e;
    return /* @__PURE__ */ s.jsx(gi, { asChild: !0, children: /* @__PURE__ */ s.jsx(
      V.a,
      {
        "data-active": o ? "" : void 0,
        "aria-current": o ? "page" : void 0,
        ...a,
        ref: t,
        onClick: F(
          e.onClick,
          (i) => {
            const l = i.target, c = new CustomEvent(rs, {
              bubbles: !0,
              cancelable: !0
            });
            if (l.addEventListener(rs, (u) => r == null ? void 0 : r(u), { once: !0 }), fo(l, c), !c.defaultPrevented && !i.metaKey) {
              const u = new CustomEvent(fn, {
                bubbles: !0,
                cancelable: !0
              });
              fo(l, u);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
di.displayName = sf;
var nr = "NavigationMenuIndicator", ui = d.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = Ne(nr, e.__scopeNavigationMenu), a = !!r.value;
  return r.indicatorTrack ? ps.createPortal(
    /* @__PURE__ */ s.jsx($e, { present: n || a, children: /* @__PURE__ */ s.jsx(af, { ...o, ref: t }) }),
    r.indicatorTrack
  ) : null;
});
ui.displayName = nr;
var af = d.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, ...o } = e, r = Ne(nr, n), a = ti(n), [i, l] = d.useState(
    null
  ), [c, u] = d.useState(null), f = r.orientation === "horizontal", m = !!r.value;
  d.useEffect(() => {
    var p;
    const b = (p = a().find((v) => v.value === r.value)) == null ? void 0 : p.ref.current;
    b && l(b);
  }, [a, r.value]);
  const g = () => {
    i && u({
      size: f ? i.offsetWidth : i.offsetHeight,
      offset: f ? i.offsetLeft : i.offsetTop
    });
  };
  return So(i, g), So(r.indicatorTrack, g), c ? /* @__PURE__ */ s.jsx(
    V.div,
    {
      "aria-hidden": !0,
      "data-state": m ? "visible" : "hidden",
      "data-orientation": r.orientation,
      ...o,
      ref: t,
      style: {
        position: "absolute",
        ...f ? {
          left: 0,
          width: c.size + "px",
          transform: `translateX(${c.offset}px)`
        } : {
          top: 0,
          height: c.size + "px",
          transform: `translateY(${c.offset}px)`
        },
        ...o.style
      }
    }
  ) : null;
}), Mt = "NavigationMenuContent", fi = d.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = Ne(Mt, e.__scopeNavigationMenu), a = ii(Mt, e.__scopeNavigationMenu), i = ne(a.contentRef, t), l = a.value === r.value, c = {
    value: a.value,
    triggerRef: a.triggerRef,
    focusProxyRef: a.focusProxyRef,
    wasEscapeCloseRef: a.wasEscapeCloseRef,
    onContentFocusOutside: a.onContentFocusOutside,
    onRootContentClose: a.onRootContentClose,
    ...o
  };
  return r.viewport ? /* @__PURE__ */ s.jsx(lf, { forceMount: n, ...c, ref: i }) : /* @__PURE__ */ s.jsx($e, { present: n || l, children: /* @__PURE__ */ s.jsx(
    pi,
    {
      "data-state": sr(l),
      ...c,
      ref: i,
      onPointerEnter: F(e.onPointerEnter, r.onContentEnter),
      onPointerLeave: F(
        e.onPointerLeave,
        Cn(r.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !l && r.isRootMenu ? "none" : void 0,
        ...c.style
      }
    }
  ) });
});
fi.displayName = Mt;
var lf = d.forwardRef((e, t) => {
  const n = Ne(Mt, e.__scopeNavigationMenu), { onViewportContentChange: o, onViewportContentRemove: r } = n;
  return me(() => {
    o(e.value, {
      ref: t,
      ...e
    });
  }, [e, t, o]), me(() => () => r(e.value), [e.value, r]), null;
}), fn = "navigationMenu.rootContentDismiss", pi = d.forwardRef((e, t) => {
  const {
    __scopeNavigationMenu: n,
    value: o,
    triggerRef: r,
    focusProxyRef: a,
    wasEscapeCloseRef: i,
    onRootContentClose: l,
    onContentFocusOutside: c,
    ...u
  } = e, f = Ne(Mt, n), m = d.useRef(null), g = ne(m, t), x = vi(f.baseId, o), b = xi(f.baseId, o), p = ti(n), v = d.useRef(null), { onItemDismiss: w } = f;
  d.useEffect(() => {
    const y = m.current;
    if (f.isRootMenu && y) {
      const S = () => {
        var E;
        w(), l(), y.contains(document.activeElement) && ((E = r.current) == null || E.focus());
      };
      return y.addEventListener(fn, S), () => y.removeEventListener(fn, S);
    }
  }, [f.isRootMenu, e.value, r, w, l]);
  const C = d.useMemo(() => {
    const S = p().map((L) => L.value);
    f.dir === "rtl" && S.reverse();
    const E = S.indexOf(f.value), M = S.indexOf(f.previousValue), j = o === f.value, R = M === S.indexOf(o);
    if (!j && !R) return v.current;
    const _ = (() => {
      if (E !== M) {
        if (j && M !== -1) return E > M ? "from-end" : "from-start";
        if (R && E !== -1) return E > M ? "to-start" : "to-end";
      }
      return null;
    })();
    return v.current = _, _;
  }, [f.previousValue, f.value, f.dir, p, o]);
  return /* @__PURE__ */ s.jsx(hi, { asChild: !0, children: /* @__PURE__ */ s.jsx(
    Gt,
    {
      id: b,
      "aria-labelledby": x,
      "data-motion": C,
      "data-orientation": f.orientation,
      ...u,
      ref: g,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        var S;
        const y = new Event(fn, {
          bubbles: !0,
          cancelable: !0
        });
        (S = m.current) == null || S.dispatchEvent(y);
      },
      onFocusOutside: F(e.onFocusOutside, (y) => {
        var E;
        c();
        const S = y.target;
        (E = f.rootNavigationMenu) != null && E.contains(S) && y.preventDefault();
      }),
      onPointerDownOutside: F(e.onPointerDownOutside, (y) => {
        var j;
        const S = y.target, E = p().some((R) => {
          var _;
          return (_ = R.ref.current) == null ? void 0 : _.contains(S);
        }), M = f.isRootMenu && ((j = f.viewport) == null ? void 0 : j.contains(S));
        (E || M || !f.isRootMenu) && y.preventDefault();
      }),
      onKeyDown: F(e.onKeyDown, (y) => {
        var M;
        const S = y.altKey || y.ctrlKey || y.metaKey;
        if (y.key === "Tab" && !S) {
          const j = yo(y.currentTarget), R = document.activeElement, _ = j.findIndex((X) => X === R), B = y.shiftKey ? j.slice(0, _).reverse() : j.slice(_ + 1, j.length);
          rr(B) ? y.preventDefault() : (M = a.current) == null || M.focus();
        }
      }),
      onEscapeKeyDown: F(e.onEscapeKeyDown, (y) => {
        i.current = !0;
      })
    }
  ) });
}), or = "NavigationMenuViewport", mi = d.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, a = !!Ne(or, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ s.jsx($e, { present: n || a, children: /* @__PURE__ */ s.jsx(cf, { ...o, ref: t }) });
});
mi.displayName = or;
var cf = d.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, children: o, ...r } = e, a = Ne(or, n), i = ne(t, a.onViewportChange), l = nf(
    Mt,
    e.__scopeNavigationMenu
  ), [c, u] = d.useState(null), [f, m] = d.useState(null), g = c ? (c == null ? void 0 : c.width) + "px" : void 0, x = c ? (c == null ? void 0 : c.height) + "px" : void 0, b = !!a.value, p = b ? a.value : a.previousValue;
  return So(f, () => {
    f && u({ width: f.offsetWidth, height: f.offsetHeight });
  }), /* @__PURE__ */ s.jsx(
    V.div,
    {
      "data-state": sr(b),
      "data-orientation": a.orientation,
      ...r,
      ref: i,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !b && a.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": g,
        "--radix-navigation-menu-viewport-height": x,
        ...r.style
      },
      onPointerEnter: F(e.onPointerEnter, a.onContentEnter),
      onPointerLeave: F(e.onPointerLeave, Cn(a.onContentLeave)),
      children: Array.from(l.items).map(([w, { ref: C, forceMount: y, ...S }]) => {
        const E = p === w;
        return /* @__PURE__ */ s.jsx($e, { present: y || E, children: /* @__PURE__ */ s.jsx(
          pi,
          {
            ...S,
            ref: ko(C, (M) => {
              E && M && m(M);
            })
          }
        ) }, w);
      })
    }
  );
}), df = "FocusGroup", hi = d.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...o } = e, r = Ne(df, n);
    return /* @__PURE__ */ s.jsx(Co.Provider, { scope: n, children: /* @__PURE__ */ s.jsx(Co.Slot, { scope: n, children: /* @__PURE__ */ s.jsx(V.div, { dir: r.dir, ...o, ref: t }) }) });
  }
), ss = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], uf = "FocusGroupItem", gi = d.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...o } = e, r = J2(n), a = Ne(uf, n);
    return /* @__PURE__ */ s.jsx(Co.ItemSlot, { scope: n, children: /* @__PURE__ */ s.jsx(
      V.button,
      {
        ...o,
        ref: t,
        onKeyDown: F(e.onKeyDown, (i) => {
          if (["Home", "End", ...ss].includes(i.key)) {
            let c = r().map((m) => m.ref.current);
            if ([a.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(i.key) && c.reverse(), ss.includes(i.key)) {
              const m = c.indexOf(i.currentTarget);
              c = c.slice(m + 1);
            }
            setTimeout(() => rr(c)), i.preventDefault();
          }
        })
      }
    ) });
  }
);
function yo(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function rr(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function ff(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const n = t.dataset.tabindex;
      t.setAttribute("tabindex", n);
    });
  };
}
function So(e, t) {
  const n = Ce(t);
  me(() => {
    let o = 0;
    if (e) {
      const r = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(n);
      });
      return r.observe(e), () => {
        window.cancelAnimationFrame(o), r.unobserve(e);
      };
    }
  }, [e, n]);
}
function sr(e) {
  return e ? "open" : "closed";
}
function vi(e, t) {
  return `${e}-trigger-${t}`;
}
function xi(e, t) {
  return `${e}-content-${t}`;
}
function Cn(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var pf = ni, mf = si, hf = li, gf = ci, vf = di, xf = ui, Cf = fi, bf = mi;
function as(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
var Fn = "Popover", [Ci] = He(Fn, [
  Dn
]), Ut = Dn(), [wf, ot] = Ci(Fn), bi = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    modal: i = !1
  } = e, l = Ut(t), c = d.useRef(null), [u, f] = d.useState(!1), [m, g] = Ee({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: Fn
  });
  return /* @__PURE__ */ s.jsx(Za, { ...l, children: /* @__PURE__ */ s.jsx(
    wf,
    {
      scope: t,
      contentId: Pe(),
      triggerRef: c,
      open: m,
      onOpenChange: g,
      onOpenToggle: d.useCallback(() => g((x) => !x), [g]),
      hasCustomAnchor: u,
      onCustomAnchorAdd: d.useCallback(() => f(!0), []),
      onCustomAnchorRemove: d.useCallback(() => f(!1), []),
      modal: i,
      children: n
    }
  ) });
};
bi.displayName = Fn;
var wi = "PopoverAnchor", yi = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = ot(wi, n), a = Ut(n), { onCustomAnchorAdd: i, onCustomAnchorRemove: l } = r;
    return d.useEffect(() => (i(), () => l()), [i, l]), /* @__PURE__ */ s.jsx(Qo, { ...a, ...o, ref: t });
  }
);
yi.displayName = wi;
var Si = "PopoverTrigger", Ei = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = ot(Si, n), a = Ut(n), i = ne(t, r.triggerRef), l = /* @__PURE__ */ s.jsx(
      V.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": Ni(r.open),
        ...o,
        ref: i,
        onClick: F(e.onClick, r.onOpenToggle)
      }
    );
    return r.hasCustomAnchor ? l : /* @__PURE__ */ s.jsx(Qo, { asChild: !0, ...a, children: l });
  }
);
Ei.displayName = Si;
var ar = "PopoverPortal", [yf, Sf] = Ci(ar, {
  forceMount: void 0
}), Ri = (e) => {
  const { __scopePopover: t, forceMount: n, children: o, container: r } = e, a = ot(ar, t);
  return /* @__PURE__ */ s.jsx(yf, { scope: t, forceMount: n, children: /* @__PURE__ */ s.jsx($e, { present: n || a.open, children: /* @__PURE__ */ s.jsx(Ho, { asChild: !0, container: r, children: o }) }) });
};
Ri.displayName = ar;
var jt = "PopoverContent", Mi = d.forwardRef(
  (e, t) => {
    const n = Sf(jt, e.__scopePopover), { forceMount: o = n.forceMount, ...r } = e, a = ot(jt, e.__scopePopover);
    return /* @__PURE__ */ s.jsx($e, { present: o || a.open, children: a.modal ? /* @__PURE__ */ s.jsx(Rf, { ...r, ref: t }) : /* @__PURE__ */ s.jsx(Mf, { ...r, ref: t }) });
  }
);
Mi.displayName = jt;
var Ef = /* @__PURE__ */ dt("PopoverContent.RemoveScroll"), Rf = d.forwardRef(
  (e, t) => {
    const n = ot(jt, e.__scopePopover), o = d.useRef(null), r = ne(t, o), a = d.useRef(!1);
    return d.useEffect(() => {
      const i = o.current;
      if (i) return Bo(i);
    }, []), /* @__PURE__ */ s.jsx(_n, { as: Ef, allowPinchZoom: !0, children: /* @__PURE__ */ s.jsx(
      ji,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: F(e.onCloseAutoFocus, (i) => {
          var l;
          i.preventDefault(), a.current || (l = n.triggerRef.current) == null || l.focus();
        }),
        onPointerDownOutside: F(
          e.onPointerDownOutside,
          (i) => {
            const l = i.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, u = l.button === 2 || c;
            a.current = u;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: F(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), Mf = d.forwardRef(
  (e, t) => {
    const n = ot(jt, e.__scopePopover), o = d.useRef(!1), r = d.useRef(!1);
    return /* @__PURE__ */ s.jsx(
      ji,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, l;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (o.current || (l = n.triggerRef.current) == null || l.focus(), a.preventDefault()), o.current = !1, r.current = !1;
        },
        onInteractOutside: (a) => {
          var c, u;
          (c = e.onInteractOutside) == null || c.call(e, a), a.defaultPrevented || (o.current = !0, a.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const i = a.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && r.current && a.preventDefault();
        }
      }
    );
  }
), ji = d.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: o,
      onOpenAutoFocus: r,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: i,
      onEscapeKeyDown: l,
      onPointerDownOutside: c,
      onFocusOutside: u,
      onInteractOutside: f,
      ...m
    } = e, g = ot(jt, n), x = Ut(n);
    return $o(), /* @__PURE__ */ s.jsx(
      Pn,
      {
        asChild: !0,
        loop: !0,
        trapped: o,
        onMountAutoFocus: r,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ s.jsx(
          Gt,
          {
            asChild: !0,
            disableOutsidePointerEvents: i,
            onInteractOutside: f,
            onEscapeKeyDown: l,
            onPointerDownOutside: c,
            onFocusOutside: u,
            onDismiss: () => g.onOpenChange(!1),
            children: /* @__PURE__ */ s.jsx(
              Ua,
              {
                "data-state": Ni(g.open),
                role: "dialog",
                id: g.contentId,
                ...x,
                ...m,
                ref: t,
                style: {
                  ...m.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Pi = "PopoverClose", jf = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = ot(Pi, n);
    return /* @__PURE__ */ s.jsx(
      V.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: F(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
jf.displayName = Pi;
var Pf = "PopoverArrow", Nf = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = Ut(n);
    return /* @__PURE__ */ s.jsx(Ka, { ...r, ...o, ref: t });
  }
);
Nf.displayName = Pf;
function Ni(e) {
  return e ? "open" : "closed";
}
var _f = bi, kf = yi, Af = Ei, Tf = Ri, If = Mi, Of = [" ", "Enter", "ArrowUp", "ArrowDown"], Lf = [" ", "Enter"], mt = "Select", [Vn, Hn, Df] = zt(mt), [Tt] = He(mt, [
  Df,
  Dn
]), $n = Dn(), [Ff, rt] = Tt(mt), [Vf, Hf] = Tt(mt), _i = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    value: i,
    defaultValue: l,
    onValueChange: c,
    dir: u,
    name: f,
    autoComplete: m,
    disabled: g,
    required: x,
    form: b
  } = e, p = $n(t), [v, w] = d.useState(null), [C, y] = d.useState(null), [S, E] = d.useState(!1), M = Wt(u), [j, R] = Ee({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: mt
  }), [_, L] = Ee({
    prop: i,
    defaultProp: l,
    onChange: c,
    caller: mt
  }), B = d.useRef(null), X = v ? b || !!v.closest("form") : !0, [$, z] = d.useState(/* @__PURE__ */ new Set()), G = Array.from($).map((D) => D.props.value).join(";");
  return /* @__PURE__ */ s.jsx(Za, { ...p, children: /* @__PURE__ */ s.jsxs(
    Ff,
    {
      required: x,
      scope: t,
      trigger: v,
      onTriggerChange: w,
      valueNode: C,
      onValueNodeChange: y,
      valueNodeHasChildren: S,
      onValueNodeHasChildrenChange: E,
      contentId: Pe(),
      value: _,
      onValueChange: L,
      open: j,
      onOpenChange: R,
      dir: M,
      triggerPointerDownPosRef: B,
      disabled: g,
      children: [
        /* @__PURE__ */ s.jsx(Vn.Provider, { scope: t, children: /* @__PURE__ */ s.jsx(
          Vf,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: d.useCallback((D) => {
              z((Z) => new Set(Z).add(D));
            }, []),
            onNativeOptionRemove: d.useCallback((D) => {
              z((Z) => {
                const P = new Set(Z);
                return P.delete(D), P;
              });
            }, []),
            children: n
          }
        ) }),
        X ? /* @__PURE__ */ s.jsxs(
          tl,
          {
            "aria-hidden": !0,
            required: x,
            tabIndex: -1,
            name: f,
            autoComplete: m,
            value: _,
            onChange: (D) => L(D.target.value),
            disabled: g,
            form: b,
            children: [
              _ === void 0 ? /* @__PURE__ */ s.jsx("option", { value: "" }) : null,
              Array.from($)
            ]
          },
          G
        ) : null
      ]
    }
  ) });
};
_i.displayName = mt;
var ki = "SelectTrigger", Ai = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: o = !1, ...r } = e, a = $n(n), i = rt(ki, n), l = i.disabled || o, c = ne(t, i.onTriggerChange), u = Hn(n), f = d.useRef("touch"), [m, g, x] = ol((p) => {
      const v = u().filter((y) => !y.disabled), w = v.find((y) => y.value === i.value), C = rl(v, p, w);
      C !== void 0 && i.onValueChange(C.value);
    }), b = (p) => {
      l || (i.onOpenChange(!0), x()), p && (i.triggerPointerDownPosRef.current = {
        x: Math.round(p.pageX),
        y: Math.round(p.pageY)
      });
    };
    return /* @__PURE__ */ s.jsx(Qo, { asChild: !0, ...a, children: /* @__PURE__ */ s.jsx(
      V.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: l,
        "data-disabled": l ? "" : void 0,
        "data-placeholder": nl(i.value) ? "" : void 0,
        ...r,
        ref: c,
        onClick: F(r.onClick, (p) => {
          p.currentTarget.focus(), f.current !== "mouse" && b(p);
        }),
        onPointerDown: F(r.onPointerDown, (p) => {
          f.current = p.pointerType;
          const v = p.target;
          v.hasPointerCapture(p.pointerId) && v.releasePointerCapture(p.pointerId), p.button === 0 && p.ctrlKey === !1 && p.pointerType === "mouse" && (b(p), p.preventDefault());
        }),
        onKeyDown: F(r.onKeyDown, (p) => {
          const v = m.current !== "";
          !(p.ctrlKey || p.altKey || p.metaKey) && p.key.length === 1 && g(p.key), !(v && p.key === " ") && Of.includes(p.key) && (b(), p.preventDefault());
        })
      }
    ) });
  }
);
Ai.displayName = ki;
var Ti = "SelectValue", Ii = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: r, children: a, placeholder: i = "", ...l } = e, c = rt(Ti, n), { onValueNodeHasChildrenChange: u } = c, f = a !== void 0, m = ne(t, c.onValueNodeChange);
    return me(() => {
      u(f);
    }, [u, f]), /* @__PURE__ */ s.jsx(
      V.span,
      {
        ...l,
        ref: m,
        style: { pointerEvents: "none" },
        children: nl(c.value) ? /* @__PURE__ */ s.jsx(s.Fragment, { children: i }) : a
      }
    );
  }
);
Ii.displayName = Ti;
var $f = "SelectIcon", Oi = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: o, ...r } = e;
    return /* @__PURE__ */ s.jsx(V.span, { "aria-hidden": !0, ...r, ref: t, children: o || "▼" });
  }
);
Oi.displayName = $f;
var Bf = "SelectPortal", Li = (e) => /* @__PURE__ */ s.jsx(Ho, { asChild: !0, ...e });
Li.displayName = Bf;
var ht = "SelectContent", Di = d.forwardRef(
  (e, t) => {
    const n = rt(ht, e.__scopeSelect), [o, r] = d.useState();
    if (me(() => {
      r(new DocumentFragment());
    }, []), !n.open) {
      const a = o;
      return a ? En.createPortal(
        /* @__PURE__ */ s.jsx(Fi, { scope: e.__scopeSelect, children: /* @__PURE__ */ s.jsx(Vn.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ s.jsx("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ s.jsx(Vi, { ...e, ref: t });
  }
);
Di.displayName = ht;
var ke = 10, [Fi, st] = Tt(ht), zf = "SelectContentImpl", Wf = /* @__PURE__ */ dt("SelectContent.RemoveScroll"), Vi = d.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: o = "item-aligned",
      onCloseAutoFocus: r,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: l,
      sideOffset: c,
      align: u,
      alignOffset: f,
      arrowPadding: m,
      collisionBoundary: g,
      collisionPadding: x,
      sticky: b,
      hideWhenDetached: p,
      avoidCollisions: v,
      //
      ...w
    } = e, C = rt(ht, n), [y, S] = d.useState(null), [E, M] = d.useState(null), j = ne(t, (A) => S(A)), [R, _] = d.useState(null), [L, B] = d.useState(
      null
    ), X = Hn(n), [$, z] = d.useState(!1), G = d.useRef(!1);
    d.useEffect(() => {
      if (y) return Bo(y);
    }, [y]), $o();
    const D = d.useCallback(
      (A) => {
        const [Q, ...ae] = X().map((K) => K.ref.current), [U] = ae.slice(-1), q = document.activeElement;
        for (const K of A)
          if (K === q || (K == null || K.scrollIntoView({ block: "nearest" }), K === Q && E && (E.scrollTop = 0), K === U && E && (E.scrollTop = E.scrollHeight), K == null || K.focus(), document.activeElement !== q)) return;
      },
      [X, E]
    ), Z = d.useCallback(
      () => D([R, y]),
      [D, R, y]
    );
    d.useEffect(() => {
      $ && Z();
    }, [$, Z]);
    const { onOpenChange: P, triggerPointerDownPosRef: te } = C;
    d.useEffect(() => {
      if (y) {
        let A = { x: 0, y: 0 };
        const Q = (U) => {
          var q, K;
          A = {
            x: Math.abs(Math.round(U.pageX) - (((q = te.current) == null ? void 0 : q.x) ?? 0)),
            y: Math.abs(Math.round(U.pageY) - (((K = te.current) == null ? void 0 : K.y) ?? 0))
          };
        }, ae = (U) => {
          A.x <= 10 && A.y <= 10 ? U.preventDefault() : y.contains(U.target) || P(!1), document.removeEventListener("pointermove", Q), te.current = null;
        };
        return te.current !== null && (document.addEventListener("pointermove", Q), document.addEventListener("pointerup", ae, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Q), document.removeEventListener("pointerup", ae, { capture: !0 });
        };
      }
    }, [y, P, te]), d.useEffect(() => {
      const A = () => P(!1);
      return window.addEventListener("blur", A), window.addEventListener("resize", A), () => {
        window.removeEventListener("blur", A), window.removeEventListener("resize", A);
      };
    }, [P]);
    const [fe, ge] = ol((A) => {
      const Q = X().filter((q) => !q.disabled), ae = Q.find((q) => q.ref.current === document.activeElement), U = rl(Q, A, ae);
      U && setTimeout(() => U.ref.current.focus());
    }), Re = d.useCallback(
      (A, Q, ae) => {
        const U = !G.current && !ae;
        (C.value !== void 0 && C.value === Q || U) && (_(A), U && (G.current = !0));
      },
      [C.value]
    ), le = d.useCallback(() => y == null ? void 0 : y.focus(), [y]), ce = d.useCallback(
      (A, Q, ae) => {
        const U = !G.current && !ae;
        (C.value !== void 0 && C.value === Q || U) && B(A);
      },
      [C.value]
    ), Se = o === "popper" ? Eo : Hi, be = Se === Eo ? {
      side: l,
      sideOffset: c,
      align: u,
      alignOffset: f,
      arrowPadding: m,
      collisionBoundary: g,
      collisionPadding: x,
      sticky: b,
      hideWhenDetached: p,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ s.jsx(
      Fi,
      {
        scope: n,
        content: y,
        viewport: E,
        onViewportChange: M,
        itemRefCallback: Re,
        selectedItem: R,
        onItemLeave: le,
        itemTextRefCallback: ce,
        focusSelectedItem: Z,
        selectedItemText: L,
        position: o,
        isPositioned: $,
        searchRef: fe,
        children: /* @__PURE__ */ s.jsx(_n, { as: Wf, allowPinchZoom: !0, children: /* @__PURE__ */ s.jsx(
          Pn,
          {
            asChild: !0,
            trapped: C.open,
            onMountAutoFocus: (A) => {
              A.preventDefault();
            },
            onUnmountAutoFocus: F(r, (A) => {
              var Q;
              (Q = C.trigger) == null || Q.focus({ preventScroll: !0 }), A.preventDefault();
            }),
            children: /* @__PURE__ */ s.jsx(
              Gt,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: i,
                onFocusOutside: (A) => A.preventDefault(),
                onDismiss: () => C.onOpenChange(!1),
                children: /* @__PURE__ */ s.jsx(
                  Se,
                  {
                    role: "listbox",
                    id: C.contentId,
                    "data-state": C.open ? "open" : "closed",
                    dir: C.dir,
                    onContextMenu: (A) => A.preventDefault(),
                    ...w,
                    ...be,
                    onPlaced: () => z(!0),
                    ref: j,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: F(w.onKeyDown, (A) => {
                      const Q = A.ctrlKey || A.altKey || A.metaKey;
                      if (A.key === "Tab" && A.preventDefault(), !Q && A.key.length === 1 && ge(A.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(A.key)) {
                        let U = X().filter((q) => !q.disabled).map((q) => q.ref.current);
                        if (["ArrowUp", "End"].includes(A.key) && (U = U.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(A.key)) {
                          const q = A.target, K = U.indexOf(q);
                          U = U.slice(K + 1);
                        }
                        setTimeout(() => D(U)), A.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Vi.displayName = zf;
var Gf = "SelectItemAlignedPosition", Hi = d.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: o, ...r } = e, a = rt(ht, n), i = st(ht, n), [l, c] = d.useState(null), [u, f] = d.useState(null), m = ne(t, (j) => f(j)), g = Hn(n), x = d.useRef(!1), b = d.useRef(!0), { viewport: p, selectedItem: v, selectedItemText: w, focusSelectedItem: C } = i, y = d.useCallback(() => {
    if (a.trigger && a.valueNode && l && u && p && v && w) {
      const j = a.trigger.getBoundingClientRect(), R = u.getBoundingClientRect(), _ = a.valueNode.getBoundingClientRect(), L = w.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const q = L.left - R.left, K = _.left - q, ve = j.left - K, Me = j.width + ve, Ie = Math.max(Me, R.width), _e = window.innerWidth - ke, Xe = as(K, [
          ke,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(ke, _e - Ie)
        ]);
        l.style.minWidth = Me + "px", l.style.left = Xe + "px";
      } else {
        const q = R.right - L.right, K = window.innerWidth - _.right - q, ve = window.innerWidth - j.right - K, Me = j.width + ve, Ie = Math.max(Me, R.width), _e = window.innerWidth - ke, Xe = as(K, [
          ke,
          Math.max(ke, _e - Ie)
        ]);
        l.style.minWidth = Me + "px", l.style.right = Xe + "px";
      }
      const B = g(), X = window.innerHeight - ke * 2, $ = p.scrollHeight, z = window.getComputedStyle(u), G = parseInt(z.borderTopWidth, 10), D = parseInt(z.paddingTop, 10), Z = parseInt(z.borderBottomWidth, 10), P = parseInt(z.paddingBottom, 10), te = G + D + $ + P + Z, fe = Math.min(v.offsetHeight * 5, te), ge = window.getComputedStyle(p), Re = parseInt(ge.paddingTop, 10), le = parseInt(ge.paddingBottom, 10), ce = j.top + j.height / 2 - ke, Se = X - ce, be = v.offsetHeight / 2, A = v.offsetTop + be, Q = G + D + A, ae = te - Q;
      if (Q <= ce) {
        const q = B.length > 0 && v === B[B.length - 1].ref.current;
        l.style.bottom = "0px";
        const K = u.clientHeight - p.offsetTop - p.offsetHeight, ve = Math.max(
          Se,
          be + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (q ? le : 0) + K + Z
        ), Me = Q + ve;
        l.style.height = Me + "px";
      } else {
        const q = B.length > 0 && v === B[0].ref.current;
        l.style.top = "0px";
        const ve = Math.max(
          ce,
          G + p.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (q ? Re : 0) + be
        ) + ae;
        l.style.height = ve + "px", p.scrollTop = Q - ce + p.offsetTop;
      }
      l.style.margin = `${ke}px 0`, l.style.minHeight = fe + "px", l.style.maxHeight = X + "px", o == null || o(), requestAnimationFrame(() => x.current = !0);
    }
  }, [
    g,
    a.trigger,
    a.valueNode,
    l,
    u,
    p,
    v,
    w,
    a.dir,
    o
  ]);
  me(() => y(), [y]);
  const [S, E] = d.useState();
  me(() => {
    u && E(window.getComputedStyle(u).zIndex);
  }, [u]);
  const M = d.useCallback(
    (j) => {
      j && b.current === !0 && (y(), C == null || C(), b.current = !1);
    },
    [y, C]
  );
  return /* @__PURE__ */ s.jsx(
    Uf,
    {
      scope: n,
      contentWrapper: l,
      shouldExpandOnScrollRef: x,
      onScrollButtonChange: M,
      children: /* @__PURE__ */ s.jsx(
        "div",
        {
          ref: c,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: S
          },
          children: /* @__PURE__ */ s.jsx(
            V.div,
            {
              ...r,
              ref: m,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...r.style
              }
            }
          )
        }
      )
    }
  );
});
Hi.displayName = Gf;
var Zf = "SelectPopperPosition", Eo = d.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: o = "start",
    collisionPadding: r = ke,
    ...a
  } = e, i = $n(n);
  return /* @__PURE__ */ s.jsx(
    Ua,
    {
      ...i,
      ...a,
      ref: t,
      align: o,
      collisionPadding: r,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Eo.displayName = Zf;
var [Uf, ir] = Tt(ht, {}), Ro = "SelectViewport", $i = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: o, ...r } = e, a = st(Ro, n), i = ir(Ro, n), l = ne(t, a.onViewportChange), c = d.useRef(0);
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ s.jsx(Vn.Slot, { scope: n, children: /* @__PURE__ */ s.jsx(
        V.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...r,
          ref: l,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...r.style
          },
          onScroll: F(r.onScroll, (u) => {
            const f = u.currentTarget, { contentWrapper: m, shouldExpandOnScrollRef: g } = i;
            if (g != null && g.current && m) {
              const x = Math.abs(c.current - f.scrollTop);
              if (x > 0) {
                const b = window.innerHeight - ke * 2, p = parseFloat(m.style.minHeight), v = parseFloat(m.style.height), w = Math.max(p, v);
                if (w < b) {
                  const C = w + x, y = Math.min(b, C), S = C - y;
                  m.style.height = y + "px", m.style.bottom === "0px" && (f.scrollTop = S > 0 ? S : 0, m.style.justifyContent = "flex-end");
                }
              }
            }
            c.current = f.scrollTop;
          })
        }
      ) })
    ] });
  }
);
$i.displayName = Ro;
var Bi = "SelectGroup", [Kf, Yf] = Tt(Bi), zi = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = Pe();
    return /* @__PURE__ */ s.jsx(Kf, { scope: n, id: r, children: /* @__PURE__ */ s.jsx(V.div, { role: "group", "aria-labelledby": r, ...o, ref: t }) });
  }
);
zi.displayName = Bi;
var Wi = "SelectLabel", Gi = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = Yf(Wi, n);
    return /* @__PURE__ */ s.jsx(V.div, { id: r.id, ...o, ref: t });
  }
);
Gi.displayName = Wi;
var bn = "SelectItem", [Xf, Zi] = Tt(bn), Ui = d.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: o,
      disabled: r = !1,
      textValue: a,
      ...i
    } = e, l = rt(bn, n), c = st(bn, n), u = l.value === o, [f, m] = d.useState(a ?? ""), [g, x] = d.useState(!1), b = ne(
      t,
      (C) => {
        var y;
        return (y = c.itemRefCallback) == null ? void 0 : y.call(c, C, o, r);
      }
    ), p = Pe(), v = d.useRef("touch"), w = () => {
      r || (l.onValueChange(o), l.onOpenChange(!1));
    };
    if (o === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ s.jsx(
      Xf,
      {
        scope: n,
        value: o,
        disabled: r,
        textId: p,
        isSelected: u,
        onItemTextChange: d.useCallback((C) => {
          m((y) => y || ((C == null ? void 0 : C.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ s.jsx(
          Vn.ItemSlot,
          {
            scope: n,
            value: o,
            disabled: r,
            textValue: f,
            children: /* @__PURE__ */ s.jsx(
              V.div,
              {
                role: "option",
                "aria-labelledby": p,
                "data-highlighted": g ? "" : void 0,
                "aria-selected": u && g,
                "data-state": u ? "checked" : "unchecked",
                "aria-disabled": r || void 0,
                "data-disabled": r ? "" : void 0,
                tabIndex: r ? void 0 : -1,
                ...i,
                ref: b,
                onFocus: F(i.onFocus, () => x(!0)),
                onBlur: F(i.onBlur, () => x(!1)),
                onClick: F(i.onClick, () => {
                  v.current !== "mouse" && w();
                }),
                onPointerUp: F(i.onPointerUp, () => {
                  v.current === "mouse" && w();
                }),
                onPointerDown: F(i.onPointerDown, (C) => {
                  v.current = C.pointerType;
                }),
                onPointerMove: F(i.onPointerMove, (C) => {
                  var y;
                  v.current = C.pointerType, r ? (y = c.onItemLeave) == null || y.call(c) : v.current === "mouse" && C.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: F(i.onPointerLeave, (C) => {
                  var y;
                  C.currentTarget === document.activeElement && ((y = c.onItemLeave) == null || y.call(c));
                }),
                onKeyDown: F(i.onKeyDown, (C) => {
                  var S;
                  ((S = c.searchRef) == null ? void 0 : S.current) !== "" && C.key === " " || (Lf.includes(C.key) && w(), C.key === " " && C.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Ui.displayName = bn;
var Ft = "SelectItemText", Ki = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: r, ...a } = e, i = rt(Ft, n), l = st(Ft, n), c = Zi(Ft, n), u = Hf(Ft, n), [f, m] = d.useState(null), g = ne(
      t,
      (w) => m(w),
      c.onItemTextChange,
      (w) => {
        var C;
        return (C = l.itemTextRefCallback) == null ? void 0 : C.call(l, w, c.value, c.disabled);
      }
    ), x = f == null ? void 0 : f.textContent, b = d.useMemo(
      () => /* @__PURE__ */ s.jsx("option", { value: c.value, disabled: c.disabled, children: x }, c.value),
      [c.disabled, c.value, x]
    ), { onNativeOptionAdd: p, onNativeOptionRemove: v } = u;
    return me(() => (p(b), () => v(b)), [p, v, b]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(V.span, { id: c.textId, ...a, ref: g }),
      c.isSelected && i.valueNode && !i.valueNodeHasChildren ? En.createPortal(a.children, i.valueNode) : null
    ] });
  }
);
Ki.displayName = Ft;
var Yi = "SelectItemIndicator", Xi = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return Zi(Yi, n).isSelected ? /* @__PURE__ */ s.jsx(V.span, { "aria-hidden": !0, ...o, ref: t }) : null;
  }
);
Xi.displayName = Yi;
var Mo = "SelectScrollUpButton", qi = d.forwardRef((e, t) => {
  const n = st(Mo, e.__scopeSelect), o = ir(Mo, e.__scopeSelect), [r, a] = d.useState(!1), i = ne(t, o.onScrollButtonChange);
  return me(() => {
    if (n.viewport && n.isPositioned) {
      let l = function() {
        const u = c.scrollTop > 0;
        a(u);
      };
      const c = n.viewport;
      return l(), c.addEventListener("scroll", l), () => c.removeEventListener("scroll", l);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ s.jsx(
    Qi,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: c } = n;
        l && c && (l.scrollTop = l.scrollTop - c.offsetHeight);
      }
    }
  ) : null;
});
qi.displayName = Mo;
var jo = "SelectScrollDownButton", Ji = d.forwardRef((e, t) => {
  const n = st(jo, e.__scopeSelect), o = ir(jo, e.__scopeSelect), [r, a] = d.useState(!1), i = ne(t, o.onScrollButtonChange);
  return me(() => {
    if (n.viewport && n.isPositioned) {
      let l = function() {
        const u = c.scrollHeight - c.clientHeight, f = Math.ceil(c.scrollTop) < u;
        a(f);
      };
      const c = n.viewport;
      return l(), c.addEventListener("scroll", l), () => c.removeEventListener("scroll", l);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ s.jsx(
    Qi,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: c } = n;
        l && c && (l.scrollTop = l.scrollTop + c.offsetHeight);
      }
    }
  ) : null;
});
Ji.displayName = jo;
var Qi = d.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: o, ...r } = e, a = st("SelectScrollButton", n), i = d.useRef(null), l = Hn(n), c = d.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return d.useEffect(() => () => c(), [c]), me(() => {
    var f;
    const u = l().find((m) => m.ref.current === document.activeElement);
    (f = u == null ? void 0 : u.ref.current) == null || f.scrollIntoView({ block: "nearest" });
  }, [l]), /* @__PURE__ */ s.jsx(
    V.div,
    {
      "aria-hidden": !0,
      ...r,
      ref: t,
      style: { flexShrink: 0, ...r.style },
      onPointerDown: F(r.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(o, 50));
      }),
      onPointerMove: F(r.onPointerMove, () => {
        var u;
        (u = a.onItemLeave) == null || u.call(a), i.current === null && (i.current = window.setInterval(o, 50));
      }),
      onPointerLeave: F(r.onPointerLeave, () => {
        c();
      })
    }
  );
}), qf = "SelectSeparator", el = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return /* @__PURE__ */ s.jsx(V.div, { "aria-hidden": !0, ...o, ref: t });
  }
);
el.displayName = qf;
var Po = "SelectArrow", Jf = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = $n(n), a = rt(Po, n), i = st(Po, n);
    return a.open && i.position === "popper" ? /* @__PURE__ */ s.jsx(Ka, { ...r, ...o, ref: t }) : null;
  }
);
Jf.displayName = Po;
var Qf = "SelectBubbleInput", tl = d.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, o) => {
    const r = d.useRef(null), a = ne(o, r), i = Ea(t);
    return d.useEffect(() => {
      const l = r.current;
      if (!l) return;
      const c = window.HTMLSelectElement.prototype, f = Object.getOwnPropertyDescriptor(
        c,
        "value"
      ).set;
      if (i !== t && f) {
        const m = new Event("change", { bubbles: !0 });
        f.call(l, t), l.dispatchEvent(m);
      }
    }, [i, t]), /* @__PURE__ */ s.jsx(
      V.select,
      {
        ...n,
        style: { ...Is, ...n.style },
        ref: a,
        defaultValue: t
      }
    );
  }
);
tl.displayName = Qf;
function nl(e) {
  return e === "" || e === void 0;
}
function ol(e) {
  const t = Ce(e), n = d.useRef(""), o = d.useRef(0), r = d.useCallback(
    (i) => {
      const l = n.current + i;
      t(l), (function c(u) {
        n.current = u, window.clearTimeout(o.current), u !== "" && (o.current = window.setTimeout(() => c(""), 1e3));
      })(l);
    },
    [t]
  ), a = d.useCallback(() => {
    n.current = "", window.clearTimeout(o.current);
  }, []);
  return d.useEffect(() => () => window.clearTimeout(o.current), []), [n, r, a];
}
function rl(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = e0(e, Math.max(a, 0));
  r.length === 1 && (i = i.filter((u) => u !== n));
  const c = i.find(
    (u) => u.textValue.toLowerCase().startsWith(r.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function e0(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var t0 = _i, n0 = Ai, o0 = Ii, r0 = Oi, s0 = Li, a0 = Di, i0 = $i, l0 = zi, c0 = Gi, d0 = Ui, u0 = Ki, f0 = Xi, p0 = qi, m0 = Ji, h0 = el, sl = "Toggle", lr = d.forwardRef((e, t) => {
  const { pressed: n, defaultPressed: o, onPressedChange: r, ...a } = e, [i, l] = Ee({
    prop: n,
    onChange: r,
    defaultProp: o ?? !1,
    caller: sl
  });
  return /* @__PURE__ */ s.jsx(
    V.button,
    {
      type: "button",
      "aria-pressed": i,
      "data-state": i ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...a,
      ref: t,
      onClick: F(e.onClick, () => {
        e.disabled || l(!i);
      })
    }
  );
});
lr.displayName = sl;
var g0 = lr, at = "ToggleGroup", [al] = He(at, [
  Xa
]), il = Xa(), cr = ee.forwardRef((e, t) => {
  const { type: n, ...o } = e;
  if (n === "single") {
    const r = o;
    return /* @__PURE__ */ s.jsx(v0, { ...r, ref: t });
  }
  if (n === "multiple") {
    const r = o;
    return /* @__PURE__ */ s.jsx(x0, { ...r, ref: t });
  }
  throw new Error(`Missing prop \`type\` expected on \`${at}\``);
});
cr.displayName = at;
var [ll, cl] = al(at), v0 = ee.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: o,
    onValueChange: r = () => {
    },
    ...a
  } = e, [i, l] = Ee({
    prop: n,
    defaultProp: o ?? "",
    onChange: r,
    caller: at
  });
  return /* @__PURE__ */ s.jsx(
    ll,
    {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: ee.useMemo(() => i ? [i] : [], [i]),
      onItemActivate: l,
      onItemDeactivate: ee.useCallback(() => l(""), [l]),
      children: /* @__PURE__ */ s.jsx(dl, { ...a, ref: t })
    }
  );
}), x0 = ee.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: o,
    onValueChange: r = () => {
    },
    ...a
  } = e, [i, l] = Ee({
    prop: n,
    defaultProp: o ?? [],
    onChange: r,
    caller: at
  }), c = ee.useCallback(
    (f) => l((m = []) => [...m, f]),
    [l]
  ), u = ee.useCallback(
    (f) => l((m = []) => m.filter((g) => g !== f)),
    [l]
  );
  return /* @__PURE__ */ s.jsx(
    ll,
    {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: i,
      onItemActivate: c,
      onItemDeactivate: u,
      children: /* @__PURE__ */ s.jsx(dl, { ...a, ref: t })
    }
  );
});
cr.displayName = at;
var [C0, b0] = al(at), dl = ee.forwardRef(
  (e, t) => {
    const {
      __scopeToggleGroup: n,
      disabled: o = !1,
      rovingFocus: r = !0,
      orientation: a,
      dir: i,
      loop: l = !0,
      ...c
    } = e, u = il(n), f = Wt(i), m = { role: "group", dir: f, ...c };
    return /* @__PURE__ */ s.jsx(C0, { scope: n, rovingFocus: r, disabled: o, children: r ? /* @__PURE__ */ s.jsx(
      Y2,
      {
        asChild: !0,
        ...u,
        orientation: a,
        dir: f,
        loop: l,
        children: /* @__PURE__ */ s.jsx(V.div, { ...m, ref: t })
      }
    ) : /* @__PURE__ */ s.jsx(V.div, { ...m, ref: t }) });
  }
), wn = "ToggleGroupItem", ul = ee.forwardRef(
  (e, t) => {
    const n = cl(wn, e.__scopeToggleGroup), o = b0(wn, e.__scopeToggleGroup), r = il(e.__scopeToggleGroup), a = n.value.includes(e.value), i = o.disabled || e.disabled, l = { ...e, pressed: a, disabled: i }, c = ee.useRef(null);
    return o.rovingFocus ? /* @__PURE__ */ s.jsx(
      X2,
      {
        asChild: !0,
        ...r,
        focusable: !i,
        active: a,
        ref: c,
        children: /* @__PURE__ */ s.jsx(is, { ...l, ref: t })
      }
    ) : /* @__PURE__ */ s.jsx(is, { ...l, ref: t });
  }
);
ul.displayName = wn;
var is = ee.forwardRef(
  (e, t) => {
    const { __scopeToggleGroup: n, value: o, ...r } = e, a = cl(wn, n), i = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, l = a.type === "single" ? i : void 0;
    return /* @__PURE__ */ s.jsx(
      lr,
      {
        ...l,
        ...r,
        ref: t,
        onPressedChange: (c) => {
          c ? a.onItemActivate(o) : a.onItemDeactivate(o);
        }
      }
    );
  }
), w0 = cr, y0 = ul;
function U4({ ...e }) {
  return /* @__PURE__ */ s.jsx(rd, { "data-slot": "accordion", ...e });
}
function K4({ className: e, value: t, ...n }) {
  const o = d.useId();
  return /* @__PURE__ */ s.jsx(
    sd,
    {
      "data-slot": "accordion-item",
      value: t ?? o,
      className: O("border-border-cards border-b py-3 last:border-b-0", e),
      ...n
    }
  );
}
function Y4({ className: e, children: t, ...n }) {
  return /* @__PURE__ */ s.jsx(ad, { className: "flex", children: /* @__PURE__ */ s.jsxs(
    id,
    {
      "data-slot": "accordion-trigger",
      className: O(
        "text-paragraph-medium text-foreground-primary/88 focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-start justify-between gap-2 rounded-md py-3.5 text-left font-bold outline-none transition-all hover:text-button-secondary-hover focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180",
        e
      ),
      ...n,
      children: [
        t,
        /* @__PURE__ */ s.jsx(
          tt,
          {
            stroke: 1.5,
            className: "text-foreground-primary pointer-events-none size-6 shrink-0 translate-y-0.5 transition-transform duration-200"
          }
        )
      ]
    }
  ) });
}
function X4({ className: e, children: t, ...n }) {
  return /* @__PURE__ */ s.jsx(
    ld,
    {
      "data-slot": "accordion-content",
      className: "text-paragraph-medium text-foreground-primary/88 data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden",
      ...n,
      children: /* @__PURE__ */ s.jsx("div", { className: O("pb-3 pt-1", e), children: t })
    }
  );
}
const S0 = Bt(
  "focus-visible:border-ring focus-visible:ring-ring/50 flex cursor-pointer items-center justify-center gap-2 rounded-full outline-none transition-all duration-300 focus-visible:ring-[3px] disabled:cursor-default",
  {
    variants: {
      variant: {
        primary: O(
          "bg-button-primary-default text-primary-foreground",
          "hover:not-disabled:bg-button-primary-hover",
          "active:not-disabled:bg-button-primary-pressed",
          "disabled:opacity-20"
        ),
        secondary: O(
          "border-1 border-button-secondary-default bg-button-secondary-background text-button-secondary-default",
          "hover:not-disabled:border-button-secondary-hover hover:not-disabled:text-button-secondary-hover",
          "active:not-disabled:border-button-secondary-pressed active:not-disabled:text-button-secondary-pressed",
          "disabled:opacity-30"
        )
      },
      size: {
        big: "text-button-big min-h-12 px-8",
        medium: "text-button-big min-h-10 px-6",
        small: "text-button-small px-3 py-1"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "big"
    }
  }
);
function ls({
  className: e,
  variant: t,
  size: n,
  asChild: o = !1,
  ...r
}) {
  const a = o ? Ts : "button";
  return /* @__PURE__ */ s.jsx(a, { "data-slot": "button", className: O(S0({ variant: t, size: n, className: e })), ...r });
}
function E0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "card",
      className: O(
        "bg-card text-card-foreground shadow-hero flex flex-col gap-6 overflow-hidden rounded-2xl py-6",
        e
      ),
      ...t
    }
  );
}
function R0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "card-header-image",
      className: O("-mt-6 flex h-[13.75rem] w-full items-center justify-center", e),
      ...t
    }
  );
}
function M0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "card-header",
      className: O(
        "@container/card-header has-data-[slot=card-action]:grid-cols-[1fr_auto] grid auto-rows-min grid-rows-[auto_auto] items-start gap-4 px-6",
        e
      ),
      ...t
    }
  );
}
function j0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "card-title",
      className: O("text-heading-h3 text-foreground-primary leading-none", e),
      ...t
    }
  );
}
function P0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "card-description",
      className: O("text-paragraph-small text-foreground-primary", e),
      ...t
    }
  );
}
function q4({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "card-action",
      className: O("col-start-2 row-span-2 row-start-1 self-start justify-self-end", e),
      ...t
    }
  );
}
function J4({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx("div", { "data-slot": "card-content", className: O("px-6", e), ...t });
}
function N0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx("div", { "data-slot": "card-footer", className: O("mt-auto flex items-center px-6", e), ...t });
}
function fl({ ...e }) {
  return /* @__PURE__ */ s.jsx(Vs, { "data-slot": "collapsible", ...e });
}
function pl({ ...e }) {
  return /* @__PURE__ */ s.jsx(To, { "data-slot": "collapsible-trigger", ...e });
}
function ml({ ...e }) {
  return /* @__PURE__ */ s.jsx(Oo, { "data-slot": "collapsible-content", ...e });
}
function _0({
  className: e,
  children: t,
  viewport: n = !0,
  ...o
}) {
  return /* @__PURE__ */ s.jsxs(
    pf,
    {
      "data-slot": "navigation-menu",
      "data-viewport": n,
      className: O(
        "group/navigation-menu relative flex max-w-max flex-1 items-center justify-center",
        e
      ),
      ...o,
      children: [
        t,
        n && /* @__PURE__ */ s.jsx(L0, {})
      ]
    }
  );
}
function k0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    mf,
    {
      "data-slot": "navigation-menu-list",
      className: O("group flex flex-1 list-none items-center justify-center gap-1", e),
      ...t
    }
  );
}
function A0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    hf,
    {
      "data-slot": "navigation-menu-item",
      className: O("relative", e),
      ...t
    }
  );
}
const T0 = Bt(
  "text-button-small text-accent-primary hover:text-accent-secondary data-[state=open]:text-accent-secondary group inline-flex cursor-pointer items-center gap-2 transition-colors hover:bg-transparent"
);
function I0({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ s.jsxs(
    gf,
    {
      "data-slot": "navigation-menu-trigger",
      className: O(T0(), "group", e),
      ...n,
      children: [
        t,
        /* @__PURE__ */ s.jsx(
          tt,
          {
            stroke: 1.5,
            className: "relative top-[1px] ml-1 size-6 transition duration-300 group-data-[state=open]:rotate-180",
            "aria-hidden": "true"
          }
        )
      ]
    }
  );
}
function O0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    Cf,
    {
      "data-slot": "navigation-menu-content",
      className: O(
        "data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52 data-[motion^=from-]:animate-in data-[motion^=from-]:fade-in data-[motion^=to-]:animate-out data-[motion^=to-]:fade-out left-0 top-0 w-full p-2 pr-2.5 md:absolute md:w-auto",
        "group-data-[viewport=false]/navigation-menu:bg-popover group-data-[viewport=false]/navigation-menu:text-popover-foreground group-data-[viewport=false]/navigation-menu:data-[state=closed]:animate-out group-data-[viewport=false]/navigation-menu:data-[state=closed]:fade-out-0 group-data-[viewport=false]/navigation-menu:data-[state=closed]:zoom-out-95 group-data-[viewport=false]/navigation-menu:data-[state=open]:animate-in group-data-[viewport=false]/navigation-menu:data-[state=open]:fade-in-0 group-data-[viewport=false]/navigation-menu:data-[state=open]:zoom-in-95 group-data-[viewport=false]/navigation-menu:top-full group-data-[viewport=false]/navigation-menu:mt-1.5 group-data-[viewport=false]/navigation-menu:overflow-hidden group-data-[viewport=false]/navigation-menu:rounded-md group-data-[viewport=false]/navigation-menu:border group-data-[viewport=false]/navigation-menu:shadow group-data-[viewport=false]/navigation-menu:duration-200",
        "h-fit p-0 pr-0",
        e
      ),
      ...t
    }
  );
}
function L0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ s.jsx("div", { className: O("absolute left-0 top-[56px] isolate z-50 flex justify-center"), children: /* @__PURE__ */ s.jsx(
    bf,
    {
      "data-slot": "navigation-menu-viewport",
      className: O(
        "origin-top-center bg-popover fade-out data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:zoom-in-90 relative mt-1.5 h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden md:w-[var(--radix-navigation-menu-viewport-width)]",
        "navbar-popover-card",
        e
      ),
      ...t
    }
  ) });
}
function No({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    vf,
    {
      "data-slot": "navigation-menu-link",
      className: O(
        "text-button-small text-accent-primary hover:text-accent-secondary flex flex-col whitespace-nowrap p-4 transition-colors hover:bg-transparent",
        e
      ),
      ...t
    }
  );
}
function Q4({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ s.jsx(
    xf,
    {
      "data-slot": "navigation-menu-indicator",
      className: O(
        "data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:animate-in data-[state=visible]:fade-in top-full z-[1] flex h-1.5 items-end justify-center overflow-hidden",
        e
      ),
      ...t,
      children: /* @__PURE__ */ s.jsx("div", { className: "bg-border relative top-[60%] h-2 w-2 rotate-45 rounded-tl-sm shadow-md" })
    }
  );
}
function D0({ ...e }) {
  return /* @__PURE__ */ s.jsx(_f, { "data-slot": "popover", ...e });
}
function F0({ ...e }) {
  return /* @__PURE__ */ s.jsx(Af, { "data-slot": "popover-trigger", ...e });
}
function V0({
  className: e,
  align: t = "center",
  sideOffset: n = 4,
  ...o
}) {
  return /* @__PURE__ */ s.jsx(Tf, { children: /* @__PURE__ */ s.jsx(
    If,
    {
      "data-slot": "popover-content",
      align: t,
      sideOffset: n,
      className: O(
        "origin-(--radix-popover-content-transform-origin) bg-popover text-popover-foreground outline-hidden data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 z-50 w-72 rounded-md border p-4 shadow-md",
        e
      ),
      ...o
    }
  ) });
}
function e3({ ...e }) {
  return /* @__PURE__ */ s.jsx(kf, { "data-slot": "popover-anchor", ...e });
}
function t3({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx("div", { "data-slot": "popover-header", className: O("flex flex-col gap-1 text-sm", e), ...t });
}
function n3({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx("div", { "data-slot": "popover-title", className: O("font-medium", e), ...t });
}
function o3({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx("p", { "data-slot": "popover-description", className: O("text-muted-foreground", e), ...t });
}
function hl({ ...e }) {
  return /* @__PURE__ */ s.jsx(t0, { "data-slot": "select", ...e });
}
function r3({ ...e }) {
  return /* @__PURE__ */ s.jsx(l0, { "data-slot": "select-group", ...e });
}
function s3({ ...e }) {
  return /* @__PURE__ */ s.jsx(o0, { "data-slot": "select-value", ...e });
}
function gl({
  className: e,
  size: t = "default",
  children: n,
  ...o
}) {
  return /* @__PURE__ */ s.jsxs(
    n0,
    {
      "data-slot": "select-trigger",
      "data-size": t,
      className: O(
        'border-input focus-visible:border-ring focus-visible:ring-ring/50 data-[placeholder]:text-muted-foreground data-[state=open]:border-accent-secondary flex w-full items-center justify-between gap-2 whitespace-nowrap rounded-[4px] border bg-transparent px-3 py-2 text-sm outline-none transition-[color,box-shadow] focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg:not([class*="size-"])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0',
        e
      ),
      ...o,
      children: [
        n,
        /* @__PURE__ */ s.jsx(r0, { asChild: !0, children: /* @__PURE__ */ s.jsx(tt, { className: "text-primary size-5" }) })
      ]
    }
  );
}
function vl({
  className: e,
  children: t,
  position: n = "item-aligned",
  align: o = "center",
  ...r
}) {
  return /* @__PURE__ */ s.jsx(s0, { children: /* @__PURE__ */ s.jsxs(
    a0,
    {
      "data-slot": "select-content",
      className: O(
        "max-h-(--radix-select-content-available-height) origin-(--radix-select-content-transform-origin) bg-popover text-popover-foreground data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 relative z-50 min-w-[8rem] overflow-y-auto overflow-x-hidden rounded-[4px] border shadow-[0_1px_4px_0px_rgba(0,0,0,0.1)]",
        n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: n,
      align: o,
      ...r,
      children: [
        /* @__PURE__ */ s.jsx(H0, {}),
        /* @__PURE__ */ s.jsx(
          i0,
          {
            className: O(
              "p-1",
              n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"
            ),
            children: t
          }
        ),
        /* @__PURE__ */ s.jsx($0, {})
      ]
    }
  ) });
}
function a3({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    c0,
    {
      "data-slot": "select-label",
      className: O("text-muted-foreground px-2 py-1.5 text-xs", e),
      ...t
    }
  );
}
function xl({ className: e, children: t, ...n }) {
  return /* @__PURE__ */ s.jsxs(
    d0,
    {
      "data-slot": "select-item",
      className: O(
        'outline-hidden focus:text-accent-secondary *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2 relative flex w-full cursor-pointer select-none items-center gap-2 rounded-sm py-1.5 pl-2 pr-8 text-sm data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg:not([class*="size-"])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0',
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ s.jsx(
          "span",
          {
            "data-slot": "select-item-indicator",
            className: "absolute right-2 flex size-3.5 items-center justify-center",
            children: /* @__PURE__ */ s.jsx(f0, { children: /* @__PURE__ */ s.jsx(dc, { className: "size-4" }) })
          }
        ),
        /* @__PURE__ */ s.jsx(u0, { children: t })
      ]
    }
  );
}
function i3({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    h0,
    {
      "data-slot": "select-separator",
      className: O("bg-border pointer-events-none -mx-1 my-1 h-px", e),
      ...t
    }
  );
}
function H0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    p0,
    {
      "data-slot": "select-scroll-up-button",
      className: O("flex cursor-default items-center justify-center py-1", e),
      ...t,
      children: /* @__PURE__ */ s.jsx(pc, { className: "size-4" })
    }
  );
}
function $0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ s.jsx(
    m0,
    {
      "data-slot": "select-scroll-down-button",
      className: O("flex cursor-default items-center justify-center py-1", e),
      ...t,
      children: /* @__PURE__ */ s.jsx(tt, { className: "size-4" })
    }
  );
}
function B0({ ...e }) {
  return /* @__PURE__ */ s.jsx(Cu, { "data-slot": "sheet", ...e });
}
function z0({ ...e }) {
  return /* @__PURE__ */ s.jsx(bu, { "data-slot": "sheet-trigger", ...e });
}
function l3({ ...e }) {
  return /* @__PURE__ */ s.jsx(Sa, { "data-slot": "sheet-close", ...e });
}
function W0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    wu,
    {
      "data-slot": "sheet-overlay",
      className: O(
        "fixed inset-0 z-50 bg-[rgba(8,8,51,0.50)] data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0",
        e
      ),
      ...t
    }
  );
}
function G0({
  className: e,
  children: t,
  side: n = "right",
  ...o
}) {
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(W0, {}),
    /* @__PURE__ */ s.jsxs(
      yu,
      {
        "data-slot": "sheet-content",
        className: O(
          "fixed z-50 flex flex-col gap-4 bg-background shadow-lg transition ease-in-out data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:animate-in data-[state=open]:duration-500",
          n === "right" && "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm",
          n === "left" && "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
          n === "top" && "inset-x-0 top-0 h-auto border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
          n === "bottom" && "inset-x-0 bottom-0 h-auto border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
          e
        ),
        ...o,
        children: [
          /* @__PURE__ */ s.jsxs(Sa, { className: "absolute top-8 right-4 mr-2 cursor-pointer rounded-xs ring-offset-background transition-opacity hover:opacity-100 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:pointer-events-none data-[state=open]:bg-secondary", children: [
            /* @__PURE__ */ s.jsx(Oc, { className: "size-6" }),
            /* @__PURE__ */ s.jsx("span", { className: "sr-only", children: /* @__PURE__ */ s.jsx(Ge, { id: "navbar.close" }) })
          ] }),
          t
        ]
      }
    )
  ] });
}
function Z0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx("div", { "data-slot": "sheet-header", className: O("flex flex-col gap-1.5 p-4", e), ...t });
}
function U0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx("div", { "data-slot": "sheet-footer", className: O("mt-auto flex flex-col gap-2 p-4", e), ...t });
}
function K0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    Su,
    {
      "data-slot": "sheet-title",
      className: O("font-semibold text-foreground", e),
      ...t
    }
  );
}
function c3({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    Eu,
    {
      "data-slot": "sheet-description",
      className: O("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function Y0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "ul",
    {
      "data-slot": "sidebar-menu",
      "data-sidebar": "menu",
      className: O(
        'flex w-full min-w-0 flex-col overflow-auto [&>[data-sidebar="menu-item"]:last-child_[data-sidebar="menu-button"]]:border-b-0',
        e
      ),
      ...t
    }
  );
}
function cs({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "li",
    {
      "data-slot": "sidebar-menu-item",
      "data-sidebar": "menu-item",
      className: O("group/menu-item relative", e),
      ...t
    }
  );
}
function X0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "ul",
    {
      "data-slot": "sidebar-menu-sub",
      "data-sidebar": "menu-sub",
      className: O(
        "mr-7 flex min-w-0 translate-x-px flex-col pl-4",
        "group-data-[collapsible=icon]:hidden",
        "border-b border-b-background-tertiary",
        e
      ),
      ...t
    }
  );
}
function ds({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "li",
    {
      "data-slot": "sidebar-menu-sub-item",
      "data-sidebar": "menu-sub-item",
      className: O("group/menu-sub-item relative", e),
      ...t
    }
  );
}
function yn({
  asChild: e = !1,
  isActive: t = !1,
  className: n,
  buttonType: o = "menu",
  children: r,
  ...a
}) {
  const i = e ? Ts : "button";
  return /* @__PURE__ */ s.jsx(
    i,
    {
      "data-slot": "sidebar-menu-button",
      "data-sidebar": "menu-button",
      "data-active": t,
      className: O(
        "group flex w-full cursor-pointer items-center gap-2 py-4 pl-2 text-button-big text-accent-primary transition-all hover:text-accent-secondary data-[state=open]:text-accent-secondary",
        o === "menu" && "border-b border-b-background-tertiary data-[state=open]:border-b-transparent",
        n
      ),
      ...a,
      children: /* @__PURE__ */ s.jsxs("div", { className: "contents", children: [
        r,
        /* @__PURE__ */ s.jsx(
          tt,
          {
            className: "relative ml-1 hidden size-4 transition duration-300 group-data-[slot=collapsible-trigger]:block group-data-[state=open]:rotate-x-180",
            "aria-hidden": "true"
          }
        )
      ] })
    }
  );
}
const Cl = Bt(
  O(
    "inline-flex items-center justify-center gap-2 rounded-full text-paragraph-small text-sm font-medium whitespace-nowrap transition-[color,box-shadow,background-color] outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50",
    "data-[state=off]:hover:text-foreground-primary/80 data-[state=on]:bg-accent-secondary data-[state=on]:text-foreground-on-primary",
    "cursor-pointer"
  ),
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "bg-transparent shadow-xs hover:text-accent-foreground"
      },
      size: {
        default: "h-[30px] min-w-9 px-2",
        sm: "h-8 min-w-8 px-1.5",
        lg: "h-10 min-w-10 px-2.5"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function d3({
  className: e,
  variant: t,
  size: n,
  ...o
}) {
  return /* @__PURE__ */ s.jsx(
    g0,
    {
      "data-slot": "toggle",
      className: O(Cl({ variant: t, size: n, className: e })),
      ...o
    }
  );
}
const bl = d.createContext({
  size: "default",
  variant: "default"
});
function u3({
  className: e,
  variant: t,
  size: n,
  children: o,
  ...r
}) {
  return /* @__PURE__ */ s.jsx(
    w0,
    {
      "data-slot": "toggle-group",
      "data-variant": t,
      "data-size": n,
      className: O(
        "group/toggle-group flex w-fit items-center rounded-full bg-background-secondary data-[variant=outline]:border-1 data-[variant=outline]:border-[#D9D9D9] data-[variant=outline]:p-[1px] data-[variant=outline]:shadow-xs",
        e
      ),
      ...r,
      children: /* @__PURE__ */ s.jsx(bl.Provider, { value: { variant: t, size: n }, children: o })
    }
  );
}
function f3({
  className: e,
  children: t,
  variant: n,
  size: o,
  ...r
}) {
  const a = d.useContext(bl);
  return /* @__PURE__ */ s.jsx(
    y0,
    {
      "data-slot": "toggle-group-item",
      "data-variant": a.variant || n,
      "data-size": a.size || o,
      className: O(
        Cl({
          variant: a.variant || n,
          size: a.size || o
        }),
        "min-w-0 shrink-0 px-4 shadow-none focus:z-10 focus-visible:z-10 data-[state=on]:rounded-full",
        e
      ),
      ...r,
      children: t
    }
  );
}
const p3 = ({
  title: e,
  description: t,
  linkText: n,
  logo: o,
  logoBackgroundColor: r,
  href: a,
  forceWhiteLogo: i
}) => {
  const { formatMessage: l } = Pt();
  return /* @__PURE__ */ s.jsxs(E0, { children: [
    /* @__PURE__ */ s.jsx(R0, { style: { backgroundColor: r }, children: /* @__PURE__ */ s.jsx(
      "img",
      {
        src: o,
        alt: l({ id: e }),
        className: O("max-h-20 max-w-50", i && "text-white brightness-0 invert")
      }
    ) }),
    /* @__PURE__ */ s.jsxs(M0, { children: [
      /* @__PURE__ */ s.jsx(j0, { children: /* @__PURE__ */ s.jsx(Ge, { id: e }) }),
      /* @__PURE__ */ s.jsx(P0, { children: /* @__PURE__ */ s.jsx(Ge, { id: t }) })
    ] }),
    /* @__PURE__ */ s.jsx(N0, { children: /* @__PURE__ */ s.jsx(Ae, { href: a, children: /* @__PURE__ */ s.jsx(E1, { variant: "Link/Medium/Bold", showArrow: !0, children: /* @__PURE__ */ s.jsx(Ge, { id: n }) }) }) })
  ] });
}, q0 = ({ description: e, icon: t, title: n }) => /* @__PURE__ */ s.jsx(
  "div",
  {
    className: O(
      "absolute top-1/2 left-1/2 hidden w-[28rem] -translate-x-1/2 -translate-y-1/2 rounded-3xl bg-white",
      "transition-all duration-150 ease-in-out",
      "scale-75 opacity-0 shadow-none",
      "xl:block",
      "xl:group-hover-or-focus:z-10 xl:group-hover-or-focus:scale-100 xl:group-hover-or-focus:opacity-100 xl:group-hover-or-focus:shadow-[0px_4px_140px_0px_rgba(66,_83,_153,_0.15)]",
      "3xl:w-[39rem]"
    ),
    children: /* @__PURE__ */ s.jsxs("div", { className: "flex h-full items-center justify-between gap-4 p-6", children: [
      /* @__PURE__ */ s.jsx("div", { className: "size-32 min-w-32 text-accent-primary [&>*]:size-full [&>*]:min-w-full", children: t }),
      /* @__PURE__ */ s.jsxs("div", { className: "flex flex-1 flex-col gap-2", children: [
        /* @__PURE__ */ s.jsx("h4", { className: "text-heading-h4", children: n }),
        /* @__PURE__ */ s.jsx("span", { className: "text-paragraph-small text-foreground-secondary", children: e })
      ] }),
      /* @__PURE__ */ s.jsx(gs, { className: "size-8 min-w-8 text-accent-primary" })
    ] })
  }
), m3 = ({ title: e, description: t, href: n, icon: o, className: r }) => /* @__PURE__ */ s.jsxs(Ae, { href: n, className: "group relative", children: [
  /* @__PURE__ */ s.jsx(q0, { description: t, icon: o, title: e }),
  /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: O(
        "flex min-h-12 items-center gap-2 pr-4 text-accent-primary transition-colors hover:text-accent-secondary",
        r
      ),
      children: [
        /* @__PURE__ */ s.jsx("div", { className: "flex size-12 min-w-12 items-center justify-center", children: o }),
        /* @__PURE__ */ s.jsx("span", { className: "flex-1 text-paragraph-big leading-[120%] font-bold tracking-[0.75px]", children: e }),
        /* @__PURE__ */ s.jsx(gs, { className: "size-4 min-w-4" })
      ]
    }
  )
] }), wl = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "105", height: "32", viewBox: "0 0 140 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0)", children: [
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M6.16 6.5759C7.224 6.0239 8.432 5.7439 9.768 5.7439C11.304 5.7439 12.696 6.1199 13.968 6.8799C15.232 7.6399 16.232 8.6959 16.952 10.0559C17.672 11.4159 18.032 12.9839 18.032 14.7519C18.032 16.5199 17.672 18.0959 16.952 19.4959C16.224 20.8879 15.232 21.9759 13.968 22.7519C12.696 23.5279 11.304 23.9199 9.768 23.9199C8.424 23.9199 7.232 23.6479 6.192 23.1039C5.152 22.5599 4.296 21.8879 3.64 21.0799V31.9999H0V6.0319H3.64V8.6239C4.256 7.8159 5.096 7.1279 6.16 6.5759ZM13.592 11.6079C13.096 10.7279 12.432 10.0559 11.608 9.5919C10.792 9.1359 9.912 8.9039 8.976 8.9039C8.056 8.9039 7.192 9.1359 6.368 9.6079C5.552 10.0719 4.888 10.7599 4.384 11.6479C3.888 12.5439 3.632 13.5999 3.632 14.8079C3.632 16.0159 3.888 17.0799 4.384 17.9839C4.888 18.8879 5.544 19.5759 6.368 20.0479C7.184 20.5119 8.056 20.7519 8.976 20.7519C9.912 20.7519 10.792 20.5119 11.608 20.0319C12.432 19.5519 13.088 18.8559 13.592 17.9359C14.096 17.0239 14.344 15.9519 14.344 14.7439C14.336 13.5439 14.088 12.4959 13.592 11.6079Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M22.376 10.064C23.112 8.69595 24.112 7.63995 25.376 6.88795C26.64 6.12795 28.04 5.75195 29.576 5.75195C30.96 5.75195 32.168 6.02395 33.2 6.56795C34.232 7.11195 35.056 7.78395 35.68 8.59195V6.03195H39.352V23.632H35.68V21.016C35.064 21.848 34.216 22.536 33.16 23.096C32.096 23.648 30.88 23.928 29.52 23.928C28.008 23.928 26.624 23.536 25.368 22.76C24.112 21.984 23.112 20.896 22.384 19.504C21.648 18.112 21.28 16.528 21.28 14.76C21.28 12.992 21.64 11.424 22.376 10.064ZM34.92 11.656C34.416 10.76 33.76 10.08 32.952 9.61595C32.144 9.14395 31.272 8.91195 30.336 8.91195C29.4 8.91195 28.528 9.14395 27.72 9.59995C26.912 10.064 26.256 10.728 25.752 11.616C25.256 12.496 25 13.544 25 14.76C25 15.976 25.256 17.04 25.752 17.952C26.256 18.864 26.912 19.56 27.736 20.048C28.552 20.528 29.424 20.768 30.336 20.768C31.272 20.768 32.144 20.536 32.952 20.064C33.76 19.6 34.416 18.904 34.92 18C35.416 17.096 35.672 16.032 35.672 14.824C35.672 13.608 35.424 12.552 34.92 11.656Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M47.3599 23.1681C46.2719 22.6641 45.4079 21.9841 44.7679 21.1201C44.1279 20.2561 43.7919 19.2961 43.7439 18.2321H47.5119C47.5759 19.0401 47.9359 19.7121 48.5839 20.2401C49.2319 20.7761 50.0479 21.0401 51.0239 21.0401C52.0479 21.0401 52.8399 20.8321 53.3999 20.4161C53.9679 20.0001 54.2479 19.4401 54.2479 18.7361C54.2479 18.0961 53.9279 17.6081 53.2879 17.2641C52.6479 16.9201 51.6559 16.5841 50.3199 16.2401C49.0239 15.8801 47.9599 15.5361 47.1439 15.2001C46.3199 14.8721 45.6159 14.3601 45.0159 13.6641C44.4239 12.9761 44.1199 12.0721 44.1199 10.9681C44.1199 10.0081 44.3839 9.12808 44.9199 8.33608C45.4479 7.53608 46.2239 6.90408 47.2319 6.44008C48.2399 5.97608 49.4319 5.73608 50.7919 5.73608C52.7919 5.73608 54.4079 6.24008 55.6319 7.24808C56.8559 8.26408 57.5119 9.64008 57.5999 11.3841H53.9599C53.8959 10.5281 53.5759 9.85608 52.9999 9.35208C52.4239 8.85608 51.6479 8.60008 50.6719 8.60008C49.7119 8.60008 48.9759 8.79208 48.4719 9.19208C47.9599 9.58408 47.7039 10.1121 47.7039 10.7761C47.7039 11.2481 47.8719 11.6401 48.2159 11.9601C48.5599 12.2801 48.9839 12.5281 49.4959 12.7121C50.0079 12.8881 50.7279 13.1121 51.6639 13.3681C52.9439 13.7121 53.9839 14.0481 54.7919 14.3921C55.5999 14.7361 56.2879 15.2481 56.8639 15.9441C57.4399 16.6321 57.7279 17.5361 57.7279 18.6401C57.7279 19.6401 57.4639 20.5361 56.9279 21.3361C56.3919 22.1361 55.6239 22.7601 54.6159 23.2241C53.6079 23.6801 52.4079 23.9121 51.0239 23.9121C49.6719 23.9201 48.4479 23.6721 47.3599 23.1681Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M64.968 23.1681C63.88 22.6641 63.0161 21.9841 62.3761 21.1201C61.736 20.2561 61.4001 19.2961 61.3521 18.2321H65.1201C65.1841 19.0401 65.544 19.7121 66.192 20.2401C66.84 20.7761 67.6561 21.0401 68.6321 21.0401C69.6561 21.0401 70.4481 20.8321 71.0081 20.4161C71.5761 20.0001 71.8561 19.4401 71.8561 18.7361C71.8561 18.0961 71.5361 17.6081 70.8961 17.2641C70.2561 16.9201 69.2641 16.5841 67.9281 16.2401C66.6321 15.8801 65.5681 15.5361 64.7521 15.2001C63.9281 14.8721 63.224 14.3601 62.624 13.6641C62.032 12.9761 61.7281 12.0721 61.7281 10.9681C61.7281 10.0081 61.9921 9.12808 62.5281 8.33608C63.0561 7.53608 63.8321 6.90408 64.8401 6.44008C65.8481 5.97608 67.0401 5.73608 68.4001 5.73608C70.4001 5.73608 72.0161 6.24008 73.2401 7.24808C74.4641 8.26408 75.1201 9.64008 75.2081 11.3841H71.5681C71.5041 10.5281 71.1841 9.85608 70.6081 9.35208C70.0321 8.85608 69.2561 8.60008 68.28 8.60008C67.32 8.60008 66.584 8.79208 66.08 9.19208C65.568 9.58408 65.312 10.1121 65.312 10.7761C65.312 11.2481 65.48 11.6401 65.824 11.9601C66.168 12.2801 66.592 12.5281 67.104 12.7121C67.616 12.8881 68.336 13.1121 69.272 13.3681C70.552 13.7121 71.5921 14.0481 72.4001 14.3921C73.2081 14.7361 73.896 15.2481 74.472 15.9441C75.048 16.6321 75.3361 17.5361 75.3361 18.6401C75.3361 19.6401 75.0721 20.5361 74.5361 21.3361C74.0001 22.1361 73.2321 22.7601 72.2241 23.2241C71.2161 23.6881 70.0161 23.9121 68.6321 23.9121C67.2801 23.9201 66.056 23.6721 64.968 23.1681Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M103.376 6.03198L97.912 23.632H94.08L90.536 10.632L86.992 23.632H83.16L77.672 6.03198H81.376L85.048 20.184L88.784 6.03198H92.584L96.16 20.12L99.8 6.03198H103.376Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M106.328 10.064C107.064 8.696 108.064 7.64 109.328 6.888C110.592 6.128 112.008 5.752 113.56 5.752C114.712 5.752 115.84 6 116.96 6.504C118.08 7.008 118.968 7.672 119.632 8.504V0H123.304V23.632H119.632V20.984C119.032 21.84 118.208 22.536 117.152 23.088C116.096 23.64 114.888 23.92 113.528 23.92C111.992 23.92 110.592 23.528 109.328 22.752C108.056 21.976 107.056 20.888 106.328 19.496C105.592 18.104 105.224 16.52 105.224 14.752C105.224 12.984 105.592 11.424 106.328 10.064ZM118.88 11.656C118.376 10.76 117.72 10.08 116.912 9.616C116.104 9.144 115.232 8.912 114.296 8.912C113.36 8.912 112.488 9.144 111.68 9.6C110.872 10.064 110.216 10.728 109.712 11.616C109.216 12.496 108.96 13.544 108.96 14.76C108.96 15.976 109.216 17.04 109.712 17.952C110.216 18.864 110.872 19.56 111.696 20.048C112.512 20.528 113.384 20.768 114.296 20.768C115.232 20.768 116.104 20.536 116.912 20.064C117.72 19.6 118.376 18.904 118.88 18C119.376 17.096 119.632 16.032 119.632 14.824C119.632 13.608 119.376 12.552 118.88 11.656Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M139.272 5.32C139.272 2.384 136.888 0 133.952 0C131.016 0 128.632 2.384 128.632 5.32C128.632 7.288 129.712 8.984 131.296 9.904V15.736C131.296 17.208 132.488 18.4 133.96 18.4C135.432 18.4 136.624 17.208 136.624 15.736V9.904C138.192 8.984 139.272 7.288 139.272 5.32Z",
        fill: "#0000FF"
      }
    )
  ] }),
  /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0", children: /* @__PURE__ */ s.jsx("rect", { width: "139.272", height: "32", fill: "white" }) }) })
] }), Oe = {
  eur: {
    label: "Euro",
    identifier: "EUR",
    icon: /* @__PURE__ */ s.jsx(Cc, { className: "text-accent-primary size-[18px]" })
  },
  usd: {
    label: "U.S. Dollar",
    identifier: "USD",
    icon: /* @__PURE__ */ s.jsx(vc, { className: "text-accent-primary size-[18px]" })
  }
}, J0 = Object.keys(Oe).map((e) => ({
  code: e
})), Q0 = ({
  currencies: e = J0,
  currentCurrency: t,
  onCurrencyChange: n,
  triggerClassName: o = "w-full",
  "aria-label": r
}) => /* @__PURE__ */ s.jsxs(hl, { value: t, onValueChange: n, children: [
  /* @__PURE__ */ s.jsx(gl, { className: o, "aria-label": r, children: /* @__PURE__ */ s.jsxs("span", { className: "flex items-center gap-2", children: [
    Oe[t].icon,
    /* @__PURE__ */ s.jsx("span", { children: Oe[t].identifier })
  ] }) }),
  /* @__PURE__ */ s.jsx(vl, { position: "popper", sideOffset: 4, children: e.map((a) => /* @__PURE__ */ s.jsxs(
    xl,
    {
      value: a.code,
      textValue: `${Oe[a.code].identifier} ${Oe[a.code].label}`,
      children: [
        Oe[a.code].icon,
        " ",
        Oe[a.code].identifier,
        " (",
        Oe[a.code].label,
        ")"
      ]
    },
    a.code
  )) })
] }), e4 = ({
  code: e = "NL",
  size: t = "l",
  gradient: n = "",
  hasBorder: o = !0,
  hasDropShadow: r = !1,
  hasBorderRadius: a = !0,
  className: i
}) => /* @__PURE__ */ s.jsx(
  "div",
  {
    className: `flag ${n} size-${t} ${o ? "border" : ""} ${r ? "drop-shadow" : ""} ${a ? "border-radius" : ""} ${i ? i.replace(/\s\s+/g, " ").trim() : ""}`,
    children: /* @__PURE__ */ s.jsx("img", { src: `/flags/${t}/${e}.svg` })
  }
), us = e4, yl = ({
  languages: e,
  currentLanguage: t,
  onLanguageChange: n,
  currencies: o,
  currentCurrency: r,
  onCurrencyChange: a,
  hideLanguage: i
}) => {
  const l = e.find((c) => c.code === t);
  return /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-2 2xl:gap-4", children: [
    !i && /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ s.jsx("label", { className: "text-paragraph-extrasmall text-foreground-secondary px-4", children: /* @__PURE__ */ s.jsx(Ge, { id: "navbar.languageAndCurrencySwitcher.language.title" }) }),
      /* @__PURE__ */ s.jsxs(hl, { value: t, onValueChange: n, children: [
        /* @__PURE__ */ s.jsx(gl, { className: "w-full", children: /* @__PURE__ */ s.jsxs("span", { className: "flex items-center gap-2", children: [
          (l == null ? void 0 : l.flagCode) && /* @__PURE__ */ s.jsx(us, { code: l.flagCode, size: "s", hasBorder: !1 }),
          /* @__PURE__ */ s.jsx("span", { children: l == null ? void 0 : l.label })
        ] }) }),
        /* @__PURE__ */ s.jsx(vl, { position: "popper", sideOffset: 4, children: e.map((c) => /* @__PURE__ */ s.jsxs(xl, { value: c.code, textValue: c.label, children: [
          c.flagCode && /* @__PURE__ */ s.jsx(us, { code: c.flagCode, size: "s", hasBorder: !1 }),
          c.label
        ] }, c.code)) })
      ] })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ s.jsx("label", { className: "text-paragraph-extrasmall text-foreground-secondary px-4", children: /* @__PURE__ */ s.jsx(Ge, { id: "navbar.languageAndCurrencySwitcher.currency.title" }) }),
      /* @__PURE__ */ s.jsx(
        Q0,
        {
          currencies: o,
          currentCurrency: r,
          onCurrencyChange: a
        }
      )
    ] })
  ] });
}, t4 = (e) => {
  const { currentCurrency: t } = e, { formatMessage: n } = Pt();
  return /* @__PURE__ */ s.jsxs(fl, { children: [
    /* @__PURE__ */ s.jsx(pl, { asChild: !0, children: /* @__PURE__ */ s.jsxs(
      "button",
      {
        className: O(
          "text-foreground-primary text-md data-[state=open]:text-accent-secondary group flex w-full cursor-pointer items-center gap-2 rounded-md px-3 py-2 font-medium",
          "hover:text-accent-secondary transition-colors"
        ),
        "aria-label": n({ id: "navbar.languageAndCurrencySwitcher.description" }),
        children: [
          /* @__PURE__ */ s.jsx(vs, { className: "size-5" }),
          Oe[t].identifier,
          /* @__PURE__ */ s.jsx(tt, { className: "relative ml-1 hidden size-4 transition duration-300 group-data-[state=open]:block" })
        ]
      }
    ) }),
    /* @__PURE__ */ s.jsx(
      ml,
      {
        className: O(
          "overflow-hidden duration-200 ease-in-out",
          "data-[state=open]:animate-collapsible-down",
          "data-[state=closed]:animate-collapsible-up"
        ),
        children: /* @__PURE__ */ s.jsx("div", { className: "pb-4 pt-1", children: /* @__PURE__ */ s.jsx(yl, { ...e }) })
      }
    )
  ] });
}, n4 = (e) => {
  const { currentCurrency: t } = e, n = hs("2xl"), [o, r] = $t(!1), { formatMessage: a } = Pt();
  return Sn(() => {
    n && r(!1);
  }, [n]), /* @__PURE__ */ s.jsxs(D0, { modal: !1, open: o, onOpenChange: r, children: [
    /* @__PURE__ */ s.jsx(F0, { asChild: !0, children: /* @__PURE__ */ s.jsxs(
      "button",
      {
        className: O(
          "text-foreground-primary hover:text-accent-secondary group flex cursor-pointer items-center gap-1 transition-colors",
          "data-[state=open]:text-accent-secondary"
        ),
        "aria-label": a({ id: "navbar.languageAndCurrencySwitcher.description" }),
        children: [
          /* @__PURE__ */ s.jsx(vs, { stroke: 1.5, className: "size-6" }),
          /* @__PURE__ */ s.jsx("span", { className: "text-button-big", children: Oe[t].identifier }),
          /* @__PURE__ */ s.jsx(
            tt,
            {
              stroke: 1.5,
              className: "ml-1 size-6 transition-transform group-data-[state=open]:rotate-180"
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ s.jsx(
      V0,
      {
        className: "navbar-popover-card w-[267px] border-none p-4",
        align: "end",
        sideOffset: 34,
        alignOffset: -15,
        children: /* @__PURE__ */ s.jsx(yl, { ...e })
      }
    )
  ] });
}, o4 = ({ content: e }) => /* @__PURE__ */ s.jsx(O0, { children: /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-2 p-4", children: [
  /* @__PURE__ */ s.jsx("div", { className: "flex justify-between", children: e.groups.map((t) => /* @__PURE__ */ s.jsxs("div", { children: [
    /* @__PURE__ */ s.jsx("p", { className: "text-paragraph-extrasmall text-foreground-secondary p-4 pb-2", children: t.label }),
    /* @__PURE__ */ s.jsx("ul", { children: t.items.map((n) => /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(No, { asChild: !0, className: "group w-[235px] whitespace-normal", children: /* @__PURE__ */ s.jsxs(
      Ae,
      {
        href: n.href,
        scope: n.scope,
        className: "flex flex-row items-center gap-2",
        children: [
          n.label,
          /* @__PURE__ */ s.jsx("span", { className: "opacity-0 transition-opacity group-hover:opacity-100", children: "→" })
        ]
      }
    ) }) }, n.label)) })
  ] }, t.label)) }),
  e.seeAll && /* @__PURE__ */ s.jsx(s.Fragment, { children: /* @__PURE__ */ s.jsx(No, { asChild: !0, className: "w-full text-center", children: /* @__PURE__ */ s.jsx(Ae, { href: e.seeAll.href, scope: e.seeAll.scope, children: e.seeAll.label }) }) })
] }) }), r4 = ({ items: e }) => /* @__PURE__ */ s.jsx(_0, { children: /* @__PURE__ */ s.jsx(k0, { children: /* @__PURE__ */ s.jsx("ul", { className: "flex flex-col xl:flex-row", children: e.map((t) => /* @__PURE__ */ s.jsx(A0, { children: t.subMenu ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
  /* @__PURE__ */ s.jsx(I0, { className: "px-5 py-1 text-button-big transition-all", children: t.label }),
  /* @__PURE__ */ s.jsx(o4, { content: t.subMenu })
] }) : /* @__PURE__ */ s.jsx(No, { asChild: !0, className: "px-5 py-1 text-button-big transition-all", children: /* @__PURE__ */ s.jsx(Ae, { href: t.href, scope: t.scope, children: t.label }) }) }, t.label)) }) }) }), se = {
  microsite: {
    home: "/",
    faq: "/faq",
    pricing: "/#pricing",
    solutions: {
      home: "/solutions",
      byIndustry: {
        nonProfits: "/password-manager-for-non-profit",
        startups: "/password-manager-for-startups",
        agencies: "/password-manager-for-agency",
        techTeams: "/password-manager-for-tech-teams",
        saasTeams: "/password-manager-for-saas-teams",
        legal: "/password-manager-for-legal",
        education: "/password-manager-for-education"
      },
      switchFrom: {
        onePassword: "/passwd-vs-1password",
        lastPass: "/passwd-vs-lastpass",
        nordPass: "/passwd-vs-nordpass",
        bitwarden: "/passwd-vs-bitwarden",
        keeper: "/passwd-vs-keeper",
        drivePassword: "/passwd-vs-drivepassword",
        roboForm: "/passwd-vs-roboform"
      }
    },
    resources: {
      home: "/resources",
      browserExtension: "/resources/browser-extension",
      iosApp: "/resources/ios-app",
      androidApp: "/resources/android-app"
    }
  },
  docs: {
    home: "/docs"
  },
  app: {
    home: "https://app.passwd.team"
  }
}, s4 = () => {
  const { formatMessage: e } = Pt();
  return Yl(
    () => [
      {
        label: e({ id: "navbar.items.solutions.text" }),
        subMenu: {
          groups: [
            {
              label: e({
                id: "navbar.solutions.industries.title"
              }),
              items: [
                {
                  label: e({
                    id: "navbar.solutions.industries.agencies"
                  }),
                  href: se.microsite.solutions.byIndustry.agencies,
                  scope: ie.Microsite
                },
                {
                  label: e({
                    id: "navbar.solutions.industries.nonProfits"
                  }),
                  href: se.microsite.solutions.byIndustry.nonProfits,
                  scope: ie.Microsite
                },
                {
                  label: e({
                    id: "navbar.solutions.industries.startups"
                  }),
                  href: se.microsite.solutions.byIndustry.startups,
                  scope: ie.Microsite
                },
                {
                  label: e({
                    id: "navbar.solutions.industries.techTeams"
                  }),
                  href: se.microsite.solutions.byIndustry.techTeams,
                  scope: ie.Microsite
                },
                {
                  label: e({
                    id: "navbar.solutions.industries.education"
                  }),
                  href: se.microsite.solutions.byIndustry.education,
                  scope: ie.Microsite
                },
                {
                  label: e({
                    id: "navbar.solutions.industries.legal"
                  }),
                  href: se.microsite.solutions.byIndustry.legal,
                  scope: ie.Microsite
                },
                {
                  label: e({
                    id: "navbar.solutions.industries.saasTeams"
                  }),
                  href: se.microsite.solutions.byIndustry.saasTeams,
                  scope: ie.Microsite
                }
              ]
            },
            {
              label: e({ id: "navbar.solutions.switchFrom.title" }),
              items: [
                {
                  label: "1Password",
                  href: se.microsite.solutions.switchFrom.onePassword,
                  scope: ie.Microsite
                },
                {
                  label: "Lastpass",
                  href: se.microsite.solutions.switchFrom.lastPass,
                  scope: ie.Microsite
                },
                {
                  label: "Nordpass",
                  href: se.microsite.solutions.switchFrom.nordPass,
                  scope: ie.Microsite
                },
                {
                  label: "Bitwarden",
                  href: se.microsite.solutions.switchFrom.bitwarden,
                  scope: ie.Microsite
                },
                {
                  label: "Keeper",
                  href: se.microsite.solutions.switchFrom.keeper,
                  scope: ie.Microsite
                },
                {
                  label: "Drive password",
                  href: se.microsite.solutions.switchFrom.drivePassword,
                  scope: ie.Microsite
                },
                {
                  label: "RoboForm",
                  href: se.microsite.solutions.switchFrom.roboForm,
                  scope: ie.Microsite
                }
              ]
            }
          ],
          seeAll: {
            label: e({
              id: "navbar.solutions.seeAll"
            }),
            href: se.microsite.solutions.home,
            scope: ie.Microsite
          }
        }
      },
      {
        label: e({ id: "navbar.items.resources.text" }),
        subMenu: {
          groups: [
            {
              label: e({ id: "navbar.resources.title" }),
              items: [
                {
                  label: e({ id: "navbar.resources.browserExtension" }),
                  href: se.microsite.resources.browserExtension,
                  scope: ie.Microsite
                },
                {
                  label: e({ id: "navbar.resources.iosApp" }),
                  href: se.microsite.resources.iosApp,
                  scope: ie.Microsite
                },
                {
                  label: e({ id: "navbar.resources.androidApp" }),
                  href: se.microsite.resources.androidApp,
                  scope: ie.Microsite
                }
              ]
            }
          ],
          seeAll: {
            label: e({ id: "navbar.resources.seeAll" }),
            href: se.microsite.resources.home,
            scope: ie.Microsite
          }
        }
      },
      {
        label: e({ id: "navbar.items.faq.text" }),
        href: se.microsite.faq,
        scope: ie.Microsite
      },
      {
        label: e({ id: "navbar.items.docs.text" }),
        href: se.docs.home,
        scope: ie.Docs
      },
      {
        label: e({ id: "navbar.items.pricing.text" }),
        href: se.microsite.pricing,
        scope: ie.Microsite
      }
    ],
    [e]
  );
}, Sl = ({ additionalActions: e }) => /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col items-center gap-2 2xl:flex-row 2xl:gap-4", children: [
  /* @__PURE__ */ s.jsx(ls, { variant: "secondary", className: "h-10 min-h-10 w-full bg-transparent 2xl:w-fit", asChild: !0, children: /* @__PURE__ */ s.jsxs(Ae, { scope: ie.App, href: se.app.home, children: [
    /* @__PURE__ */ s.jsx(Ac, { stroke: 1.5, className: "size-6" }),
    /* @__PURE__ */ s.jsx(Ge, { id: "navbar.login" })
  ] }) }),
  /* @__PURE__ */ s.jsx(ls, { className: "h-10 min-h-10 w-full 2xl:w-fit", asChild: !0, children: /* @__PURE__ */ s.jsx(Ae, { scope: ie.Microsite, href: se.microsite.pricing, children: /* @__PURE__ */ s.jsx(Ge, { id: "navbar.tryButton" }) }) }),
  e && e.map((t, n) => /* @__PURE__ */ s.jsx("div", { className: "flex min-h-10 items-center", children: t }, n))
] }), a4 = ({ content: e }) => /* @__PURE__ */ s.jsxs(X0, { children: [
  e.seeAll && /* @__PURE__ */ s.jsx(ds, { children: /* @__PURE__ */ s.jsx(yn, { className: "text-button-small", buttonType: "sub-menu", asChild: !0, children: /* @__PURE__ */ s.jsx(Ae, { href: e.seeAll.href, scope: e.seeAll.scope, children: e.seeAll.label }) }) }),
  e.groups.map((t) => /* @__PURE__ */ s.jsxs("div", { children: [
    /* @__PURE__ */ s.jsx("p", { className: "text-paragraph-extrasmall text-foreground-secondary py-2", children: t.label }),
    t.items.map((n) => /* @__PURE__ */ s.jsx(ds, { children: /* @__PURE__ */ s.jsx(yn, { className: "text-button-small", buttonType: "sub-menu", asChild: !0, children: /* @__PURE__ */ s.jsx(Ae, { href: n.href, scope: n.scope, children: n.label }) }) }, n.label))
  ] }, t.label))
] }), i4 = ({ items: e, navbarActions: t, languageAndCurrency: n }) => {
  const { formatMessage: o } = Pt(), r = hs("2xl"), [a, i] = $t(!1);
  return Sn(() => {
    r || i(!1);
  }, [r]), /* @__PURE__ */ s.jsxs(B0, { open: a, onOpenChange: i, children: [
    /* @__PURE__ */ s.jsx("div", { className: "flex w-full items-center justify-end 2xl:hidden", children: /* @__PURE__ */ s.jsx(
      z0,
      {
        className: "cursor-pointer",
        title: o({ id: "navbar.open" }),
        onClick: () => i(!0),
        children: /* @__PURE__ */ s.jsx(jc, { className: "block size-6" })
      }
    ) }),
    /* @__PURE__ */ s.jsxs(G0, { side: "right", className: "rounded-l-4xl w-4/5 border-none px-4", children: [
      /* @__PURE__ */ s.jsxs(Z0, { className: "pl-0 pt-8 active:outline-0", children: [
        /* @__PURE__ */ s.jsx(K0, { className: "sr-only", children: /* @__PURE__ */ s.jsx(Ge, { id: "navbar.menu" }) }),
        /* @__PURE__ */ s.jsx(Ae, { href: se.microsite.home, className: "w-fit", children: /* @__PURE__ */ s.jsx(wl, { className: "h-6 w-[121px]" }) })
      ] }),
      /* @__PURE__ */ s.jsx(Y0, { children: e.map(
        (l) => l.subMenu ? /* @__PURE__ */ s.jsx(fl, { className: "group/collapsible", children: /* @__PURE__ */ s.jsxs(cs, { children: [
          /* @__PURE__ */ s.jsx(pl, { asChild: !0, children: /* @__PURE__ */ s.jsx(yn, { children: l.label }) }),
          /* @__PURE__ */ s.jsx(
            ml,
            {
              className: O(
                "overflow-hidden duration-200 ease-in-out",
                "data-[state=open]:animate-collapsible-down",
                "data-[state=closed]:animate-collapsible-up"
              ),
              children: /* @__PURE__ */ s.jsx(a4, { content: l.subMenu })
            }
          )
        ] }) }, l.label) : /* @__PURE__ */ s.jsx(cs, { children: /* @__PURE__ */ s.jsx(yn, { asChild: !0, children: /* @__PURE__ */ s.jsx(Ae, { href: l.href, scope: l.scope, onClick: () => i(!1), children: l.label }) }) }, l.label)
      ) }),
      /* @__PURE__ */ s.jsxs(U0, { children: [
        n && /* @__PURE__ */ s.jsx(t4, { ...n }),
        /* @__PURE__ */ s.jsx(Sl, { additionalActions: t })
      ] })
    ] })
  ] });
}, l4 = "shadow-[0px_16px_50px_0px_rgba(0,0,255,0.07)]", h3 = ({
  navbarActions: e,
  forceBackground: t,
  LinkComponent: n = "a",
  scope: o,
  languageAndCurrency: r
}) => {
  const a = rc(), { formatMessage: i } = Pt(), l = s4();
  return /* @__PURE__ */ s.jsx($c, { LinkComponent: n, scope: o, children: /* @__PURE__ */ s.jsx("div", { className: "sticky left-0 top-0 z-10 flex min-w-full items-center justify-center pt-4 2xl:pt-6", children: /* @__PURE__ */ s.jsxs(
    "nav",
    {
      className: O(
        "3xl:w-[calc(100%-160px)] flex w-[calc(100%-32px)] max-w-[1520px] items-center gap-6 rounded-full bg-white px-4 py-4 transition-all duration-300 2xl:pl-9",
        l4,
        !a && !t && "2xl:bg-transparent 2xl:shadow-none"
      ),
      children: [
        /* @__PURE__ */ s.jsx(n, { href: se.microsite.home, title: i({ id: "navbar.home" }), children: /* @__PURE__ */ s.jsx(wl, { className: "block h-6 pl-2.5 2xl:h-8 2xl:pl-0" }) }),
        /* @__PURE__ */ s.jsxs("div", { className: "hidden 2xl:contents", children: [
          /* @__PURE__ */ s.jsx(r4, { items: l }),
          /* @__PURE__ */ s.jsx("div", { className: "flex-1" }),
          /* @__PURE__ */ s.jsx(Sl, { additionalActions: e }),
          r && /* @__PURE__ */ s.jsx(n4, { ...r })
        ] }),
        /* @__PURE__ */ s.jsx(
          i4,
          {
            items: l,
            navbarActions: e,
            languageAndCurrency: r
          }
        )
      ]
    }
  ) }) });
};
export {
  U4 as Accordion,
  X4 as AccordionContent,
  K4 as AccordionItem,
  Y4 as AccordionTrigger,
  W4 as Badge,
  ls as Button,
  E0 as Card,
  q4 as CardAction,
  J4 as CardContent,
  P0 as CardDescription,
  N0 as CardFooter,
  M0 as CardHeader,
  R0 as CardHeaderImage,
  j0 as CardTitle,
  fl as Collapsible,
  ml as CollapsibleContent,
  pl as CollapsibleTrigger,
  Q0 as CurrencySelect,
  p3 as CustomerStoryCard,
  f4 as IconAlertTriangle,
  gs as IconArrowRight,
  p4 as IconBan,
  M4 as IconBrandApple,
  j4 as IconBrandCloudflare,
  P4 as IconBrandDropbox,
  N4 as IconBrandFigma,
  _4 as IconBrandGithub,
  k4 as IconBrandGoogle,
  A4 as IconBrandJira,
  T4 as IconBrandMastercard,
  I4 as IconBrandMicrosoft,
  O4 as IconBrandNetflix,
  L4 as IconBrandNotion,
  D4 as IconBrandPaypal,
  F4 as IconBrandSlack,
  V4 as IconBrandSpotify,
  dc as IconCheck,
  tt as IconChevronDown,
  pc as IconChevronUp,
  m4 as IconCircleCheck,
  h4 as IconCopy,
  vc as IconCurrencyDollar,
  Cc as IconCurrencyEuro,
  v4 as IconEye,
  g4 as IconEyeOff,
  x4 as IconFileTypePdf,
  C4 as IconGauge,
  R4 as IconInfoCircleFilled,
  b4 as IconLetterCase,
  w4 as IconLock,
  H4 as IconMediaAp,
  $4 as IconMediaBusinessInsider,
  B4 as IconMediaTechradar,
  jc as IconMenuDeep,
  y4 as IconPassword,
  z4 as IconRecordApi,
  S4 as IconRefresh,
  E4 as IconShieldSearch,
  Ac as IconUser,
  vs as IconWorld,
  Oc as IconX,
  t4 as LanguageAndCurrencyCollapsible,
  yl as LanguageAndCurrencyFields,
  n4 as LanguageAndCurrencyPopover,
  E1 as Link,
  Ae as LinkByScope,
  m3 as LinkCard,
  $c as LinkContextProvider,
  ie as LinkScope,
  r4 as Menu,
  h3 as Navbar,
  _0 as NavigationMenu,
  O0 as NavigationMenuContent,
  Q4 as NavigationMenuIndicator,
  A0 as NavigationMenuItem,
  No as NavigationMenuLink,
  k0 as NavigationMenuList,
  I0 as NavigationMenuTrigger,
  L0 as NavigationMenuViewport,
  wl as PasswdLogo,
  D0 as Popover,
  e3 as PopoverAnchor,
  V0 as PopoverContent,
  o3 as PopoverDescription,
  t3 as PopoverHeader,
  n3 as PopoverTitle,
  F0 as PopoverTrigger,
  hl as Select,
  vl as SelectContent,
  r3 as SelectGroup,
  xl as SelectItem,
  a3 as SelectLabel,
  $0 as SelectScrollDownButton,
  H0 as SelectScrollUpButton,
  i3 as SelectSeparator,
  gl as SelectTrigger,
  s3 as SelectValue,
  B0 as Sheet,
  l3 as SheetClose,
  G0 as SheetContent,
  c3 as SheetDescription,
  U0 as SheetFooter,
  Z0 as SheetHeader,
  K0 as SheetTitle,
  z0 as SheetTrigger,
  Y0 as SidebarMenu,
  yn as SidebarMenuButton,
  cs as SidebarMenuItem,
  X0 as SidebarMenuSub,
  ds as SidebarMenuSubItem,
  d3 as Toggle,
  u3 as ToggleGroup,
  f3 as ToggleGroupItem,
  As as Typography,
  S0 as buttonVariants,
  O as cn,
  T0 as navigationMenuTriggerStyle,
  Cl as toggleVariants,
  hs as useBreakpoint,
  rc as useIsScrolled,
  Hc as useLinkContext
};
